export const apercuBold = {
  glyphs: {
    '0': {
      ha: 856,
      x_min: 69,
      x_max: 786,
      o:
        'm 428 -11 q 163 120 256 -11 q 69 486 69 251 q 163 852 69 721 q 428 983 256 983 q 693 852 600 983 q 786 486 786 721 q 693 120 786 251 q 428 -11 600 -11 m 428 150 q 614 486 614 150 q 428 822 614 822 q 242 486 242 822 q 428 150 242 150 z ',
    },
    '1': {
      ha: 536,
      x_min: 64,
      x_max: 425,
      o:
        'm 250 728 l 64 617 l 64 806 l 349 972 l 425 972 l 425 0 l 250 0 l 250 728 z ',
    },
    '2': {
      ha: 711,
      x_min: 36,
      x_max: 654,
      o:
        'm 36 69 l 383 518 q 442 611 425 571 q 458 694 458 651 q 428 788 458 754 q 339 822 397 822 q 253 789 286 822 q 213 694 221 756 l 51 725 q 94 857 56 799 q 199 949 133 915 q 343 983 264 983 q 556 906 479 983 q 633 701 633 828 q 550 471 633 581 l 313 161 l 654 161 l 654 0 l 36 0 l 36 69 z ',
    },
    '3': {
      ha: 771,
      x_min: 58,
      x_max: 713,
      o:
        'm 383 -11 q 224 25 294 -11 q 110 125 153 61 q 58 269 67 189 l 226 292 q 383 150 261 150 q 494 194 451 150 q 538 313 538 239 q 495 439 538 394 q 385 483 453 483 q 300 463 340 483 l 231 560 l 414 811 l 104 811 l 104 972 l 661 972 l 661 911 l 432 601 q 471 604 457 604 q 647 524 582 604 q 713 315 713 444 q 669 142 713 217 q 552 28 626 68 q 383 -11 478 -11 z ',
    },
    '4': {
      ha: 794,
      x_min: 57,
      x_max: 758,
      o:
        'm 475 181 l 57 181 l 57 269 l 467 972 l 650 972 l 650 342 l 758 342 l 758 181 l 650 181 l 650 0 l 475 0 l 475 181 m 475 342 l 475 713 l 269 342 l 475 342 z ',
    },
    '5': {
      ha: 732,
      x_min: 57,
      x_max: 688,
      o:
        'm 368 -11 q 218 22 286 -11 q 108 115 150 54 q 57 254 65 175 l 222 285 q 368 150 249 150 q 476 194 439 150 q 513 322 513 239 q 473 447 513 404 q 360 490 433 490 q 268 467 313 490 q 188 403 224 443 l 78 425 l 132 972 l 632 972 l 632 811 l 275 811 l 253 608 q 390 644 314 644 q 613 558 538 644 q 688 322 688 471 q 648 149 688 225 q 536 31 608 74 q 368 -11 464 -11 z ',
    },
    '6': {
      ha: 767,
      x_min: 58,
      x_max: 708,
      o:
        'm 383 -11 q 219 30 293 -11 q 101 144 144 71 q 58 306 58 217 q 72 394 58 349 q 106 476 85 439 l 389 983 l 583 983 l 372 622 l 394 622 q 555 582 483 622 q 667 470 626 542 q 708 306 708 399 q 666 144 708 217 q 549 31 624 72 q 383 -11 475 -11 m 383 150 q 490 193 447 150 q 533 306 533 236 q 491 419 533 378 q 383 461 449 461 q 276 419 318 461 q 233 306 233 378 q 277 193 233 236 q 383 150 321 150 z ',
    },
    '7': {
      ha: 672,
      x_min: 43,
      x_max: 632,
      o:
        'm 425 811 l 43 811 l 43 972 l 632 972 l 632 900 l 265 0 l 93 0 l 425 811 z ',
    },
    '8': {
      ha: 756,
      x_min: 61,
      x_max: 694,
      o:
        'm 378 -11 q 219 26 292 -11 q 104 131 147 63 q 61 290 61 199 q 94 430 61 371 q 189 524 128 489 q 122 608 146 558 q 99 718 99 658 q 134 851 99 790 q 233 947 169 911 q 378 983 297 983 q 522 947 458 983 q 622 851 586 911 q 657 718 657 790 q 633 608 657 658 q 565 524 610 558 q 660 430 626 489 q 694 290 694 371 q 651 131 694 199 q 536 26 608 63 q 378 -11 464 -11 m 378 592 q 463 626 431 592 q 494 715 494 660 q 463 803 494 769 q 378 836 431 836 q 293 803 325 836 q 261 715 261 769 q 293 626 261 660 q 378 592 325 592 m 378 150 q 479 188 439 150 q 519 290 519 225 q 479 393 519 356 q 378 431 439 431 q 276 393 317 431 q 236 290 236 356 q 276 188 236 225 q 378 150 317 150 z ',
    },
    '9': {
      ha: 767,
      x_min: 58,
      x_max: 708,
      o:
        'm 394 350 l 372 350 q 212 390 283 350 q 99 502 140 431 q 58 667 58 574 q 101 828 58 756 q 217 942 143 900 q 383 983 292 983 q 548 942 474 983 q 665 828 622 901 q 708 667 708 756 q 695 578 708 624 q 661 496 682 533 l 378 -11 l 183 -11 l 394 350 m 383 511 q 491 553 449 511 q 533 667 533 594 q 490 779 533 736 q 383 822 446 822 q 276 779 319 822 q 233 667 233 736 q 276 553 233 594 q 383 511 318 511 z ',
    },
    '\r': { ha: 344, x_min: 0, x_max: 0, o: '' },
    ' ': { ha: 344, x_min: 0, x_max: 0, o: '' },
    '!': {
      ha: 453,
      x_min: 111,
      x_max: 342,
      o:
        'm 113 972 l 340 972 l 301 336 l 151 336 l 113 972 m 226 -8 q 144 25 178 -8 q 111 106 111 58 q 145 188 111 154 q 226 222 179 222 q 308 188 274 222 q 342 106 342 154 q 308 25 342 58 q 226 -8 275 -8 z ',
    },
    '"': {
      ha: 582,
      x_min: 61,
      x_max: 521,
      o:
        'm 61 983 l 257 983 l 214 638 l 104 638 l 61 983 m 325 983 l 521 983 l 478 638 l 368 638 l 325 983 z ',
    },
    '#': {
      ha: 933,
      x_min: 46,
      x_max: 888,
      o:
        'm 204 268 l 46 268 l 46 404 l 232 404 l 265 568 l 101 568 l 101 704 l 293 704 l 349 972 l 488 972 l 432 704 l 590 704 l 644 972 l 783 972 l 729 704 l 888 704 l 888 568 l 701 568 l 668 404 l 832 404 l 832 268 l 640 268 l 585 0 l 446 0 l 501 268 l 343 268 l 289 0 l 150 0 l 204 268 m 529 404 l 563 568 l 404 568 l 371 404 l 529 404 z ',
    },
    $: {
      ha: 738,
      x_min: 44,
      x_max: 690,
      o:
        'm 690 279 q 631 98 690 171 q 472 0 572 25 l 472 -125 l 303 -125 l 303 -3 q 134 91 203 18 q 44 261 65 164 l 190 353 q 260 210 213 264 q 383 156 308 156 q 475 184 440 156 q 510 271 510 213 q 486 335 510 307 q 427 383 463 363 q 326 436 392 404 l 286 456 q 153 560 203 497 q 103 722 103 624 q 157 885 103 817 q 303 975 211 954 l 303 1097 l 472 1097 l 472 971 q 649 807 596 933 l 503 714 q 374 817 467 817 q 304 791 333 817 q 275 728 275 765 q 301 662 275 690 q 363 613 326 633 q 469 561 400 593 q 584 496 538 529 q 660 409 631 463 q 690 279 690 356 z ',
    },
    '%': {
      ha: 1172,
      x_min: 76,
      x_max: 1096,
      o:
        'm 163 28 l 910 1025 l 1010 946 l 263 -53 l 163 28 m 304 539 q 187 568 239 539 q 106 648 135 597 q 76 761 76 699 q 106 874 76 824 q 187 954 135 925 q 304 983 239 983 q 422 954 369 983 q 503 874 474 925 q 532 761 532 824 q 503 648 532 699 q 422 568 474 597 q 304 539 369 539 m 304 671 q 367 697 344 671 q 390 761 390 722 q 367 826 390 800 q 304 851 344 851 q 241 826 264 851 q 218 761 218 800 q 241 697 218 722 q 304 671 264 671 m 868 -11 q 751 18 803 -11 q 669 98 699 47 q 640 211 640 149 q 669 324 640 274 q 751 404 699 375 q 868 433 803 433 q 985 404 933 433 q 1067 324 1038 375 q 1096 211 1096 274 q 1067 98 1096 149 q 985 18 1038 47 q 868 -11 933 -11 m 868 121 q 931 147 908 121 q 954 211 954 172 q 931 276 954 250 q 868 301 908 301 q 805 276 828 301 q 782 211 782 250 q 805 147 782 172 q 868 121 828 121 z ',
    },
    '&': {
      ha: 883,
      x_min: 50,
      x_max: 875,
      o:
        'm 358 -11 q 201 24 271 -11 q 90 127 131 60 q 50 286 50 194 q 102 464 50 388 q 235 586 154 540 q 186 678 204 629 q 168 776 168 728 q 196 881 168 833 q 275 956 224 928 q 394 983 326 983 q 515 956 464 983 q 592 884 565 929 q 619 789 619 839 q 574 642 619 707 q 461 542 529 578 l 621 332 q 692 507 660 406 l 792 390 q 719 203 767 283 l 875 0 l 671 0 l 614 75 q 358 -11 506 -11 m 365 658 q 464 771 464 703 q 444 818 464 800 q 394 836 425 836 q 342 817 363 836 q 321 765 321 797 q 332 711 321 736 q 365 658 343 686 m 360 149 q 447 162 410 149 q 518 203 483 175 l 322 464 q 244 388 272 433 q 217 289 217 342 q 256 189 217 229 q 360 149 296 149 z ',
    },
    "'": {
      ha: 318,
      x_min: 61,
      x_max: 257,
      o: 'm 61 983 l 257 983 l 214 638 l 104 638 l 61 983 z ',
    },
    '(': {
      ha: 385,
      x_min: 64,
      x_max: 358,
      o:
        'm 210 -69 q 133 85 164 14 q 83 256 103 157 q 64 486 64 356 q 83 716 64 617 q 133 887 103 815 q 210 1042 164 958 l 358 1042 q 262 794 293 924 q 231 486 231 664 q 262 176 231 301 q 358 -69 293 51 l 210 -69 z ',
    },
    ')': {
      ha: 385,
      x_min: 26,
      x_max: 321,
      o:
        'm 26 -69 q 123 176 92 51 q 154 486 154 301 q 123 794 154 664 q 26 1042 92 924 l 175 1042 q 251 887 221 958 q 301 716 282 815 q 321 486 321 617 q 301 256 321 356 q 251 85 282 157 q 175 -69 221 14 l 26 -69 z ',
    },
    '*': {
      ha: 675,
      x_min: 69,
      x_max: 606,
      o:
        'm 128 561 l 221 688 l 69 739 l 115 876 l 267 826 l 267 983 l 408 983 l 408 826 l 560 876 l 606 739 l 454 688 l 547 561 l 429 474 l 338 603 l 246 474 l 128 561 z ',
    },
    '+': {
      ha: 842,
      x_min: 90,
      x_max: 751,
      o:
        'm 346 365 l 90 365 l 90 515 l 346 515 l 346 771 l 496 771 l 496 515 l 751 515 l 751 365 l 496 365 l 496 110 l 346 110 l 346 365 z ',
    },
    ',': {
      ha: 383,
      x_min: 32,
      x_max: 357,
      o: 'm 125 189 l 357 189 l 163 -189 l 32 -189 l 125 189 z ',
    },
    '-': {
      ha: 699,
      x_min: 90,
      x_max: 608,
      o: 'm 90 515 l 608 515 l 608 365 l 90 365 l 90 515 z ',
    },
    '.': {
      ha: 383,
      x_min: 75,
      x_max: 308,
      o:
        'm 192 -8 q 108 25 142 -8 q 75 108 75 58 q 108 192 75 158 q 192 225 142 225 q 275 192 242 225 q 308 108 308 158 q 275 25 308 58 q 192 -8 242 -8 z ',
    },
    '/': {
      ha: 775,
      x_min: 1,
      x_max: 774,
      o: 'm 607 1042 l 774 1042 l 168 -69 l 1 -69 l 607 1042 z ',
    },
    ':': {
      ha: 383,
      x_min: 75,
      x_max: 308,
      o:
        'm 192 478 q 108 511 142 478 q 75 594 75 544 q 108 678 75 644 q 192 711 142 711 q 275 678 242 711 q 308 594 308 644 q 275 511 308 544 q 192 478 242 478 m 192 -8 q 108 25 142 -8 q 75 108 75 58 q 108 192 75 158 q 192 225 142 225 q 275 192 242 225 q 308 108 308 158 q 275 25 308 58 q 192 -8 242 -8 z ',
    },
    ';': {
      ha: 383,
      x_min: 32,
      x_max: 357,
      o:
        'm 240 478 q 157 511 190 478 q 124 594 124 544 q 157 678 124 644 q 240 711 190 711 q 324 678 290 711 q 357 594 357 644 q 324 511 357 544 q 240 478 290 478 m 125 189 l 357 189 l 163 -189 l 32 -189 l 125 189 z ',
    },
    '<': {
      ha: 686,
      x_min: 67,
      x_max: 610,
      o:
        'm 67 350 l 67 511 l 610 794 l 610 613 l 260 431 l 610 249 l 610 67 l 67 350 z ',
    },
    '=': {
      ha: 788,
      x_min: 90,
      x_max: 697,
      o:
        'm 90 631 l 697 631 l 697 481 l 90 481 l 90 631 m 90 381 l 697 381 l 697 231 l 90 231 l 90 381 z ',
    },
    '>': {
      ha: 686,
      x_min: 76,
      x_max: 619,
      o:
        'm 76 249 l 426 431 l 76 613 l 76 794 l 619 511 l 619 350 l 76 67 l 76 249 z ',
    },
    '?': {
      ha: 639,
      x_min: 58,
      x_max: 581,
      o:
        'm 321 296 q 183 345 236 296 q 129 474 129 394 q 169 583 129 540 q 279 654 208 626 q 389 710 360 685 q 418 769 418 735 q 393 822 418 804 q 328 839 368 839 q 254 815 285 839 q 210 746 224 790 l 58 771 q 145 923 75 863 q 324 983 215 983 q 510 924 440 983 q 581 764 581 864 q 535 643 581 686 q 389 561 490 600 q 295 515 319 533 q 271 469 271 497 q 285 434 271 447 q 321 421 300 421 q 400 485 378 421 l 522 439 q 447 334 499 372 q 321 296 394 296 m 321 -8 q 239 25 272 -8 q 206 106 206 58 q 240 188 206 154 q 321 222 274 222 q 402 188 368 222 q 436 106 436 154 q 403 25 436 58 q 321 -8 369 -8 z ',
    },
    '@': {
      ha: 1275,
      x_min: 83,
      x_max: 1192,
      o:
        'm 653 -131 q 356 -60 486 -131 q 155 136 226 11 q 83 418 83 261 q 157 723 83 592 q 362 926 231 854 q 661 997 493 997 q 950 933 831 997 q 1131 753 1069 868 q 1192 489 1192 639 q 1158 310 1192 388 q 1065 192 1125 233 q 928 150 1006 150 q 834 178 875 150 q 776 246 793 206 q 693 176 740 201 q 590 150 646 150 q 409 222 475 150 q 343 411 343 294 q 379 564 343 494 q 483 675 415 633 q 643 717 551 717 q 788 664 728 717 l 803 707 l 918 707 l 890 403 l 888 363 q 901 308 888 325 q 942 292 914 292 q 1025 496 1025 292 q 924 765 1025 674 q 654 856 822 856 q 458 806 550 856 q 308 658 365 757 q 250 418 250 560 q 309 195 250 288 q 461 57 368 103 q 653 11 554 11 q 809 25 735 11 q 983 88 883 39 l 1038 -47 q 853 -112 940 -93 q 653 -131 765 -131 m 603 292 q 707 340 665 292 q 749 458 749 388 q 719 544 749 514 q 636 575 690 575 q 542 528 582 575 q 503 404 503 482 q 603 292 503 292 z ',
    },
    A: {
      ha: 867,
      x_min: 14,
      x_max: 853,
      o:
        'm 343 972 l 524 972 l 853 0 l 658 0 l 588 229 l 279 229 l 208 0 l 14 0 l 343 972 m 536 396 l 433 733 l 331 396 l 536 396 z ',
    },
    B: {
      ha: 858,
      x_min: 111,
      x_max: 794,
      o:
        'm 111 972 l 467 972 q 669 906 594 972 q 744 710 744 839 q 719 602 744 650 q 649 531 694 554 q 794 293 794 471 q 709 76 794 153 q 474 0 624 0 l 111 0 l 111 972 m 457 594 q 542 619 514 594 q 571 700 571 643 q 542 781 571 757 q 453 806 513 806 l 292 806 l 292 594 l 457 594 m 457 167 q 576 200 539 167 q 614 297 614 233 q 576 394 614 361 q 457 428 539 428 l 292 428 l 292 167 l 457 167 z ',
    },
    C: {
      ha: 985,
      x_min: 64,
      x_max: 926,
      o:
        'm 524 -11 q 294 47 399 -11 q 126 217 189 104 q 64 486 64 329 q 126 756 64 643 q 294 926 189 868 q 524 983 399 983 q 787 906 682 983 q 926 689 892 829 l 764 647 q 676 772 733 728 q 524 817 619 817 q 383 780 446 817 q 284 669 321 743 q 247 486 247 594 q 284 303 247 378 q 383 192 321 229 q 524 156 446 156 q 676 200 619 156 q 764 325 733 244 l 926 283 q 787 66 892 143 q 524 -11 682 -11 z ',
    },
    D: {
      ha: 932,
      x_min: 111,
      x_max: 868,
      o:
        'm 111 972 l 415 972 q 639 919 536 972 q 805 758 742 867 q 868 486 868 649 q 805 215 868 324 q 639 53 742 106 q 415 0 536 0 l 111 0 l 111 972 m 358 167 q 591 238 497 167 q 685 486 685 310 q 591 734 685 663 q 358 806 497 806 l 292 806 l 292 167 l 358 167 z ',
    },
    E: {
      ha: 796,
      x_min: 111,
      x_max: 726,
      o:
        'm 111 972 l 713 972 l 713 806 l 292 806 l 292 601 l 629 601 l 629 435 l 292 435 l 292 167 l 726 167 l 726 0 l 111 0 l 111 972 z ',
    },
    F: {
      ha: 768,
      x_min: 111,
      x_max: 726,
      o:
        'm 111 972 l 726 972 l 726 806 l 292 806 l 292 583 l 642 583 l 642 417 l 292 417 l 292 0 l 111 0 l 111 972 z ',
    },
    G: {
      ha: 1011,
      x_min: 64,
      x_max: 931,
      o:
        'm 513 -11 q 290 45 392 -11 q 126 214 188 101 q 64 486 64 326 q 128 758 64 646 q 297 926 192 869 q 526 983 403 983 q 788 899 683 983 q 931 676 892 815 l 765 633 q 526 817 690 817 q 325 733 403 817 q 247 486 247 649 q 324 238 247 319 q 522 156 400 156 q 676 210 621 156 q 740 340 731 265 l 560 340 l 560 490 l 915 490 l 915 0 l 764 0 l 749 104 q 658 22 717 54 q 513 -11 599 -11 z ',
    },
    H: {
      ha: 972,
      x_min: 111,
      x_max: 861,
      o:
        'm 111 972 l 292 972 l 292 603 l 681 603 l 681 972 l 861 972 l 861 0 l 681 0 l 681 436 l 292 436 l 292 0 l 111 0 l 111 972 z ',
    },
    I: {
      ha: 403,
      x_min: 111,
      x_max: 292,
      o: 'm 111 972 l 292 972 l 292 0 l 111 0 l 111 972 z ',
    },
    J: {
      ha: 743,
      x_min: 33,
      x_max: 643,
      o:
        'm 333 -11 q 128 56 207 -11 q 33 240 49 122 l 211 278 q 254 185 224 214 q 333 156 285 156 q 429 193 396 156 q 463 322 463 231 l 463 972 l 643 972 l 643 342 q 564 71 643 153 q 333 -11 485 -11 z ',
    },
    K: {
      ha: 888,
      x_min: 111,
      x_max: 874,
      o:
        'm 111 972 l 292 972 l 292 611 l 624 972 l 846 972 l 451 538 l 874 0 l 644 0 l 292 464 l 292 0 l 111 0 l 111 972 z ',
    },
    L: {
      ha: 751,
      x_min: 111,
      x_max: 704,
      o: 'm 111 972 l 292 972 l 292 167 l 704 167 l 704 0 l 111 0 l 111 972 z ',
    },
    M: {
      ha: 1086,
      x_min: 111,
      x_max: 975,
      o:
        'm 111 972 l 314 972 l 543 365 l 772 972 l 975 972 l 975 0 l 794 0 l 794 600 l 608 89 l 478 89 l 292 600 l 292 0 l 111 0 l 111 972 z ',
    },
    N: {
      ha: 950,
      x_min: 111,
      x_max: 839,
      o:
        'm 111 972 l 301 972 l 658 331 l 658 972 l 839 972 l 839 0 l 649 0 l 292 642 l 292 0 l 111 0 l 111 972 z ',
    },
    O: {
      ha: 1044,
      x_min: 64,
      x_max: 981,
      o:
        'm 522 -11 q 292 44 396 -11 q 126 212 188 100 q 64 486 64 324 q 126 760 64 649 q 292 928 188 872 q 522 983 396 983 q 753 928 649 983 q 919 760 857 872 q 981 486 981 649 q 919 212 981 324 q 753 44 857 100 q 522 -11 649 -11 m 522 156 q 660 191 599 156 q 760 301 722 226 q 797 486 797 375 q 760 672 797 597 q 660 781 722 746 q 522 817 599 817 q 384 781 446 817 q 285 672 322 746 q 247 486 247 597 q 285 301 247 375 q 384 191 322 226 q 522 156 446 156 z ',
    },
    P: {
      ha: 829,
      x_min: 111,
      x_max: 782,
      o:
        'm 111 972 l 478 972 q 704 891 626 972 q 782 676 782 810 q 704 462 782 543 q 478 381 626 381 l 292 381 l 292 0 l 111 0 l 111 972 m 471 547 q 565 579 532 547 q 599 676 599 611 q 565 774 599 742 q 471 806 532 806 l 292 806 l 292 547 l 471 547 z ',
    },
    Q: {
      ha: 1044,
      x_min: 64,
      x_max: 1008,
      o:
        'm 522 -11 q 292 44 396 -11 q 126 212 188 100 q 64 486 64 324 q 126 760 64 649 q 292 928 188 872 q 522 983 396 983 q 753 928 649 983 q 919 760 857 872 q 981 486 981 649 q 915 206 981 321 l 1008 114 l 882 -11 l 797 72 q 522 -11 683 -11 m 522 156 q 671 197 607 156 l 544 325 l 671 450 l 776 343 q 797 486 797 404 q 760 672 797 597 q 660 781 722 746 q 522 817 599 817 q 384 781 446 817 q 285 672 322 746 q 247 486 247 597 q 285 301 247 375 q 384 191 322 226 q 522 156 446 156 z ',
    },
    R: {
      ha: 879,
      x_min: 111,
      x_max: 849,
      o:
        'm 111 972 l 465 972 q 684 897 607 972 q 761 696 761 821 q 714 530 761 599 q 579 435 667 461 l 849 0 l 647 0 l 386 419 l 292 419 l 292 0 l 111 0 l 111 972 m 467 586 q 550 613 519 586 q 581 696 581 639 q 550 779 581 753 q 467 806 519 806 l 292 806 l 292 586 l 467 586 z ',
    },
    S: {
      ha: 738,
      x_min: 44,
      x_max: 690,
      o:
        'm 379 -11 q 223 25 293 -11 q 106 124 153 61 q 44 261 60 186 l 190 353 q 260 210 213 264 q 383 156 308 156 q 475 184 440 156 q 510 271 510 213 q 486 335 510 307 q 427 383 463 363 q 326 436 392 404 l 286 456 q 153 560 203 497 q 103 722 103 624 q 137 856 103 796 q 233 949 171 915 q 374 983 294 983 q 649 807 575 983 l 503 714 q 374 817 467 817 q 304 791 333 817 q 275 728 275 765 q 301 662 275 690 q 363 613 326 633 q 469 561 400 593 q 584 496 538 529 q 660 409 631 463 q 690 279 690 356 q 651 126 690 192 q 540 24 611 60 q 379 -11 469 -11 z ',
    },
    T: {
      ha: 789,
      x_min: 33,
      x_max: 756,
      o:
        'm 304 806 l 33 806 l 33 972 l 756 972 l 756 806 l 485 806 l 485 0 l 304 0 l 304 806 z ',
    },
    U: {
      ha: 925,
      x_min: 100,
      x_max: 825,
      o:
        'm 463 -11 q 198 85 296 -11 q 100 369 100 181 l 100 972 l 281 972 l 281 367 q 463 156 281 156 q 644 367 644 156 l 644 972 l 825 972 l 825 369 q 727 85 825 181 q 463 -11 629 -11 z ',
    },
    V: {
      ha: 864,
      x_min: 14,
      x_max: 850,
      o:
        'm 14 972 l 214 972 l 432 253 l 650 972 l 850 972 l 524 0 l 340 0 l 14 972 z ',
    },
    W: {
      ha: 1256,
      x_min: 14,
      x_max: 1242,
      o:
        'm 14 972 l 206 972 l 368 257 l 550 869 l 706 869 l 888 257 l 1050 972 l 1242 972 l 988 0 l 804 0 l 628 572 l 451 0 l 268 0 l 14 972 z ',
    },
    X: {
      ha: 839,
      x_min: 18,
      x_max: 821,
      o:
        'm 321 525 l 64 972 l 261 972 l 419 697 l 578 972 l 775 972 l 518 525 l 821 0 l 621 0 l 419 351 l 218 0 l 18 0 l 321 525 z ',
    },
    Y: {
      ha: 767,
      x_min: 13,
      x_max: 754,
      o:
        'm 293 414 l 13 972 l 207 972 l 383 594 l 560 972 l 754 972 l 474 414 l 474 0 l 293 0 l 293 414 z ',
    },
    Z: {
      ha: 788,
      x_min: 50,
      x_max: 738,
      o:
        'm 50 83 l 471 806 l 74 806 l 74 972 l 718 972 l 718 889 l 301 167 l 738 167 l 738 0 l 50 0 l 50 83 z ',
    },
    '[': {
      ha: 457,
      x_min: 111,
      x_max: 431,
      o:
        'm 111 1042 l 431 1042 l 431 892 l 278 892 l 278 81 l 431 81 l 431 -69 l 111 -69 l 111 1042 z ',
    },
    '\\': {
      ha: 775,
      x_min: 1,
      x_max: 774,
      o: 'm 1 1042 l 168 1042 l 774 -69 l 607 -69 l 1 1042 z ',
    },
    ']': {
      ha: 457,
      x_min: 26,
      x_max: 346,
      o:
        'm 26 81 l 179 81 l 179 892 l 26 892 l 26 1042 l 346 1042 l 346 -69 l 26 -69 l 26 81 z ',
    },
    '^': {
      ha: 771,
      x_min: 40,
      x_max: 731,
      o:
        'm 311 972 l 460 972 l 731 560 l 564 560 l 386 822 l 207 560 l 40 560 l 311 972 z ',
    },
    _: {
      ha: 701,
      x_min: 35,
      x_max: 667,
      o: 'm 35 0 l 667 0 l 667 -150 l 35 -150 l 35 0 z ',
    },
    '`': {
      ha: 361,
      x_min: 18,
      x_max: 344,
      o: 'm 18 983 l 251 983 l 344 767 l 219 767 l 18 983 z ',
    },
    a: {
      ha: 732,
      x_min: 61,
      x_max: 649,
      o:
        'm 274 -11 q 121 44 181 -11 q 61 201 61 100 q 140 368 61 306 q 354 431 219 431 l 476 431 l 476 461 q 442 538 476 513 q 354 564 407 564 q 233 483 264 564 l 88 517 q 177 658 104 604 q 354 711 250 711 q 572 637 494 711 q 649 418 649 563 l 649 0 l 507 0 l 489 89 q 274 -11 407 -11 m 319 136 q 429 176 382 136 q 476 281 476 215 l 476 294 l 361 294 q 273 272 304 294 q 242 204 242 250 q 263 155 242 174 q 319 136 285 136 z ',
    },
    b: {
      ha: 817,
      x_min: 97,
      x_max: 758,
      o:
        'm 439 -11 q 333 15 379 -11 q 269 72 286 42 l 269 0 l 97 0 l 97 983 l 269 983 l 269 636 q 340 689 293 667 q 439 711 388 711 q 676 613 593 711 q 758 350 758 515 q 676 87 758 185 q 439 -11 593 -11 m 415 136 q 532 193 486 136 q 578 350 578 250 q 532 508 578 451 q 415 564 486 564 q 299 508 344 564 q 254 350 254 451 q 299 192 254 249 q 415 136 344 136 z ',
    },
    c: {
      ha: 768,
      x_min: 58,
      x_max: 718,
      o:
        'm 400 -11 q 213 37 290 -11 q 97 167 136 85 q 58 350 58 249 q 97 533 58 451 q 213 663 136 615 q 400 711 290 711 q 598 660 517 711 q 718 511 679 610 l 564 449 q 497 535 536 506 q 400 564 457 564 q 280 505 321 564 q 239 350 239 446 q 280 195 239 254 q 400 136 321 136 q 497 165 457 136 q 564 251 536 194 l 718 189 q 598 40 679 90 q 400 -11 517 -11 z ',
    },
    d: {
      ha: 817,
      x_min: 58,
      x_max: 719,
      o:
        'm 364 -11 q 138 87 218 -11 q 58 350 58 185 q 138 613 58 515 q 364 711 218 711 q 473 690 424 711 q 547 636 522 668 l 547 983 l 719 983 l 719 0 l 547 0 l 547 72 q 481 15 531 40 q 364 -11 432 -11 m 401 136 q 517 192 472 136 q 563 350 563 249 q 517 508 563 451 q 401 564 472 564 q 285 508 331 564 q 239 350 239 451 q 285 193 239 250 q 401 136 331 136 z ',
    },
    e: {
      ha: 779,
      x_min: 58,
      x_max: 721,
      o:
        'm 394 -11 q 205 42 281 -11 q 94 178 129 96 q 58 350 58 261 q 94 522 58 439 q 205 658 129 604 q 394 711 281 711 q 578 659 504 711 q 686 528 651 607 q 721 365 721 449 l 721 294 l 239 294 q 285 183 242 231 q 404 136 329 136 q 502 163 463 136 q 574 244 542 189 l 713 193 q 592 42 669 94 q 394 -11 515 -11 m 544 431 q 495 526 532 489 q 394 564 458 564 q 293 525 333 564 q 243 431 253 486 l 544 431 z ',
    },
    f: {
      ha: 476,
      x_min: 13,
      x_max: 474,
      o:
        'm 101 553 l 13 553 l 13 700 l 101 700 l 101 736 q 166 922 101 860 q 343 983 231 983 q 474 956 422 983 l 436 817 q 353 836 390 836 q 274 749 274 836 l 274 700 l 421 700 l 421 553 l 274 553 l 274 0 l 101 0 l 101 553 z ',
    },
    g: {
      ha: 707,
      x_min: 43,
      x_max: 688,
      o:
        'm 360 -294 q 131 -235 219 -294 q 43 -64 43 -175 q 100 75 43 22 q 64 183 64 118 q 87 269 64 232 q 150 331 110 307 q 101 475 101 390 q 135 599 101 546 q 228 682 169 653 q 358 711 288 711 q 488 681 426 711 l 619 750 l 688 636 l 588 586 q 615 475 615 538 q 581 351 615 404 q 488 269 547 297 q 358 242 429 242 q 257 257 306 242 q 224 204 224 238 q 240 166 224 179 q 289 153 257 153 l 432 153 q 611 99 544 153 q 678 -53 678 46 q 633 -189 678 -135 q 515 -269 588 -243 q 360 -294 443 -294 m 358 381 q 427 407 400 381 q 454 475 454 433 q 427 545 454 518 q 358 572 400 572 q 290 545 317 572 q 263 475 263 518 q 290 407 263 433 q 358 381 317 381 m 360 -150 q 466 -129 426 -150 q 506 -64 506 -108 q 476 -8 506 -24 q 393 8 447 8 l 299 8 q 218 14 251 8 q 203 -50 203 -10 q 246 -124 203 -99 q 360 -150 289 -150 z ',
    },
    h: {
      ha: 807,
      x_min: 97,
      x_max: 710,
      o:
        'm 97 983 l 269 983 l 269 588 q 362 677 304 643 q 492 711 419 711 q 651 658 593 711 q 710 500 710 604 l 710 0 l 538 0 l 538 439 q 512 533 538 503 q 433 564 486 564 q 354 535 392 564 q 293 446 317 506 q 269 296 269 386 l 269 0 l 97 0 l 97 983 z ',
    },
    i: {
      ha: 367,
      x_min: 72,
      x_max: 294,
      o:
        'm 183 790 q 104 822 136 790 q 72 901 72 854 q 104 981 72 949 q 183 1013 136 1013 q 263 981 231 1013 q 294 901 294 949 q 263 822 294 854 q 183 790 231 790 m 97 700 l 269 700 l 269 0 l 97 0 l 97 700 z ',
    },
    j: {
      ha: 367,
      x_min: -65,
      x_max: 294,
      o:
        'm 183 790 q 104 822 136 790 q 72 901 72 854 q 104 981 72 949 q 183 1013 136 1013 q 263 981 231 1013 q 294 901 294 949 q 263 822 294 854 q 183 790 231 790 m -65 -143 q 57 -78 17 -122 q 97 60 97 -33 l 97 700 l 269 700 l 269 81 q 198 -172 269 -83 q -24 -294 126 -260 l -65 -143 z ',
    },
    k: {
      ha: 736,
      x_min: 97,
      x_max: 728,
      o:
        'm 97 983 l 269 983 l 269 425 l 497 700 l 710 700 l 429 378 l 728 0 l 517 0 l 269 331 l 269 0 l 97 0 l 97 983 z ',
    },
    l: {
      ha: 367,
      x_min: 97,
      x_max: 269,
      o: 'm 97 983 l 269 983 l 269 0 l 97 0 l 97 983 z ',
    },
    m: {
      ha: 1186,
      x_min: 97,
      x_max: 1089,
      o:
        'm 97 700 l 269 700 l 269 588 q 358 680 310 649 q 471 711 406 711 q 592 675 539 711 q 667 567 644 639 q 760 673 704 635 q 881 711 817 711 q 1033 654 978 711 q 1089 496 1089 597 l 1089 0 l 917 0 l 917 467 q 831 564 917 564 q 722 489 764 564 q 679 272 679 414 l 679 0 l 507 0 l 507 467 q 421 564 507 564 q 312 485 354 564 q 269 257 269 407 l 269 0 l 97 0 l 97 700 z ',
    },
    n: {
      ha: 799,
      x_min: 97,
      x_max: 701,
      o:
        'm 97 700 l 269 700 l 269 588 q 365 678 310 644 q 486 711 421 711 q 642 657 583 711 q 701 500 701 603 l 701 0 l 529 0 l 529 449 q 502 536 529 508 q 429 564 475 564 q 350 531 386 564 q 292 433 314 497 q 269 279 269 368 l 269 0 l 97 0 l 97 700 z ',
    },
    o: {
      ha: 828,
      x_min: 58,
      x_max: 769,
      o:
        'm 414 -11 q 224 36 304 -11 q 101 165 143 83 q 58 350 58 247 q 101 535 58 453 q 224 664 143 617 q 414 711 304 711 q 604 664 524 711 q 727 535 685 617 q 769 350 769 453 q 727 165 769 247 q 604 36 685 83 q 414 -11 524 -11 m 414 136 q 542 198 494 136 q 589 350 589 260 q 542 502 589 440 q 414 564 494 564 q 286 502 333 564 q 239 350 239 440 q 286 198 239 260 q 414 136 333 136 z ',
    },
    p: {
      ha: 817,
      x_min: 97,
      x_max: 758,
      o:
        'm 97 700 l 269 700 l 269 628 q 333 685 286 658 q 439 711 379 711 q 676 613 593 711 q 758 350 758 515 q 676 87 758 185 q 439 -11 593 -11 q 340 11 388 -11 q 269 64 293 33 l 269 -283 l 97 -283 l 97 700 m 415 136 q 532 193 486 136 q 578 350 578 250 q 532 508 578 451 q 415 564 486 564 q 299 508 344 564 q 254 350 254 451 q 299 192 254 249 q 415 136 344 136 z ',
    },
    q: {
      ha: 817,
      x_min: 58,
      x_max: 719,
      o:
        'm 547 64 q 476 11 524 33 q 378 -11 429 -11 q 141 87 224 -11 q 58 350 58 185 q 141 613 58 515 q 378 711 224 711 q 484 685 438 711 q 547 628 531 658 l 547 700 l 719 700 l 719 -283 l 547 -283 l 547 64 m 401 136 q 517 192 472 136 q 563 350 563 249 q 517 508 563 451 q 401 564 472 564 q 285 508 331 564 q 239 350 239 451 q 285 193 239 250 q 401 136 331 136 z ',
    },
    r: {
      ha: 579,
      x_min: 97,
      x_max: 561,
      o:
        'm 97 700 l 269 700 l 269 586 q 361 678 307 646 q 476 711 415 711 q 561 697 515 711 l 529 538 q 457 557 497 557 q 322 483 375 557 q 269 249 269 408 l 269 0 l 97 0 l 97 700 z ',
    },
    s: {
      ha: 619,
      x_min: 47,
      x_max: 561,
      o:
        'm 325 -11 q 144 44 217 -11 q 47 178 71 100 l 185 251 q 240 167 204 197 q 324 136 275 136 q 386 152 361 136 q 411 204 411 168 q 381 256 411 236 q 289 299 351 276 q 260 310 279 301 q 135 390 179 342 q 90 515 90 439 q 119 614 90 569 q 199 685 149 658 q 314 711 250 711 q 443 681 385 711 q 533 597 501 651 l 431 503 q 318 564 389 564 q 270 549 290 564 q 250 511 250 535 q 279 465 250 486 q 393 413 308 443 q 517 336 474 383 q 561 215 561 289 q 496 51 561 113 q 325 -11 431 -11 z ',
    },
    t: {
      ha: 514,
      x_min: 13,
      x_max: 492,
      o:
        'm 378 -11 q 189 54 257 -11 q 121 247 121 119 l 121 553 l 13 553 l 13 700 l 121 700 l 121 875 l 293 983 l 293 700 l 478 700 l 478 553 l 293 553 l 293 250 q 316 162 293 188 q 385 136 339 136 q 451 153 419 136 l 492 14 q 378 -11 438 -11 z ',
    },
    u: {
      ha: 799,
      x_min: 97,
      x_max: 701,
      o:
        'm 313 -11 q 156 43 215 -11 q 97 200 97 97 l 97 700 l 269 700 l 269 251 q 297 164 269 192 q 369 136 324 136 q 449 169 413 136 q 507 267 485 203 q 529 421 529 332 l 529 700 l 701 700 l 701 0 l 529 0 l 529 113 q 433 22 489 56 q 313 -11 378 -11 z ',
    },
    v: {
      ha: 667,
      x_min: 18,
      x_max: 649,
      o:
        'm 18 700 l 192 700 l 333 213 l 475 700 l 649 700 l 411 0 l 256 0 l 18 700 z ',
    },
    w: {
      ha: 1025,
      x_min: 15,
      x_max: 1010,
      o:
        'm 15 700 l 189 700 l 314 219 l 432 700 l 593 700 l 711 219 l 836 700 l 1010 700 l 786 0 l 633 0 l 513 453 l 392 0 l 239 0 l 15 700 z ',
    },
    x: {
      ha: 667,
      x_min: 10,
      x_max: 657,
      o:
        'm 242 374 l 39 700 l 219 700 l 333 518 l 447 700 l 628 700 l 425 374 l 657 0 l 476 0 l 333 228 l 190 0 l 10 0 l 242 374 z ',
    },
    y: {
      ha: 689,
      x_min: 14,
      x_max: 675,
      o:
        'm 268 44 l 14 700 l 188 700 l 350 261 l 503 700 l 675 700 l 314 -283 l 147 -283 l 268 44 z ',
    },
    z: {
      ha: 629,
      x_min: 42,
      x_max: 578,
      o:
        'm 42 67 l 344 553 l 64 553 l 64 700 l 558 700 l 558 633 l 258 147 l 578 147 l 578 0 l 42 0 l 42 67 z ',
    },
    '{': {
      ha: 439,
      x_min: 40,
      x_max: 413,
      o:
        'm 290 -69 q 190 -31 228 -69 q 151 69 151 7 l 151 300 q 127 388 151 364 q 40 411 103 411 l 40 561 q 127 585 103 561 q 151 672 151 608 l 151 903 q 190 1003 151 965 q 290 1042 228 1042 l 413 1042 l 413 892 l 375 892 q 330 878 342 892 q 318 829 318 865 l 318 622 q 292 520 318 547 q 215 486 265 493 q 292 452 265 479 q 318 350 318 425 l 318 143 q 330 94 318 107 q 375 81 342 81 l 413 81 l 413 -69 l 290 -69 z ',
    },
    '|': {
      ha: 392,
      x_min: 111,
      x_max: 281,
      o: 'm 111 1042 l 281 1042 l 281 -69 l 111 -69 l 111 1042 z ',
    },
    '}': {
      ha: 439,
      x_min: 26,
      x_max: 399,
      o:
        'm 26 81 l 64 81 q 109 94 97 81 q 121 143 121 107 l 121 350 q 147 452 121 425 q 224 486 174 479 q 147 520 174 493 q 121 622 121 547 l 121 829 q 109 878 121 865 q 64 892 97 892 l 26 892 l 26 1042 l 149 1042 q 249 1003 211 1042 q 288 903 288 965 l 288 672 q 312 585 288 608 q 399 561 336 561 l 399 411 q 312 388 336 411 q 288 300 288 364 l 288 69 q 249 -31 288 7 q 149 -69 211 -69 l 26 -69 l 26 81 z ',
    },
    '~': {
      ha: 822,
      x_min: 60,
      x_max: 763,
      o:
        'm 553 335 q 476 346 511 335 q 399 379 442 357 q 333 408 360 399 q 275 417 306 417 q 149 346 204 417 l 60 442 q 144 551 86 506 q 269 596 201 596 q 346 585 311 596 q 424 551 381 574 q 490 523 463 532 q 547 514 517 514 q 674 585 618 514 l 763 489 q 678 380 736 425 q 553 335 621 335 z ',
    },
    ' ': { ha: 344, x_min: 0, x_max: 0, o: '' },
    '¡': {
      ha: 453,
      x_min: 111,
      x_max: 342,
      o:
        'm 226 467 q 145 501 179 467 q 111 583 111 535 q 144 664 111 631 q 226 697 178 697 q 308 664 275 697 q 342 583 342 631 q 308 501 342 535 q 226 467 274 467 m 151 353 l 301 353 l 340 -283 l 113 -283 l 151 353 z ',
    },
    '¢': {
      ha: 768,
      x_min: 58,
      x_max: 718,
      o:
        'm 315 133 q 124 256 190 160 q 58 486 58 353 q 124 716 58 619 q 315 839 190 813 l 315 1042 l 485 1042 l 485 839 q 718 647 653 807 l 564 585 q 497 671 536 642 q 400 700 457 700 q 280 641 321 700 q 239 486 239 582 q 280 331 239 390 q 400 272 321 272 q 497 301 457 272 q 564 388 536 331 l 718 325 q 485 133 653 165 l 485 -69 l 315 -69 l 315 133 z ',
    },
    '£': {
      ha: 772,
      x_min: 50,
      x_max: 747,
      o:
        'm 50 94 q 163 217 125 164 q 200 340 200 271 q 185 432 200 379 l 72 432 l 72 579 l 142 579 q 117 694 117 646 q 153 842 117 776 q 257 946 190 908 q 413 983 324 983 q 594 933 521 983 q 700 792 668 882 l 557 724 q 413 822 511 822 q 325 788 361 822 q 289 685 289 754 q 301 579 289 621 l 540 579 l 540 432 l 347 432 q 353 372 353 406 q 324 242 353 293 q 240 146 294 192 q 378 190 314 190 q 415 185 400 190 q 454 169 431 181 q 490 154 474 160 q 528 149 506 149 q 578 165 556 149 q 628 226 601 181 l 747 151 q 645 28 700 68 q 518 -11 590 -11 q 458 -4 483 -11 q 403 17 432 3 q 356 34 376 28 q 307 40 335 40 q 228 28 264 40 q 146 -11 192 15 l 50 94 z ',
    },
    '¤': {
      ha: 797,
      x_min: 31,
      x_max: 767,
      o:
        'm 31 193 l 154 289 q 119 426 119 351 q 154 564 119 501 l 31 660 l 165 794 l 261 671 q 399 707 322 707 q 536 671 475 707 l 632 794 l 767 660 l 643 564 q 678 426 678 501 q 643 289 678 351 l 767 193 l 632 58 l 536 182 q 399 146 475 146 q 261 182 322 146 l 165 58 l 31 193 m 399 303 q 481 337 451 303 q 511 426 511 371 q 481 516 511 482 q 399 550 451 550 q 316 516 346 550 q 286 426 286 482 q 316 337 286 371 q 399 303 346 303 z ',
    },
    '¥': {
      ha: 750,
      x_min: 13,
      x_max: 738,
      o:
        'm 285 164 l 86 164 l 86 314 l 285 314 l 285 414 l 86 414 l 86 564 l 213 564 l 13 972 l 207 972 l 375 594 l 543 972 l 738 972 l 538 564 l 664 564 l 664 414 l 465 414 l 465 314 l 664 314 l 664 164 l 465 164 l 465 0 l 285 0 l 285 164 z ',
    },
    '¦': {
      ha: 392,
      x_min: 111,
      x_max: 281,
      o:
        'm 111 1042 l 281 1042 l 281 557 l 111 557 l 111 1042 m 111 415 l 281 415 l 281 -69 l 111 -69 l 111 415 z ',
    },
    '§': {
      ha: 689,
      x_min: 44,
      x_max: 642,
      o:
        'm 343 -294 q 164 -242 235 -294 q 65 -85 93 -190 l 218 -35 q 268 -110 238 -87 q 343 -133 299 -133 q 405 -108 382 -133 q 428 -33 428 -82 q 407 33 428 6 q 351 82 386 61 q 247 138 317 103 l 190 165 q 44 381 44 239 q 126 574 44 503 q 92 713 92 633 q 126 855 92 793 q 217 950 160 917 q 343 983 275 983 q 522 931 451 983 q 621 774 593 879 l 468 724 q 418 799 449 776 q 343 822 388 822 q 281 797 304 822 q 258 722 258 771 q 279 656 258 683 q 335 607 300 628 q 439 551 369 586 l 496 524 q 642 308 642 450 q 560 115 642 186 q 594 -24 594 57 q 560 -166 594 -104 q 469 -261 526 -228 q 343 -294 411 -294 m 450 211 q 492 296 492 244 q 450 369 492 339 q 319 439 408 399 q 236 478 264 464 q 194 393 194 446 q 236 320 194 350 q 367 250 278 290 q 450 211 422 225 z ',
    },
    '¨': {
      ha: 529,
      x_min: 22,
      x_max: 507,
      o:
        'm 121 800 q 50 828 78 800 q 22 899 22 856 q 50 969 22 942 q 121 997 78 997 q 192 969 164 997 q 219 899 219 942 q 192 828 219 856 q 121 800 164 800 m 408 800 q 338 828 365 800 q 310 899 310 856 q 338 969 310 942 q 408 997 365 997 q 479 969 451 997 q 507 899 507 942 q 479 828 507 856 q 408 800 451 800 z ',
    },
    '©': {
      ha: 1236,
      x_min: 83,
      x_max: 1153,
      o:
        'm 618 -56 q 346 15 468 -56 q 153 210 224 86 q 83 486 83 335 q 153 762 83 638 q 346 957 224 886 q 618 1028 468 1028 q 890 957 768 1028 q 1083 762 1013 886 q 1153 486 1153 638 q 1083 210 1153 335 q 890 15 1013 86 q 618 -56 768 -56 m 618 92 q 815 142 728 92 q 951 283 903 193 q 1000 486 1000 372 q 951 690 1000 600 q 815 830 903 779 q 618 881 728 881 q 421 830 508 881 q 285 690 333 779 q 236 486 236 600 q 285 283 236 372 q 421 142 333 193 q 618 92 508 92 m 618 186 q 479 221 543 186 q 377 323 415 256 q 339 486 339 390 q 377 649 339 582 q 479 751 415 717 q 618 786 543 786 q 789 735 717 786 q 875 590 861 683 l 740 564 q 618 654 711 654 q 527 607 563 654 q 492 486 492 560 q 527 365 492 413 q 618 318 563 318 q 740 408 711 318 l 875 382 q 789 238 861 289 q 618 186 717 186 z ',
    },
    ª: {
      ha: 624,
      x_min: 81,
      x_max: 542,
      o:
        'm 247 411 q 128 456 176 411 q 81 578 81 500 q 146 709 81 660 q 315 758 211 758 l 407 758 l 407 782 q 380 844 407 825 q 311 863 353 863 q 215 799 238 863 l 101 825 q 171 935 114 893 q 311 978 228 978 q 542 747 542 978 l 542 417 l 429 417 l 417 489 q 247 411 350 411 m 279 526 q 368 558 329 526 q 407 640 407 590 l 407 656 l 315 656 q 247 635 272 656 q 222 578 222 614 q 237 541 222 556 q 279 526 251 526 z ',
    },
    '«': {
      ha: 976,
      x_min: 61,
      x_max: 907,
      o:
        'm 61 374 l 61 488 l 490 790 l 490 613 l 233 431 l 490 249 l 490 71 l 61 374 m 478 374 l 478 488 l 907 790 l 907 613 l 650 431 l 907 249 l 907 71 l 478 374 z ',
    },
    '¬': {
      ha: 828,
      x_min: 90,
      x_max: 738,
      o:
        'm 565 410 l 90 410 l 90 565 l 738 565 l 738 197 l 565 197 l 565 410 z ',
    },
    '­': {
      ha: 699,
      x_min: 90,
      x_max: 608,
      o: 'm 90 515 l 608 515 l 608 365 l 90 365 l 90 515 z ',
    },
    '®': {
      ha: 1236,
      x_min: 83,
      x_max: 1153,
      o:
        'm 618 -56 q 346 15 468 -56 q 153 210 224 86 q 83 486 83 335 q 153 762 83 638 q 346 957 224 886 q 618 1028 468 1028 q 890 957 768 1028 q 1083 762 1013 886 q 1153 486 1153 638 q 1083 210 1153 335 q 890 15 1013 86 q 618 -56 768 -56 m 618 92 q 815 142 728 92 q 951 283 903 193 q 1000 486 1000 372 q 951 690 1000 600 q 815 830 903 779 q 618 881 728 881 q 421 830 508 881 q 285 690 333 779 q 236 486 236 600 q 285 283 236 372 q 421 142 333 193 q 618 92 508 92 m 401 782 l 636 782 q 782 738 733 782 q 831 613 831 694 q 798 502 831 543 q 710 450 765 461 l 864 204 l 707 204 l 564 443 l 547 443 l 547 204 l 401 204 l 401 782 m 622 558 q 674 572 658 558 q 689 613 689 586 q 674 653 689 639 q 622 667 658 667 l 547 667 l 547 558 l 622 558 z ',
    },
    '¯': {
      ha: 399,
      x_min: 13,
      x_max: 386,
      o: 'm 13 961 l 386 961 l 386 825 l 13 825 l 13 961 z ',
    },
    '°': {
      ha: 506,
      x_min: 83,
      x_max: 422,
      o:
        'm 253 656 q 132 703 181 656 q 83 824 83 751 q 132 944 83 896 q 253 992 181 992 q 374 944 325 992 q 422 824 422 896 q 374 703 422 751 q 253 656 325 656 m 253 768 q 292 783 278 768 q 307 824 307 799 q 292 864 307 849 q 253 879 278 879 q 213 864 228 879 q 199 824 199 849 q 213 783 199 799 q 253 768 228 768 z ',
    },
    '±': {
      ha: 842,
      x_min: 90,
      x_max: 751,
      o:
        'm 346 479 l 90 479 l 90 629 l 346 629 l 346 885 l 496 885 l 496 629 l 751 629 l 751 479 l 496 479 l 496 224 l 346 224 l 346 479 m 90 150 l 751 150 l 751 0 l 90 0 l 90 150 z ',
    },
    '²': {
      ha: 463,
      x_min: 43,
      x_max: 419,
      o:
        'm 43 465 l 244 711 q 282 806 282 756 q 267 848 282 833 q 229 863 253 863 q 158 789 172 863 l 47 821 q 106 934 56 890 q 229 978 157 978 q 361 932 311 978 q 411 808 411 886 q 356 671 411 739 l 242 532 l 419 532 l 419 417 l 43 417 l 43 465 z ',
    },
    '³': {
      ha: 469,
      x_min: 46,
      x_max: 435,
      o:
        'm 240 411 q 103 461 157 411 q 46 586 50 511 l 157 600 q 186 545 164 564 q 238 526 208 526 q 288 547 271 526 q 306 608 306 568 q 288 664 306 646 q 239 682 269 682 q 213 679 224 682 q 188 668 201 676 l 132 738 l 224 857 l 71 857 l 71 972 l 400 972 l 400 924 l 276 765 q 390 718 344 765 q 435 604 435 671 q 385 463 435 515 q 240 411 336 411 z ',
    },
    '´': {
      ha: 361,
      x_min: 17,
      x_max: 343,
      o: 'm 110 983 l 343 983 l 142 767 l 17 767 l 110 983 z ',
    },
    µ: {
      ha: 799,
      x_min: 97,
      x_max: 701,
      o:
        'm 97 700 l 269 700 l 269 251 q 297 164 269 192 q 369 136 324 136 q 449 169 413 136 q 507 267 485 203 q 529 421 529 332 l 529 700 l 701 700 l 701 0 l 529 0 l 529 113 q 433 22 489 56 q 313 -11 378 -11 q 269 -7 290 -11 l 269 -283 l 97 -283 l 97 700 z ',
    },
    '¶': {
      ha: 1033,
      x_min: 75,
      x_max: 950,
      o:
        'm 390 342 q 233 384 306 342 q 117 499 160 426 q 75 657 75 572 q 117 815 75 742 q 233 930 160 888 q 390 972 306 972 l 950 972 l 950 822 l 864 822 l 864 -283 l 697 -283 l 697 822 l 557 822 l 557 -283 l 390 -283 l 390 342 z ',
    },
    '·': {
      ha: 456,
      x_min: 111,
      x_max: 344,
      o:
        'm 228 369 q 144 403 178 369 q 111 486 111 436 q 144 569 111 536 q 228 603 178 603 q 311 569 278 603 q 344 486 344 536 q 311 403 344 436 q 228 369 278 369 z ',
    },
    '¸': {
      ha: 335,
      x_min: 7,
      x_max: 328,
      o: 'm 7 -278 l 203 -83 l 328 -83 l 213 -369 l 7 -278 z ',
    },
    '¹': {
      ha: 340,
      x_min: 35,
      x_max: 276,
      o:
        'm 153 803 l 35 750 l 35 882 l 225 972 l 276 972 l 276 417 l 153 417 l 153 803 z ',
    },
    º: {
      ha: 725,
      x_min: 83,
      x_max: 642,
      o:
        'm 363 411 q 213 448 276 411 q 117 549 150 485 q 83 694 83 614 q 117 840 83 775 q 213 941 150 904 q 363 978 276 978 q 512 941 449 978 q 608 840 575 904 q 642 694 642 775 q 608 549 642 614 q 512 448 575 485 q 363 411 449 411 m 363 526 q 463 575 426 526 q 500 694 500 624 q 463 814 500 765 q 363 863 426 863 q 262 814 299 863 q 225 694 225 765 q 262 575 225 624 q 363 526 299 526 z ',
    },
    '»': {
      ha: 976,
      x_min: 69,
      x_max: 915,
      o:
        'm 69 249 l 326 431 l 69 613 l 69 790 l 499 488 l 499 374 l 69 71 l 69 249 m 486 249 l 743 431 l 486 613 l 486 790 l 915 488 l 915 374 l 486 71 l 486 249 z ',
    },
    '¼': {
      ha: 1053,
      x_min: 35,
      x_max: 1024,
      o:
        'm 153 803 l 35 750 l 35 882 l 225 972 l 276 972 l 276 417 l 153 417 l 153 803 m 149 28 l 896 1025 l 996 946 l 249 -53 l 149 28 m 840 90 l 608 90 l 608 153 l 832 556 l 964 556 l 964 206 l 1024 206 l 1024 90 l 964 90 l 964 0 l 840 0 l 840 90 m 840 206 l 840 375 l 753 206 l 840 206 z ',
    },
    '½': {
      ha: 1186,
      x_min: 35,
      x_max: 1143,
      o:
        'm 153 803 l 35 750 l 35 882 l 225 972 l 276 972 l 276 417 l 153 417 l 153 803 m 149 28 l 896 1025 l 996 946 l 249 -53 l 149 28 m 767 49 l 968 294 q 1006 389 1006 339 q 991 431 1006 417 q 953 446 976 446 q 882 372 896 446 l 771 404 q 830 517 779 474 q 953 561 881 561 q 1085 515 1035 561 q 1135 392 1135 469 q 1079 254 1135 322 l 965 115 l 1143 115 l 1143 0 l 767 0 l 767 49 z ',
    },
    '¾': {
      ha: 1114,
      x_min: 46,
      x_max: 1085,
      o:
        'm 240 411 q 103 461 157 411 q 46 586 50 511 l 157 600 q 186 545 164 564 q 238 526 208 526 q 288 547 271 526 q 306 608 306 568 q 288 664 306 646 q 239 682 269 682 q 213 679 224 682 q 188 668 201 676 l 132 738 l 224 857 l 71 857 l 71 972 l 400 972 l 400 924 l 276 765 q 390 718 344 765 q 435 604 435 671 q 385 463 435 515 q 240 411 336 411 m 210 28 l 957 1025 l 1057 946 l 310 -53 l 210 28 m 901 90 l 669 90 l 669 153 l 893 556 l 1025 556 l 1025 206 l 1085 206 l 1085 90 l 1025 90 l 1025 0 l 901 0 l 901 90 m 901 206 l 901 375 l 814 206 l 901 206 z ',
    },
    '¿': {
      ha: 639,
      x_min: 58,
      x_max: 581,
      o:
        'm 318 393 q 456 344 403 393 q 510 215 510 294 q 470 106 510 149 q 360 35 431 63 q 250 -21 279 4 q 221 -81 221 -46 q 246 -133 221 -115 q 311 -150 271 -150 q 385 -126 354 -150 q 429 -57 415 -101 l 581 -82 q 494 -234 564 -174 q 315 -294 424 -294 q 128 -235 199 -294 q 58 -75 58 -175 q 103 46 58 3 q 250 128 149 89 q 344 174 319 156 q 368 219 368 192 q 353 255 368 242 q 318 268 339 268 q 239 204 261 268 l 117 250 q 192 355 140 317 q 318 393 244 393 m 318 697 q 400 664 367 697 q 433 583 433 631 q 399 501 433 535 q 318 467 365 467 q 237 501 271 467 q 203 583 203 535 q 236 664 203 631 q 318 697 269 697 z ',
    },
    À: {
      ha: 867,
      x_min: 14,
      x_max: 853,
      o:
        'm 343 972 l 524 972 l 853 0 l 658 0 l 588 229 l 279 229 l 208 0 l 14 0 l 343 972 m 536 396 l 433 733 l 331 396 l 536 396 m 176 1256 l 410 1256 l 503 1039 l 378 1039 l 176 1256 z ',
    },
    Á: {
      ha: 867,
      x_min: 14,
      x_max: 853,
      o:
        'm 343 972 l 524 972 l 853 0 l 658 0 l 588 229 l 279 229 l 208 0 l 14 0 l 343 972 m 536 396 l 433 733 l 331 396 l 536 396 m 457 1256 l 690 1256 l 489 1039 l 364 1039 l 457 1256 z ',
    },
    Â: {
      ha: 867,
      x_min: 14,
      x_max: 853,
      o:
        'm 343 972 l 524 972 l 853 0 l 658 0 l 588 229 l 279 229 l 208 0 l 14 0 l 343 972 m 536 396 l 433 733 l 331 396 l 536 396 m 410 1292 l 457 1292 l 681 1050 l 522 1050 l 433 1146 l 344 1050 l 186 1050 l 410 1292 z ',
    },
    Ã: {
      ha: 867,
      x_min: 14,
      x_max: 853,
      o:
        'm 343 972 l 524 972 l 853 0 l 658 0 l 588 229 l 279 229 l 208 0 l 14 0 l 343 972 m 536 396 l 433 733 l 331 396 l 536 396 m 165 1139 q 236 1226 189 1193 q 336 1260 283 1260 q 393 1251 369 1260 q 444 1228 417 1243 q 485 1209 469 1215 q 521 1203 500 1203 q 610 1263 567 1203 l 700 1186 q 629 1099 676 1132 q 529 1065 582 1065 q 472 1074 496 1065 q 421 1097 449 1082 q 381 1116 396 1110 q 344 1122 365 1122 q 256 1063 299 1122 l 165 1139 z ',
    },
    Ä: {
      ha: 867,
      x_min: 14,
      x_max: 853,
      o:
        'm 343 972 l 524 972 l 853 0 l 658 0 l 588 229 l 279 229 l 208 0 l 14 0 l 343 972 m 536 396 l 433 733 l 331 396 l 536 396 m 289 1072 q 218 1100 246 1072 q 190 1171 190 1128 q 218 1242 190 1214 q 289 1269 246 1269 q 360 1242 332 1269 q 388 1171 388 1214 q 360 1100 388 1128 q 289 1072 332 1072 m 576 1072 q 506 1100 533 1072 q 478 1171 478 1128 q 506 1242 478 1214 q 576 1269 533 1269 q 647 1242 619 1269 q 675 1171 675 1214 q 647 1100 675 1128 q 576 1072 619 1072 z ',
    },
    Å: {
      ha: 867,
      x_min: 14,
      x_max: 853,
      o:
        'm 343 972 l 524 972 l 853 0 l 658 0 l 588 229 l 279 229 l 208 0 l 14 0 l 343 972 m 536 396 l 433 733 l 331 396 l 536 396 m 432 1040 q 327 1081 369 1040 q 285 1182 285 1121 q 327 1283 285 1243 q 432 1324 369 1324 q 537 1283 494 1324 q 579 1182 579 1243 q 537 1081 579 1121 q 432 1040 494 1040 m 432 1138 q 464 1150 451 1138 q 476 1182 476 1163 q 464 1214 476 1201 q 432 1226 451 1226 q 400 1214 413 1226 q 388 1182 388 1201 q 400 1150 388 1163 q 432 1138 413 1138 z ',
    },
    Æ: {
      ha: 1207,
      x_min: 14,
      x_max: 1138,
      o:
        'm 439 972 l 1124 972 l 1124 806 l 703 806 l 703 601 l 1040 601 l 1040 435 l 703 435 l 703 167 l 1138 167 l 1138 0 l 522 0 l 522 229 l 300 229 l 208 0 l 14 0 l 439 972 m 522 396 l 522 733 l 504 733 l 368 396 l 522 396 z ',
    },
    Ç: {
      ha: 985,
      x_min: 64,
      x_max: 926,
      o:
        'm 524 -11 q 294 47 399 -11 q 126 217 189 104 q 64 486 64 329 q 126 756 64 643 q 294 926 189 868 q 524 983 399 983 q 787 906 682 983 q 926 689 892 829 l 764 647 q 676 772 733 728 q 524 817 619 817 q 383 780 446 817 q 284 669 321 743 q 247 486 247 594 q 284 303 247 378 q 383 192 321 229 q 524 156 446 156 q 676 200 619 156 q 764 325 733 244 l 926 283 q 787 66 892 143 q 524 -11 682 -11 m 279 -278 l 475 -83 l 600 -83 l 485 -369 l 279 -278 z ',
    },
    È: {
      ha: 796,
      x_min: 111,
      x_max: 726,
      o:
        'm 111 972 l 713 972 l 713 806 l 292 806 l 292 601 l 629 601 l 629 435 l 292 435 l 292 167 l 726 167 l 726 0 l 111 0 l 111 972 m 157 1256 l 390 1256 l 483 1039 l 358 1039 l 157 1256 z ',
    },
    É: {
      ha: 796,
      x_min: 111,
      x_max: 726,
      o:
        'm 111 972 l 713 972 l 713 806 l 292 806 l 292 601 l 629 601 l 629 435 l 292 435 l 292 167 l 726 167 l 726 0 l 111 0 l 111 972 m 438 1256 l 671 1256 l 469 1039 l 344 1039 l 438 1256 z ',
    },
    Ê: {
      ha: 796,
      x_min: 111,
      x_max: 726,
      o:
        'm 111 972 l 713 972 l 713 806 l 292 806 l 292 601 l 629 601 l 629 435 l 292 435 l 292 167 l 726 167 l 726 0 l 111 0 l 111 972 m 390 1292 l 438 1292 l 661 1050 l 503 1050 l 414 1146 l 325 1050 l 167 1050 l 390 1292 z ',
    },
    Ë: {
      ha: 796,
      x_min: 111,
      x_max: 726,
      o:
        'm 111 972 l 713 972 l 713 806 l 292 806 l 292 601 l 629 601 l 629 435 l 292 435 l 292 167 l 726 167 l 726 0 l 111 0 l 111 972 m 269 1072 q 199 1100 226 1072 q 171 1171 171 1128 q 199 1242 171 1214 q 269 1269 226 1269 q 340 1242 313 1269 q 368 1171 368 1214 q 340 1100 368 1128 q 269 1072 313 1072 m 557 1072 q 486 1100 514 1072 q 458 1171 458 1128 q 486 1242 458 1214 q 557 1269 514 1269 q 628 1242 600 1269 q 656 1171 656 1214 q 628 1100 656 1128 q 557 1072 600 1072 z ',
    },
    Ì: {
      ha: 403,
      x_min: -56,
      x_max: 292,
      o:
        'm 111 972 l 292 972 l 292 0 l 111 0 l 111 972 m -56 1256 l 178 1256 l 271 1039 l 146 1039 l -56 1256 z ',
    },
    Í: {
      ha: 403,
      x_min: 111,
      x_max: 458,
      o:
        'm 111 972 l 292 972 l 292 0 l 111 0 l 111 972 m 225 1256 l 458 1256 l 257 1039 l 132 1039 l 225 1256 z ',
    },
    Î: {
      ha: 403,
      x_min: -46,
      x_max: 449,
      o:
        'm 111 972 l 292 972 l 292 0 l 111 0 l 111 972 m 178 1292 l 225 1292 l 449 1050 l 290 1050 l 201 1146 l 113 1050 l -46 1050 l 178 1292 z ',
    },
    Ï: {
      ha: 403,
      x_min: -42,
      x_max: 443,
      o:
        'm 111 972 l 292 972 l 292 0 l 111 0 l 111 972 m 57 1072 q -14 1100 14 1072 q -42 1171 -42 1128 q -14 1242 -42 1214 q 57 1269 14 1269 q 128 1242 100 1269 q 156 1171 156 1214 q 128 1100 156 1128 q 57 1072 100 1072 m 344 1072 q 274 1100 301 1072 q 246 1171 246 1128 q 274 1242 246 1214 q 344 1269 301 1269 q 415 1242 388 1269 q 443 1171 443 1214 q 415 1100 443 1128 q 344 1072 388 1072 z ',
    },
    Ð: {
      ha: 932,
      x_min: 10,
      x_max: 868,
      o:
        'm 111 972 l 415 972 q 639 919 536 972 q 805 758 742 867 q 868 486 868 649 q 805 215 868 324 q 639 53 742 106 q 415 0 536 0 l 111 0 l 111 972 m 358 167 q 591 238 497 167 q 685 486 685 310 q 591 734 685 663 q 358 806 497 806 l 292 806 l 292 167 l 358 167 m 10 561 l 449 561 l 449 411 l 10 411 l 10 561 z ',
    },
    Ñ: {
      ha: 950,
      x_min: 111,
      x_max: 839,
      o:
        'm 111 972 l 301 972 l 658 331 l 658 972 l 839 972 l 839 0 l 649 0 l 292 642 l 292 0 l 111 0 l 111 972 m 207 1139 q 278 1226 231 1193 q 378 1260 325 1260 q 435 1251 411 1260 q 486 1228 458 1243 q 526 1209 511 1215 q 563 1203 542 1203 q 651 1263 608 1203 l 742 1186 q 671 1099 718 1132 q 571 1065 624 1065 q 514 1074 538 1065 q 463 1097 490 1082 q 422 1116 438 1110 q 386 1122 407 1122 q 297 1063 340 1122 l 207 1139 z ',
    },
    Ò: {
      ha: 1044,
      x_min: 64,
      x_max: 981,
      o:
        'm 522 -11 q 292 44 396 -11 q 126 212 188 100 q 64 486 64 324 q 126 760 64 649 q 292 928 188 872 q 522 983 396 983 q 753 928 649 983 q 919 760 857 872 q 981 486 981 649 q 919 212 981 324 q 753 44 857 100 q 522 -11 649 -11 m 522 156 q 660 191 599 156 q 760 301 722 226 q 797 486 797 375 q 760 672 797 597 q 660 781 722 746 q 522 817 599 817 q 384 781 446 817 q 285 672 322 746 q 247 486 247 597 q 285 301 247 375 q 384 191 322 226 q 522 156 446 156 m 265 1256 l 499 1256 l 592 1039 l 467 1039 l 265 1256 z ',
    },
    Ó: {
      ha: 1044,
      x_min: 64,
      x_max: 981,
      o:
        'm 522 -11 q 292 44 396 -11 q 126 212 188 100 q 64 486 64 324 q 126 760 64 649 q 292 928 188 872 q 522 983 396 983 q 753 928 649 983 q 919 760 857 872 q 981 486 981 649 q 919 212 981 324 q 753 44 857 100 q 522 -11 649 -11 m 522 156 q 660 191 599 156 q 760 301 722 226 q 797 486 797 375 q 760 672 797 597 q 660 781 722 746 q 522 817 599 817 q 384 781 446 817 q 285 672 322 746 q 247 486 247 597 q 285 301 247 375 q 384 191 322 226 q 522 156 446 156 m 546 1256 l 779 1256 l 578 1039 l 453 1039 l 546 1256 z ',
    },
    Ô: {
      ha: 1044,
      x_min: 64,
      x_max: 981,
      o:
        'm 522 -11 q 292 44 396 -11 q 126 212 188 100 q 64 486 64 324 q 126 760 64 649 q 292 928 188 872 q 522 983 396 983 q 753 928 649 983 q 919 760 857 872 q 981 486 981 649 q 919 212 981 324 q 753 44 857 100 q 522 -11 649 -11 m 522 156 q 660 191 599 156 q 760 301 722 226 q 797 486 797 375 q 760 672 797 597 q 660 781 722 746 q 522 817 599 817 q 384 781 446 817 q 285 672 322 746 q 247 486 247 597 q 285 301 247 375 q 384 191 322 226 q 522 156 446 156 m 499 1292 l 546 1292 l 769 1050 l 611 1050 l 522 1146 l 433 1050 l 275 1050 l 499 1292 z ',
    },
    Õ: {
      ha: 1044,
      x_min: 64,
      x_max: 981,
      o:
        'm 522 -11 q 292 44 396 -11 q 126 212 188 100 q 64 486 64 324 q 126 760 64 649 q 292 928 188 872 q 522 983 396 983 q 753 928 649 983 q 919 760 857 872 q 981 486 981 649 q 919 212 981 324 q 753 44 857 100 q 522 -11 649 -11 m 522 156 q 660 191 599 156 q 760 301 722 226 q 797 486 797 375 q 760 672 797 597 q 660 781 722 746 q 522 817 599 817 q 384 781 446 817 q 285 672 322 746 q 247 486 247 597 q 285 301 247 375 q 384 191 322 226 q 522 156 446 156 m 254 1139 q 325 1226 278 1193 q 425 1260 372 1260 q 482 1251 458 1260 q 533 1228 506 1243 q 574 1209 558 1215 q 610 1203 589 1203 q 699 1263 656 1203 l 789 1186 q 718 1099 765 1132 q 618 1065 671 1065 q 561 1074 585 1065 q 510 1097 538 1082 q 469 1116 485 1110 q 433 1122 454 1122 q 344 1063 388 1122 l 254 1139 z ',
    },
    Ö: {
      ha: 1044,
      x_min: 64,
      x_max: 981,
      o:
        'm 522 -11 q 292 44 396 -11 q 126 212 188 100 q 64 486 64 324 q 126 760 64 649 q 292 928 188 872 q 522 983 396 983 q 753 928 649 983 q 919 760 857 872 q 981 486 981 649 q 919 212 981 324 q 753 44 857 100 q 522 -11 649 -11 m 522 156 q 660 191 599 156 q 760 301 722 226 q 797 486 797 375 q 760 672 797 597 q 660 781 722 746 q 522 817 599 817 q 384 781 446 817 q 285 672 322 746 q 247 486 247 597 q 285 301 247 375 q 384 191 322 226 q 522 156 446 156 m 378 1072 q 307 1100 335 1072 q 279 1171 279 1128 q 307 1242 279 1214 q 378 1269 335 1269 q 449 1242 421 1269 q 476 1171 476 1214 q 449 1100 476 1128 q 378 1072 421 1072 m 665 1072 q 594 1100 622 1072 q 567 1171 567 1128 q 594 1242 567 1214 q 665 1269 622 1269 q 736 1242 708 1269 q 764 1171 764 1214 q 736 1100 764 1128 q 665 1072 708 1072 z ',
    },
    '×': {
      ha: 825,
      x_min: 86,
      x_max: 739,
      o:
        'm 86 221 l 307 440 l 86 660 l 193 767 l 413 546 l 632 767 l 739 660 l 518 440 l 739 221 l 632 114 l 413 335 l 193 114 l 86 221 z ',
    },
    Ø: {
      ha: 1044,
      x_min: 64,
      x_max: 981,
      o:
        'm 522 -11 q 292 44 396 -11 q 126 212 188 100 q 64 486 64 324 q 126 760 64 649 q 292 928 188 872 q 522 983 396 983 q 753 928 649 983 q 919 760 857 872 q 981 486 981 649 q 919 212 981 324 q 753 44 857 100 q 522 -11 649 -11 m 522 156 q 660 191 599 156 q 760 301 722 226 q 797 486 797 375 q 760 672 797 597 q 660 781 722 746 q 522 817 599 817 q 384 781 446 817 q 285 672 322 746 q 247 486 247 597 q 285 301 247 375 q 384 191 322 226 q 522 156 446 156 m 75 31 l 850 1029 l 969 942 l 194 -57 l 75 31 z ',
    },
    Ù: {
      ha: 925,
      x_min: 100,
      x_max: 825,
      o:
        'm 463 -11 q 198 85 296 -11 q 100 369 100 181 l 100 972 l 281 972 l 281 367 q 463 156 281 156 q 644 367 644 156 l 644 972 l 825 972 l 825 369 q 727 85 825 181 q 463 -11 629 -11 m 206 1256 l 439 1256 l 532 1039 l 407 1039 l 206 1256 z ',
    },
    Ú: {
      ha: 925,
      x_min: 100,
      x_max: 825,
      o:
        'm 463 -11 q 198 85 296 -11 q 100 369 100 181 l 100 972 l 281 972 l 281 367 q 463 156 281 156 q 644 367 644 156 l 644 972 l 825 972 l 825 369 q 727 85 825 181 q 463 -11 629 -11 m 486 1256 l 719 1256 l 518 1039 l 393 1039 l 486 1256 z ',
    },
    Û: {
      ha: 925,
      x_min: 100,
      x_max: 825,
      o:
        'm 463 -11 q 198 85 296 -11 q 100 369 100 181 l 100 972 l 281 972 l 281 367 q 463 156 281 156 q 644 367 644 156 l 644 972 l 825 972 l 825 369 q 727 85 825 181 q 463 -11 629 -11 m 439 1292 l 486 1292 l 710 1050 l 551 1050 l 463 1146 l 374 1050 l 215 1050 l 439 1292 z ',
    },
    Ü: {
      ha: 925,
      x_min: 100,
      x_max: 825,
      o:
        'm 463 -11 q 198 85 296 -11 q 100 369 100 181 l 100 972 l 281 972 l 281 367 q 463 156 281 156 q 644 367 644 156 l 644 972 l 825 972 l 825 369 q 727 85 825 181 q 463 -11 629 -11 m 318 1072 q 247 1100 275 1072 q 219 1171 219 1128 q 247 1242 219 1214 q 318 1269 275 1269 q 389 1242 361 1269 q 417 1171 417 1214 q 389 1100 417 1128 q 318 1072 361 1072 m 606 1072 q 535 1100 563 1072 q 507 1171 507 1128 q 535 1242 507 1214 q 606 1269 563 1269 q 676 1242 649 1269 q 704 1171 704 1214 q 676 1100 704 1128 q 606 1072 649 1072 z ',
    },
    Ý: {
      ha: 767,
      x_min: 13,
      x_max: 754,
      o:
        'm 293 414 l 13 972 l 207 972 l 383 594 l 560 972 l 754 972 l 474 414 l 474 0 l 293 0 l 293 414 m 407 1256 l 640 1256 l 439 1039 l 314 1039 l 407 1256 z ',
    },
    Þ: {
      ha: 829,
      x_min: 111,
      x_max: 782,
      o:
        'm 111 972 l 292 972 l 292 782 l 478 782 q 704 701 626 782 q 782 486 782 619 q 704 272 782 353 q 478 190 626 190 l 292 190 l 292 0 l 111 0 l 111 972 m 471 357 q 565 389 532 357 q 599 486 599 421 q 565 583 599 551 q 471 615 532 615 l 292 615 l 292 357 l 471 357 z ',
    },
    ß: {
      ha: 801,
      x_min: 44,
      x_max: 738,
      o:
        'm 438 -11 q 338 0 379 -11 l 338 150 q 426 139 393 139 q 571 293 571 139 q 528 415 571 376 q 404 453 486 453 l 358 453 l 358 608 l 386 608 q 472 636 442 608 q 503 721 503 664 q 474 806 503 776 q 397 836 446 836 q 314 801 344 836 q 283 699 283 765 l 283 0 l 117 0 l 117 453 l 44 453 l 44 608 l 117 608 l 117 694 q 193 908 117 833 q 397 983 269 983 q 591 917 522 983 q 660 743 660 850 q 629 624 660 672 q 549 557 599 575 q 688 466 639 529 q 738 289 738 403 q 660 67 738 146 q 438 -11 582 -11 z ',
    },
    à: {
      ha: 732,
      x_min: 61,
      x_max: 649,
      o:
        'm 274 -11 q 121 44 181 -11 q 61 201 61 100 q 140 368 61 306 q 354 431 219 431 l 476 431 l 476 461 q 442 538 476 513 q 354 564 407 564 q 233 483 264 564 l 88 517 q 177 658 104 604 q 354 711 250 711 q 572 637 494 711 q 649 418 649 563 l 649 0 l 507 0 l 489 89 q 274 -11 407 -11 m 319 136 q 429 176 382 136 q 476 281 476 215 l 476 294 l 361 294 q 273 272 304 294 q 242 204 242 250 q 263 155 242 174 q 319 136 285 136 m 100 983 l 333 983 l 426 767 l 301 767 l 100 983 z ',
    },
    á: {
      ha: 732,
      x_min: 61,
      x_max: 649,
      o:
        'm 274 -11 q 121 44 181 -11 q 61 201 61 100 q 140 368 61 306 q 354 431 219 431 l 476 431 l 476 461 q 442 538 476 513 q 354 564 407 564 q 233 483 264 564 l 88 517 q 177 658 104 604 q 354 711 250 711 q 572 637 494 711 q 649 418 649 563 l 649 0 l 507 0 l 489 89 q 274 -11 407 -11 m 319 136 q 429 176 382 136 q 476 281 476 215 l 476 294 l 361 294 q 273 272 304 294 q 242 204 242 250 q 263 155 242 174 q 319 136 285 136 m 381 983 l 614 983 l 413 767 l 288 767 l 381 983 z ',
    },
    â: {
      ha: 732,
      x_min: 61,
      x_max: 649,
      o:
        'm 274 -11 q 121 44 181 -11 q 61 201 61 100 q 140 368 61 306 q 354 431 219 431 l 476 431 l 476 461 q 442 538 476 513 q 354 564 407 564 q 233 483 264 564 l 88 517 q 177 658 104 604 q 354 711 250 711 q 572 637 494 711 q 649 418 649 563 l 649 0 l 507 0 l 489 89 q 274 -11 407 -11 m 319 136 q 429 176 382 136 q 476 281 476 215 l 476 294 l 361 294 q 273 272 304 294 q 242 204 242 250 q 263 155 242 174 q 319 136 285 136 m 333 1019 l 381 1019 l 604 778 l 446 778 l 357 874 l 268 778 l 110 778 l 333 1019 z ',
    },
    ã: {
      ha: 732,
      x_min: 61,
      x_max: 649,
      o:
        'm 274 -11 q 121 44 181 -11 q 61 201 61 100 q 140 368 61 306 q 354 431 219 431 l 476 431 l 476 461 q 442 538 476 513 q 354 564 407 564 q 233 483 264 564 l 88 517 q 177 658 104 604 q 354 711 250 711 q 572 637 494 711 q 649 418 649 563 l 649 0 l 507 0 l 489 89 q 274 -11 407 -11 m 319 136 q 429 176 382 136 q 476 281 476 215 l 476 294 l 361 294 q 273 272 304 294 q 242 204 242 250 q 263 155 242 174 q 319 136 285 136 m 89 867 q 160 954 113 921 q 260 988 207 988 q 317 979 293 988 q 368 956 340 971 q 408 937 393 943 q 444 931 424 931 q 533 990 490 931 l 624 914 q 553 826 600 860 q 453 793 506 793 q 396 801 419 793 q 344 825 372 810 q 304 844 319 838 q 268 850 289 850 q 179 790 222 850 l 89 867 z ',
    },
    ä: {
      ha: 732,
      x_min: 61,
      x_max: 649,
      o:
        'm 274 -11 q 121 44 181 -11 q 61 201 61 100 q 140 368 61 306 q 354 431 219 431 l 476 431 l 476 461 q 442 538 476 513 q 354 564 407 564 q 233 483 264 564 l 88 517 q 177 658 104 604 q 354 711 250 711 q 572 637 494 711 q 649 418 649 563 l 649 0 l 507 0 l 489 89 q 274 -11 407 -11 m 319 136 q 429 176 382 136 q 476 281 476 215 l 476 294 l 361 294 q 273 272 304 294 q 242 204 242 250 q 263 155 242 174 q 319 136 285 136 m 213 800 q 142 828 169 800 q 114 899 114 856 q 142 969 114 942 q 213 997 169 997 q 283 969 256 997 q 311 899 311 942 q 283 828 311 856 q 213 800 256 800 m 500 800 q 429 828 457 800 q 401 899 401 856 q 429 969 401 942 q 500 997 457 997 q 571 969 543 997 q 599 899 599 942 q 571 828 599 856 q 500 800 543 800 z ',
    },
    å: {
      ha: 732,
      x_min: 61,
      x_max: 649,
      o:
        'm 274 -11 q 121 44 181 -11 q 61 201 61 100 q 140 368 61 306 q 354 431 219 431 l 476 431 l 476 461 q 442 538 476 513 q 354 564 407 564 q 233 483 264 564 l 88 517 q 177 658 104 604 q 354 711 250 711 q 572 637 494 711 q 649 418 649 563 l 649 0 l 507 0 l 489 89 q 274 -11 407 -11 m 319 136 q 429 176 382 136 q 476 281 476 215 l 476 294 l 361 294 q 273 272 304 294 q 242 204 242 250 q 263 155 242 174 q 319 136 285 136 m 356 768 q 251 808 293 768 q 208 910 208 849 q 251 1011 208 971 q 356 1051 293 1051 q 460 1011 418 1051 q 503 910 503 971 q 460 808 503 849 q 356 768 418 768 m 356 865 q 388 878 375 865 q 400 910 400 890 q 388 942 400 929 q 356 954 375 954 q 324 942 336 954 q 311 910 311 929 q 324 878 311 890 q 356 865 336 865 z ',
    },
    æ: {
      ha: 1197,
      x_min: 61,
      x_max: 1139,
      o:
        'm 274 -11 q 121 45 181 -11 q 61 201 61 101 q 99 322 61 269 q 204 402 136 374 q 360 431 272 431 l 476 431 l 476 461 q 442 540 476 515 q 354 564 408 564 q 233 483 261 564 l 88 517 q 176 658 104 604 q 354 711 249 711 q 585 626 511 711 q 813 711 674 711 q 996 659 922 711 q 1104 528 1069 607 q 1139 365 1139 449 l 1139 294 l 657 294 q 703 183 660 231 q 822 136 747 136 q 920 163 881 136 q 992 244 960 189 l 1131 193 q 1010 42 1088 94 q 813 -11 933 -11 q 647 28 715 -11 q 535 135 578 68 q 417 22 482 56 q 274 -11 353 -11 m 963 431 q 913 526 950 489 q 813 564 876 564 q 710 524 751 564 q 660 431 669 485 l 963 431 m 314 136 q 427 176 378 136 q 476 281 476 217 l 476 294 l 361 294 q 273 272 304 294 q 242 204 242 249 q 260 156 242 176 q 314 136 279 136 z ',
    },
    ç: {
      ha: 768,
      x_min: 58,
      x_max: 718,
      o:
        'm 400 -11 q 213 37 290 -11 q 97 167 136 85 q 58 350 58 249 q 97 533 58 451 q 213 663 136 615 q 400 711 290 711 q 598 660 517 711 q 718 511 679 610 l 564 449 q 497 535 536 506 q 400 564 457 564 q 280 505 321 564 q 239 350 239 446 q 280 195 239 254 q 400 136 321 136 q 497 165 457 136 q 564 251 536 194 l 718 189 q 598 40 679 90 q 400 -11 517 -11 m 151 -278 l 347 -83 l 472 -83 l 357 -369 l 151 -278 z ',
    },
    è: {
      ha: 779,
      x_min: 58,
      x_max: 721,
      o:
        'm 394 -11 q 205 42 281 -11 q 94 178 129 96 q 58 350 58 261 q 94 522 58 439 q 205 658 129 604 q 394 711 281 711 q 578 659 504 711 q 686 528 651 607 q 721 365 721 449 l 721 294 l 239 294 q 285 183 242 231 q 404 136 329 136 q 502 163 463 136 q 574 244 542 189 l 713 193 q 592 42 669 94 q 394 -11 515 -11 m 544 431 q 495 526 532 489 q 394 564 458 564 q 293 525 333 564 q 243 431 253 486 l 544 431 m 139 983 l 372 983 l 465 767 l 340 767 l 139 983 z ',
    },
    é: {
      ha: 779,
      x_min: 58,
      x_max: 721,
      o:
        'm 394 -11 q 205 42 281 -11 q 94 178 129 96 q 58 350 58 261 q 94 522 58 439 q 205 658 129 604 q 394 711 281 711 q 578 659 504 711 q 686 528 651 607 q 721 365 721 449 l 721 294 l 239 294 q 285 183 242 231 q 404 136 329 136 q 502 163 463 136 q 574 244 542 189 l 713 193 q 592 42 669 94 q 394 -11 515 -11 m 544 431 q 495 526 532 489 q 394 564 458 564 q 293 525 333 564 q 243 431 253 486 l 544 431 m 419 983 l 653 983 l 451 767 l 326 767 l 419 983 z ',
    },
    ê: {
      ha: 779,
      x_min: 58,
      x_max: 721,
      o:
        'm 394 -11 q 205 42 281 -11 q 94 178 129 96 q 58 350 58 261 q 94 522 58 439 q 205 658 129 604 q 394 711 281 711 q 578 659 504 711 q 686 528 651 607 q 721 365 721 449 l 721 294 l 239 294 q 285 183 242 231 q 404 136 329 136 q 502 163 463 136 q 574 244 542 189 l 713 193 q 592 42 669 94 q 394 -11 515 -11 m 544 431 q 495 526 532 489 q 394 564 458 564 q 293 525 333 564 q 243 431 253 486 l 544 431 m 372 1019 l 419 1019 l 643 778 l 485 778 l 396 874 l 307 778 l 149 778 l 372 1019 z ',
    },
    ë: {
      ha: 779,
      x_min: 58,
      x_max: 721,
      o:
        'm 394 -11 q 205 42 281 -11 q 94 178 129 96 q 58 350 58 261 q 94 522 58 439 q 205 658 129 604 q 394 711 281 711 q 578 659 504 711 q 686 528 651 607 q 721 365 721 449 l 721 294 l 239 294 q 285 183 242 231 q 404 136 329 136 q 502 163 463 136 q 574 244 542 189 l 713 193 q 592 42 669 94 q 394 -11 515 -11 m 544 431 q 495 526 532 489 q 394 564 458 564 q 293 525 333 564 q 243 431 253 486 l 544 431 m 251 800 q 181 828 208 800 q 153 899 153 856 q 181 969 153 942 q 251 997 208 997 q 322 969 294 997 q 350 899 350 942 q 322 828 350 856 q 251 800 294 800 m 539 800 q 468 828 496 800 q 440 899 440 856 q 468 969 440 942 q 539 997 496 997 q 610 969 582 997 q 638 899 638 942 q 610 828 638 856 q 539 800 582 800 z ',
    },
    ì: {
      ha: 367,
      x_min: -74,
      x_max: 269,
      o:
        'm 97 700 l 269 700 l 269 0 l 97 0 l 97 700 m -74 983 l 160 983 l 253 767 l 128 767 l -74 983 z ',
    },
    í: {
      ha: 367,
      x_min: 97,
      x_max: 440,
      o:
        'm 97 700 l 269 700 l 269 0 l 97 0 l 97 700 m 207 983 l 440 983 l 239 767 l 114 767 l 207 983 z ',
    },
    î: {
      ha: 367,
      x_min: -64,
      x_max: 431,
      o:
        'm 97 700 l 269 700 l 269 0 l 97 0 l 97 700 m 160 1019 l 207 1019 l 431 778 l 272 778 l 183 874 l 94 778 l -64 778 l 160 1019 z ',
    },
    ï: {
      ha: 367,
      x_min: -60,
      x_max: 425,
      o:
        'm 97 700 l 269 700 l 269 0 l 97 0 l 97 700 m 39 800 q -32 828 -4 800 q -60 899 -60 856 q -32 969 -60 942 q 39 997 -4 997 q 110 969 82 997 q 138 899 138 942 q 110 828 138 856 q 39 800 82 800 m 326 800 q 256 828 283 800 q 228 899 228 856 q 256 969 228 942 q 326 997 283 997 q 397 969 369 997 q 425 899 425 942 q 397 828 425 856 q 326 800 369 800 z ',
    },
    ð: {
      ha: 808,
      x_min: 58,
      x_max: 750,
      o:
        'm 404 -11 q 217 36 294 -11 q 99 165 139 83 q 58 350 58 247 q 99 535 58 453 q 217 664 139 617 q 404 711 294 711 q 517 683 464 711 q 403 807 476 754 l 358 742 l 254 815 l 294 874 q 175 928 225 910 l 261 1054 q 378 996 324 1028 l 424 1063 l 529 990 l 485 925 q 685 699 619 829 q 750 383 750 568 q 710 178 750 267 q 592 39 669 89 q 404 -11 514 -11 m 404 136 q 526 197 483 136 q 569 350 569 258 q 526 503 568 442 q 404 564 483 564 q 282 503 325 564 q 239 350 239 442 q 282 197 239 258 q 404 136 325 136 z ',
    },
    ñ: {
      ha: 799,
      x_min: 97,
      x_max: 701,
      o:
        'm 97 700 l 269 700 l 269 588 q 365 678 310 644 q 486 711 421 711 q 642 657 583 711 q 701 500 701 603 l 701 0 l 529 0 l 529 449 q 502 536 529 508 q 429 564 475 564 q 350 531 386 564 q 292 433 314 497 q 269 279 269 368 l 269 0 l 97 0 l 97 700 m 146 867 q 217 954 169 921 q 317 988 264 988 q 374 979 350 988 q 425 956 397 971 q 465 937 450 943 q 501 931 481 931 q 590 990 547 931 l 681 914 q 610 826 657 860 q 510 793 563 793 q 453 801 476 793 q 401 825 429 810 q 361 844 376 838 q 325 850 346 850 q 236 790 279 850 l 146 867 z ',
    },
    ò: {
      ha: 828,
      x_min: 58,
      x_max: 769,
      o:
        'm 414 -11 q 224 36 304 -11 q 101 165 143 83 q 58 350 58 247 q 101 535 58 453 q 224 664 143 617 q 414 711 304 711 q 604 664 524 711 q 727 535 685 617 q 769 350 769 453 q 727 165 769 247 q 604 36 685 83 q 414 -11 524 -11 m 414 136 q 542 198 494 136 q 589 350 589 260 q 542 502 589 440 q 414 564 494 564 q 286 502 333 564 q 239 350 239 440 q 286 198 239 260 q 414 136 333 136 m 157 983 l 390 983 l 483 767 l 358 767 l 157 983 z ',
    },
    ó: {
      ha: 828,
      x_min: 58,
      x_max: 769,
      o:
        'm 414 -11 q 224 36 304 -11 q 101 165 143 83 q 58 350 58 247 q 101 535 58 453 q 224 664 143 617 q 414 711 304 711 q 604 664 524 711 q 727 535 685 617 q 769 350 769 453 q 727 165 769 247 q 604 36 685 83 q 414 -11 524 -11 m 414 136 q 542 198 494 136 q 589 350 589 260 q 542 502 589 440 q 414 564 494 564 q 286 502 333 564 q 239 350 239 440 q 286 198 239 260 q 414 136 333 136 m 438 983 l 671 983 l 469 767 l 344 767 l 438 983 z ',
    },
    ô: {
      ha: 828,
      x_min: 58,
      x_max: 769,
      o:
        'm 414 -11 q 224 36 304 -11 q 101 165 143 83 q 58 350 58 247 q 101 535 58 453 q 224 664 143 617 q 414 711 304 711 q 604 664 524 711 q 727 535 685 617 q 769 350 769 453 q 727 165 769 247 q 604 36 685 83 q 414 -11 524 -11 m 414 136 q 542 198 494 136 q 589 350 589 260 q 542 502 589 440 q 414 564 494 564 q 286 502 333 564 q 239 350 239 440 q 286 198 239 260 q 414 136 333 136 m 390 1019 l 438 1019 l 661 778 l 503 778 l 414 874 l 325 778 l 167 778 l 390 1019 z ',
    },
    õ: {
      ha: 828,
      x_min: 58,
      x_max: 769,
      o:
        'm 414 -11 q 224 36 304 -11 q 101 165 143 83 q 58 350 58 247 q 101 535 58 453 q 224 664 143 617 q 414 711 304 711 q 604 664 524 711 q 727 535 685 617 q 769 350 769 453 q 727 165 769 247 q 604 36 685 83 q 414 -11 524 -11 m 414 136 q 542 198 494 136 q 589 350 589 260 q 542 502 589 440 q 414 564 494 564 q 286 502 333 564 q 239 350 239 440 q 286 198 239 260 q 414 136 333 136 m 146 867 q 217 954 169 921 q 317 988 264 988 q 374 979 350 988 q 425 956 397 971 q 465 937 450 943 q 501 931 481 931 q 590 990 547 931 l 681 914 q 610 826 657 860 q 510 793 563 793 q 453 801 476 793 q 401 825 429 810 q 361 844 376 838 q 325 850 346 850 q 236 790 279 850 l 146 867 z ',
    },
    ö: {
      ha: 828,
      x_min: 58,
      x_max: 769,
      o:
        'm 414 -11 q 224 36 304 -11 q 101 165 143 83 q 58 350 58 247 q 101 535 58 453 q 224 664 143 617 q 414 711 304 711 q 604 664 524 711 q 727 535 685 617 q 769 350 769 453 q 727 165 769 247 q 604 36 685 83 q 414 -11 524 -11 m 414 136 q 542 198 494 136 q 589 350 589 260 q 542 502 589 440 q 414 564 494 564 q 286 502 333 564 q 239 350 239 440 q 286 198 239 260 q 414 136 333 136 m 269 800 q 199 828 226 800 q 171 899 171 856 q 199 969 171 942 q 269 997 226 997 q 340 969 313 997 q 368 899 368 942 q 340 828 368 856 q 269 800 313 800 m 557 800 q 486 828 514 800 q 458 899 458 856 q 486 969 458 942 q 557 997 514 997 q 628 969 600 997 q 656 899 656 942 q 628 828 656 856 q 557 800 600 800 z ',
    },
    '÷': {
      ha: 842,
      x_min: 90,
      x_max: 751,
      o:
        'm 421 586 q 338 619 371 586 q 304 703 304 653 q 338 786 304 753 q 421 819 371 819 q 504 786 471 819 q 538 703 538 753 q 504 619 538 653 q 421 586 471 586 m 90 513 l 751 513 l 751 363 l 90 363 l 90 513 m 421 56 q 338 89 371 56 q 304 172 304 122 q 338 256 304 222 q 421 289 371 289 q 504 256 471 289 q 538 172 538 222 q 504 89 538 122 q 421 56 471 56 z ',
    },
    ø: {
      ha: 828,
      x_min: 49,
      x_max: 779,
      o:
        'm 414 -11 q 224 36 304 -11 q 101 165 143 83 q 58 350 58 247 q 101 535 58 453 q 224 664 143 617 q 414 711 304 711 q 604 664 524 711 q 727 535 685 617 q 769 350 769 453 q 727 165 769 247 q 604 36 685 83 q 414 -11 524 -11 m 414 136 q 542 198 494 136 q 589 350 589 260 q 542 502 589 440 q 414 564 494 564 q 286 502 333 564 q 239 350 239 440 q 286 198 239 260 q 414 136 333 136 m 49 4 l 660 783 l 779 696 l 168 -83 l 49 4 z ',
    },
    ù: {
      ha: 799,
      x_min: 97,
      x_max: 701,
      o:
        'm 313 -11 q 156 43 215 -11 q 97 200 97 97 l 97 700 l 269 700 l 269 251 q 297 164 269 192 q 369 136 324 136 q 449 169 413 136 q 507 267 485 203 q 529 421 529 332 l 529 700 l 701 700 l 701 0 l 529 0 l 529 113 q 433 22 489 56 q 313 -11 378 -11 m 142 983 l 375 983 l 468 767 l 343 767 l 142 983 z ',
    },
    ú: {
      ha: 799,
      x_min: 97,
      x_max: 701,
      o:
        'm 313 -11 q 156 43 215 -11 q 97 200 97 97 l 97 700 l 269 700 l 269 251 q 297 164 269 192 q 369 136 324 136 q 449 169 413 136 q 507 267 485 203 q 529 421 529 332 l 529 700 l 701 700 l 701 0 l 529 0 l 529 113 q 433 22 489 56 q 313 -11 378 -11 m 422 983 l 656 983 l 454 767 l 329 767 l 422 983 z ',
    },
    û: {
      ha: 799,
      x_min: 97,
      x_max: 701,
      o:
        'm 313 -11 q 156 43 215 -11 q 97 200 97 97 l 97 700 l 269 700 l 269 251 q 297 164 269 192 q 369 136 324 136 q 449 169 413 136 q 507 267 485 203 q 529 421 529 332 l 529 700 l 701 700 l 701 0 l 529 0 l 529 113 q 433 22 489 56 q 313 -11 378 -11 m 375 1019 l 422 1019 l 646 778 l 488 778 l 399 874 l 310 778 l 151 778 l 375 1019 z ',
    },
    ü: {
      ha: 799,
      x_min: 97,
      x_max: 701,
      o:
        'm 313 -11 q 156 43 215 -11 q 97 200 97 97 l 97 700 l 269 700 l 269 251 q 297 164 269 192 q 369 136 324 136 q 449 169 413 136 q 507 267 485 203 q 529 421 529 332 l 529 700 l 701 700 l 701 0 l 529 0 l 529 113 q 433 22 489 56 q 313 -11 378 -11 m 254 800 q 183 828 211 800 q 156 899 156 856 q 183 969 156 942 q 254 997 211 997 q 325 969 297 997 q 353 899 353 942 q 325 828 353 856 q 254 800 297 800 m 542 800 q 471 828 499 800 q 443 899 443 856 q 471 969 443 942 q 542 997 499 997 q 613 969 585 997 q 640 899 640 942 q 613 828 640 856 q 542 800 585 800 z ',
    },
    ý: {
      ha: 689,
      x_min: 14,
      x_max: 675,
      o:
        'm 268 44 l 14 700 l 188 700 l 350 261 l 503 700 l 675 700 l 314 -283 l 147 -283 l 268 44 m 368 983 l 601 983 l 400 767 l 275 767 l 368 983 z ',
    },
    þ: {
      ha: 817,
      x_min: 97,
      x_max: 758,
      o:
        'm 97 983 l 269 983 l 269 629 q 333 685 286 660 q 439 711 379 711 q 676 613 593 711 q 758 350 758 515 q 676 87 758 185 q 439 -11 593 -11 q 340 11 388 -11 q 269 64 293 33 l 269 -283 l 97 -283 l 97 983 m 415 136 q 532 193 486 136 q 578 350 578 250 q 532 508 578 451 q 415 564 486 564 q 299 508 344 564 q 254 350 254 451 q 299 192 254 249 q 415 136 344 136 z ',
    },
    ÿ: {
      ha: 689,
      x_min: 14,
      x_max: 675,
      o:
        'm 268 44 l 14 700 l 188 700 l 350 261 l 503 700 l 675 700 l 314 -283 l 147 -283 l 268 44 m 200 800 q 129 828 157 800 q 101 899 101 856 q 129 969 101 942 q 200 997 157 997 q 271 969 243 997 q 299 899 299 942 q 271 828 299 856 q 200 800 243 800 m 488 800 q 417 828 444 800 q 389 899 389 856 q 417 969 389 942 q 488 997 444 997 q 558 969 531 997 q 586 899 586 942 q 558 828 586 856 q 488 800 531 800 z ',
    },
    Ā: {
      ha: 867,
      x_min: 14,
      x_max: 853,
      o:
        'm 343 972 l 524 972 l 853 0 l 658 0 l 588 229 l 279 229 l 208 0 l 14 0 l 343 972 m 536 396 l 433 733 l 331 396 l 536 396 m 246 1233 l 619 1233 l 619 1097 l 246 1097 l 246 1233 z ',
    },
    ā: {
      ha: 732,
      x_min: 61,
      x_max: 649,
      o:
        'm 274 -11 q 121 44 181 -11 q 61 201 61 100 q 140 368 61 306 q 354 431 219 431 l 476 431 l 476 461 q 442 538 476 513 q 354 564 407 564 q 233 483 264 564 l 88 517 q 177 658 104 604 q 354 711 250 711 q 572 637 494 711 q 649 418 649 563 l 649 0 l 507 0 l 489 89 q 274 -11 407 -11 m 319 136 q 429 176 382 136 q 476 281 476 215 l 476 294 l 361 294 q 273 272 304 294 q 242 204 242 250 q 263 155 242 174 q 319 136 285 136 m 169 961 l 543 961 l 543 825 l 169 825 l 169 961 z ',
    },
    Ă: {
      ha: 867,
      x_min: 14,
      x_max: 853,
      o:
        'm 343 972 l 524 972 l 853 0 l 658 0 l 588 229 l 279 229 l 208 0 l 14 0 l 343 972 m 536 396 l 433 733 l 331 396 l 536 396 m 444 1093 q 326 1138 371 1093 q 281 1244 281 1182 l 407 1244 q 417 1217 407 1228 q 444 1206 428 1206 q 472 1217 461 1206 q 482 1244 482 1228 l 608 1244 q 563 1138 608 1182 q 444 1093 518 1093 z ',
    },
    ă: {
      ha: 732,
      x_min: 61,
      x_max: 649,
      o:
        'm 274 -11 q 121 44 181 -11 q 61 201 61 100 q 140 368 61 306 q 354 431 219 431 l 476 431 l 476 461 q 442 538 476 513 q 354 564 407 564 q 233 483 264 564 l 88 517 q 177 658 104 604 q 354 711 250 711 q 572 637 494 711 q 649 418 649 563 l 649 0 l 507 0 l 489 89 q 274 -11 407 -11 m 319 136 q 429 176 382 136 q 476 281 476 215 l 476 294 l 361 294 q 273 272 304 294 q 242 204 242 250 q 263 155 242 174 q 319 136 285 136 m 368 821 q 249 865 294 821 q 204 972 204 910 l 331 972 q 341 944 331 956 q 368 933 351 933 q 395 944 385 933 q 406 972 406 956 l 532 972 q 487 865 532 910 q 368 821 442 821 z ',
    },
    Ą: {
      ha: 867,
      x_min: 14,
      x_max: 879,
      o:
        'm 343 972 l 524 972 l 853 0 l 658 0 l 588 229 l 279 229 l 208 0 l 14 0 l 343 972 m 536 396 l 433 733 l 331 396 l 536 396 m 789 -257 q 691 -224 728 -257 q 654 -132 654 -190 q 676 -58 654 -93 q 733 0 699 -22 l 853 0 q 772 -108 772 -65 q 781 -135 772 -125 q 808 -144 790 -144 q 851 -131 828 -144 l 879 -236 q 789 -257 840 -257 z ',
    },
    ą: {
      ha: 760,
      x_min: 61,
      x_max: 675,
      o:
        'm 675 -236 q 585 -257 636 -257 q 487 -224 524 -257 q 450 -132 450 -190 q 472 -58 450 -93 q 529 0 494 -22 l 507 0 l 489 89 q 274 -11 407 -11 q 121 44 181 -11 q 61 201 61 100 q 140 368 61 306 q 354 431 219 431 l 476 431 l 476 461 q 442 538 476 513 q 354 564 407 564 q 233 483 264 564 l 88 517 q 177 658 104 604 q 354 711 250 711 q 572 637 494 711 q 649 418 649 563 l 649 0 q 568 -108 568 -65 q 577 -135 568 -125 q 604 -144 586 -144 q 647 -131 624 -144 l 675 -236 m 476 294 l 361 294 q 273 272 304 294 q 242 204 242 250 q 263 155 242 174 q 319 136 285 136 q 429 176 382 136 q 476 281 476 215 l 476 294 z ',
    },
    Ć: {
      ha: 985,
      x_min: 64,
      x_max: 926,
      o:
        'm 524 -11 q 294 47 399 -11 q 126 217 189 104 q 64 486 64 329 q 126 756 64 643 q 294 926 189 868 q 524 983 399 983 q 787 906 682 983 q 926 689 892 829 l 764 647 q 676 772 733 728 q 524 817 619 817 q 383 780 446 817 q 284 669 321 743 q 247 486 247 594 q 284 303 247 378 q 383 192 321 229 q 524 156 446 156 q 676 200 619 156 q 764 325 733 244 l 926 283 q 787 66 892 143 q 524 -11 682 -11 m 547 1256 l 781 1256 l 579 1039 l 454 1039 l 547 1256 z ',
    },
    ć: {
      ha: 768,
      x_min: 58,
      x_max: 718,
      o:
        'm 400 -11 q 213 37 290 -11 q 97 167 136 85 q 58 350 58 249 q 97 533 58 451 q 213 663 136 615 q 400 711 290 711 q 598 660 517 711 q 718 511 679 610 l 564 449 q 497 535 536 506 q 400 564 457 564 q 280 505 321 564 q 239 350 239 446 q 280 195 239 254 q 400 136 321 136 q 497 165 457 136 q 564 251 536 194 l 718 189 q 598 40 679 90 q 400 -11 517 -11 m 425 983 l 658 983 l 457 767 l 332 767 l 425 983 z ',
    },
    Ĉ: {
      ha: 985,
      x_min: 64,
      x_max: 926,
      o:
        'm 524 -11 q 294 47 399 -11 q 126 217 189 104 q 64 486 64 329 q 126 756 64 643 q 294 926 189 868 q 524 983 399 983 q 787 906 682 983 q 926 689 892 829 l 764 647 q 676 772 733 728 q 524 817 619 817 q 383 780 446 817 q 284 669 321 743 q 247 486 247 594 q 284 303 247 378 q 383 192 321 229 q 524 156 446 156 q 676 200 619 156 q 764 325 733 244 l 926 283 q 787 66 892 143 q 524 -11 682 -11 m 500 1292 l 547 1292 l 771 1050 l 613 1050 l 524 1146 l 435 1050 l 276 1050 l 500 1292 z ',
    },
    ĉ: {
      ha: 768,
      x_min: 58,
      x_max: 718,
      o:
        'm 400 -11 q 213 37 290 -11 q 97 167 136 85 q 58 350 58 249 q 97 533 58 451 q 213 663 136 615 q 400 711 290 711 q 598 660 517 711 q 718 511 679 610 l 564 449 q 497 535 536 506 q 400 564 457 564 q 280 505 321 564 q 239 350 239 446 q 280 195 239 254 q 400 136 321 136 q 497 165 457 136 q 564 251 536 194 l 718 189 q 598 40 679 90 q 400 -11 517 -11 m 378 1019 l 425 1019 l 649 778 l 490 778 l 401 874 l 313 778 l 154 778 l 378 1019 z ',
    },
    Ċ: {
      ha: 985,
      x_min: 64,
      x_max: 926,
      o:
        'm 524 -11 q 294 47 399 -11 q 126 217 189 104 q 64 486 64 329 q 126 756 64 643 q 294 926 189 868 q 524 983 399 983 q 787 906 682 983 q 926 689 892 829 l 764 647 q 676 772 733 728 q 524 817 619 817 q 383 780 446 817 q 284 669 321 743 q 247 486 247 594 q 284 303 247 378 q 383 192 321 229 q 524 156 446 156 q 676 200 619 156 q 764 325 733 244 l 926 283 q 787 66 892 143 q 524 -11 682 -11 m 524 1063 q 444 1094 476 1063 q 413 1174 413 1126 q 444 1253 413 1221 q 524 1285 476 1285 q 603 1253 571 1285 q 635 1174 635 1221 q 603 1094 635 1126 q 524 1063 571 1063 z ',
    },
    ċ: {
      ha: 768,
      x_min: 58,
      x_max: 718,
      o:
        'm 400 -11 q 213 37 290 -11 q 97 167 136 85 q 58 350 58 249 q 97 533 58 451 q 213 663 136 615 q 400 711 290 711 q 598 660 517 711 q 718 511 679 610 l 564 449 q 497 535 536 506 q 400 564 457 564 q 280 505 321 564 q 239 350 239 446 q 280 195 239 254 q 400 136 321 136 q 497 165 457 136 q 564 251 536 194 l 718 189 q 598 40 679 90 q 400 -11 517 -11 m 401 790 q 322 822 354 790 q 290 901 290 854 q 322 981 290 949 q 401 1013 354 1013 q 481 981 449 1013 q 513 901 513 949 q 481 822 513 854 q 401 790 449 790 z ',
    },
    Č: {
      ha: 985,
      x_min: 64,
      x_max: 926,
      o:
        'm 524 -11 q 294 47 399 -11 q 126 217 189 104 q 64 486 64 329 q 126 756 64 643 q 294 926 189 868 q 524 983 399 983 q 787 906 682 983 q 926 689 892 829 l 764 647 q 676 772 733 728 q 524 817 619 817 q 383 780 446 817 q 284 669 321 743 q 247 486 247 594 q 284 303 247 378 q 383 192 321 229 q 524 156 446 156 q 676 200 619 156 q 764 325 733 244 l 926 283 q 787 66 892 143 q 524 -11 682 -11 m 276 1292 l 435 1292 l 524 1196 l 613 1292 l 771 1292 l 547 1050 l 500 1050 l 276 1292 z ',
    },
    č: {
      ha: 768,
      x_min: 58,
      x_max: 718,
      o:
        'm 400 -11 q 213 37 290 -11 q 97 167 136 85 q 58 350 58 249 q 97 533 58 451 q 213 663 136 615 q 400 711 290 711 q 598 660 517 711 q 718 511 679 610 l 564 449 q 497 535 536 506 q 400 564 457 564 q 280 505 321 564 q 239 350 239 446 q 280 195 239 254 q 400 136 321 136 q 497 165 457 136 q 564 251 536 194 l 718 189 q 598 40 679 90 q 400 -11 517 -11 m 154 1019 l 313 1019 l 401 924 l 490 1019 l 649 1019 l 425 778 l 378 778 l 154 1019 z ',
    },
    Ď: {
      ha: 932,
      x_min: 111,
      x_max: 868,
      o:
        'm 111 972 l 415 972 q 639 919 536 972 q 805 758 742 867 q 868 486 868 649 q 805 215 868 324 q 639 53 742 106 q 415 0 536 0 l 111 0 l 111 972 m 358 167 q 591 238 497 167 q 685 486 685 310 q 591 734 685 663 q 358 806 497 806 l 292 806 l 292 167 l 358 167 m 131 1292 l 289 1292 l 378 1196 l 467 1292 l 625 1292 l 401 1050 l 354 1050 l 131 1292 z ',
    },
    ď: {
      ha: 1028,
      x_min: 58,
      x_max: 1028,
      o:
        'm 364 -11 q 138 87 218 -11 q 58 350 58 185 q 138 613 58 515 q 364 711 218 711 q 473 690 424 711 q 547 636 522 668 l 547 983 l 719 983 l 719 0 l 547 0 l 547 72 q 481 15 531 40 q 364 -11 432 -11 m 401 136 q 517 192 472 136 q 563 350 563 249 q 517 508 563 451 q 401 564 472 564 q 285 508 331 564 q 239 350 239 451 q 285 193 239 250 q 401 136 331 136 m 839 1008 l 1028 1008 l 914 753 l 804 753 l 839 1008 z ',
    },
    Đ: {
      ha: 932,
      x_min: 10,
      x_max: 868,
      o:
        'm 111 972 l 415 972 q 639 919 536 972 q 805 758 742 867 q 868 486 868 649 q 805 215 868 324 q 639 53 742 106 q 415 0 536 0 l 111 0 l 111 972 m 358 167 q 591 238 497 167 q 685 486 685 310 q 591 734 685 663 q 358 806 497 806 l 292 806 l 292 167 l 358 167 m 10 561 l 449 561 l 449 411 l 10 411 l 10 561 z ',
    },
    đ: {
      ha: 817,
      x_min: 58,
      x_max: 797,
      o:
        'm 364 -11 q 138 87 218 -11 q 58 350 58 185 q 138 613 58 515 q 364 711 218 711 q 473 690 424 711 q 547 636 522 668 l 547 983 l 719 983 l 719 0 l 547 0 l 547 72 q 481 15 531 40 q 364 -11 432 -11 m 401 136 q 517 192 472 136 q 563 350 563 249 q 517 508 563 451 q 401 564 472 564 q 285 508 331 564 q 239 350 239 451 q 285 193 239 250 q 401 136 331 136 m 371 906 l 797 906 l 797 778 l 371 778 l 371 906 z ',
    },
    Ē: {
      ha: 796,
      x_min: 111,
      x_max: 726,
      o:
        'm 111 972 l 713 972 l 713 806 l 292 806 l 292 601 l 629 601 l 629 435 l 292 435 l 292 167 l 726 167 l 726 0 l 111 0 l 111 972 m 226 1233 l 600 1233 l 600 1097 l 226 1097 l 226 1233 z ',
    },
    ē: {
      ha: 779,
      x_min: 58,
      x_max: 721,
      o:
        'm 394 -11 q 205 42 281 -11 q 94 178 129 96 q 58 350 58 261 q 94 522 58 439 q 205 658 129 604 q 394 711 281 711 q 578 659 504 711 q 686 528 651 607 q 721 365 721 449 l 721 294 l 239 294 q 285 183 242 231 q 404 136 329 136 q 502 163 463 136 q 574 244 542 189 l 713 193 q 592 42 669 94 q 394 -11 515 -11 m 544 431 q 495 526 532 489 q 394 564 458 564 q 293 525 333 564 q 243 431 253 486 l 544 431 m 208 961 l 582 961 l 582 825 l 208 825 l 208 961 z ',
    },
    Ĕ: {
      ha: 796,
      x_min: 111,
      x_max: 726,
      o:
        'm 111 972 l 713 972 l 713 806 l 292 806 l 292 601 l 629 601 l 629 435 l 292 435 l 292 167 l 726 167 l 726 0 l 111 0 l 111 972 m 425 1093 q 306 1138 351 1093 q 261 1244 261 1182 l 388 1244 q 398 1217 388 1228 q 425 1206 408 1206 q 452 1217 442 1206 q 463 1244 463 1228 l 589 1244 q 544 1138 589 1182 q 425 1093 499 1093 z ',
    },
    ĕ: {
      ha: 779,
      x_min: 58,
      x_max: 721,
      o:
        'm 394 -11 q 205 42 281 -11 q 94 178 129 96 q 58 350 58 261 q 94 522 58 439 q 205 658 129 604 q 394 711 281 711 q 578 659 504 711 q 686 528 651 607 q 721 365 721 449 l 721 294 l 239 294 q 285 183 242 231 q 404 136 329 136 q 502 163 463 136 q 574 244 542 189 l 713 193 q 592 42 669 94 q 394 -11 515 -11 m 544 431 q 495 526 532 489 q 394 564 458 564 q 293 525 333 564 q 243 431 253 486 l 544 431 m 407 821 q 288 865 333 821 q 243 972 243 910 l 369 972 q 380 944 369 956 q 407 933 390 933 q 434 944 424 933 q 444 972 444 956 l 571 972 q 526 865 571 910 q 407 821 481 821 z ',
    },
    Ė: {
      ha: 796,
      x_min: 111,
      x_max: 726,
      o:
        'm 111 972 l 713 972 l 713 806 l 292 806 l 292 601 l 629 601 l 629 435 l 292 435 l 292 167 l 726 167 l 726 0 l 111 0 l 111 972 m 414 1063 q 335 1094 367 1063 q 303 1174 303 1126 q 335 1253 303 1221 q 414 1285 367 1285 q 493 1253 461 1285 q 525 1174 525 1221 q 493 1094 525 1126 q 414 1063 461 1063 z ',
    },
    ė: {
      ha: 779,
      x_min: 58,
      x_max: 721,
      o:
        'm 394 -11 q 205 42 281 -11 q 94 178 129 96 q 58 350 58 261 q 94 522 58 439 q 205 658 129 604 q 394 711 281 711 q 578 659 504 711 q 686 528 651 607 q 721 365 721 449 l 721 294 l 239 294 q 285 183 242 231 q 404 136 329 136 q 502 163 463 136 q 574 244 542 189 l 713 193 q 592 42 669 94 q 394 -11 515 -11 m 544 431 q 495 526 532 489 q 394 564 458 564 q 293 525 333 564 q 243 431 253 486 l 544 431 m 396 790 q 317 822 349 790 q 285 901 285 854 q 317 981 285 949 q 396 1013 349 1013 q 475 981 443 1013 q 507 901 507 949 q 475 822 507 854 q 396 790 443 790 z ',
    },
    Ę: {
      ha: 796,
      x_min: 111,
      x_max: 753,
      o:
        'm 111 972 l 713 972 l 713 806 l 292 806 l 292 601 l 629 601 l 629 435 l 292 435 l 292 167 l 726 167 l 726 0 l 111 0 l 111 972 m 663 -257 q 565 -224 601 -257 q 528 -132 528 -190 q 550 -58 528 -93 q 607 0 572 -22 l 726 0 q 646 -108 646 -65 q 655 -135 646 -125 q 682 -144 664 -144 q 725 -131 701 -144 l 753 -236 q 663 -257 714 -257 z ',
    },
    ę: {
      ha: 779,
      x_min: 58,
      x_max: 721,
      o:
        'm 394 -11 q 205 42 281 -11 q 94 178 129 96 q 58 350 58 261 q 94 522 58 439 q 205 658 129 604 q 394 711 281 711 q 578 659 504 711 q 686 528 651 607 q 721 365 721 449 l 721 294 l 239 294 q 285 183 242 231 q 404 136 329 136 q 502 163 463 136 q 574 244 542 189 l 713 193 q 592 42 669 94 q 394 -11 515 -11 m 544 431 q 495 526 532 489 q 394 564 458 564 q 293 525 333 564 q 243 431 253 486 l 544 431 m 431 -257 q 333 -224 369 -257 q 296 -132 296 -190 q 318 -58 296 -93 q 375 0 340 -22 l 494 0 q 414 -108 414 -65 q 423 -135 414 -125 q 450 -144 432 -144 q 493 -131 469 -144 l 521 -236 q 431 -257 482 -257 z ',
    },
    Ě: {
      ha: 796,
      x_min: 111,
      x_max: 726,
      o:
        'm 111 972 l 713 972 l 713 806 l 292 806 l 292 601 l 629 601 l 629 435 l 292 435 l 292 167 l 726 167 l 726 0 l 111 0 l 111 972 m 167 1292 l 325 1292 l 414 1196 l 503 1292 l 661 1292 l 438 1050 l 390 1050 l 167 1292 z ',
    },
    ě: {
      ha: 779,
      x_min: 58,
      x_max: 721,
      o:
        'm 394 -11 q 205 42 281 -11 q 94 178 129 96 q 58 350 58 261 q 94 522 58 439 q 205 658 129 604 q 394 711 281 711 q 578 659 504 711 q 686 528 651 607 q 721 365 721 449 l 721 294 l 239 294 q 285 183 242 231 q 404 136 329 136 q 502 163 463 136 q 574 244 542 189 l 713 193 q 592 42 669 94 q 394 -11 515 -11 m 544 431 q 495 526 532 489 q 394 564 458 564 q 293 525 333 564 q 243 431 253 486 l 544 431 m 149 1019 l 307 1019 l 396 924 l 485 1019 l 643 1019 l 419 778 l 372 778 l 149 1019 z ',
    },
    Ĝ: {
      ha: 1011,
      x_min: 64,
      x_max: 931,
      o:
        'm 513 -11 q 290 45 392 -11 q 126 214 188 101 q 64 486 64 326 q 128 758 64 646 q 297 926 192 869 q 526 983 403 983 q 788 899 683 983 q 931 676 892 815 l 765 633 q 526 817 690 817 q 325 733 403 817 q 247 486 247 649 q 324 238 247 319 q 522 156 400 156 q 676 210 621 156 q 740 340 731 265 l 560 340 l 560 490 l 915 490 l 915 0 l 764 0 l 749 104 q 658 22 717 54 q 513 -11 599 -11 m 503 1292 l 550 1292 l 774 1050 l 615 1050 l 526 1146 l 438 1050 l 279 1050 l 503 1292 z ',
    },
    ĝ: {
      ha: 707,
      x_min: 43,
      x_max: 688,
      o:
        'm 360 -294 q 131 -235 219 -294 q 43 -64 43 -175 q 100 75 43 22 q 64 183 64 118 q 87 269 64 232 q 150 331 110 307 q 101 475 101 390 q 135 599 101 546 q 228 682 169 653 q 358 711 288 711 q 488 681 426 711 l 619 750 l 688 636 l 588 586 q 615 475 615 538 q 581 351 615 404 q 488 269 547 297 q 358 242 429 242 q 257 257 306 242 q 224 204 224 238 q 240 166 224 179 q 289 153 257 153 l 432 153 q 611 99 544 153 q 678 -53 678 46 q 633 -189 678 -135 q 515 -269 588 -243 q 360 -294 443 -294 m 358 381 q 427 407 400 381 q 454 475 454 433 q 427 545 454 518 q 358 572 400 572 q 290 545 317 572 q 263 475 263 518 q 290 407 263 433 q 358 381 317 381 m 360 -150 q 466 -129 426 -150 q 506 -64 506 -108 q 476 -8 506 -24 q 393 8 447 8 l 299 8 q 218 14 251 8 q 203 -50 203 -10 q 246 -124 203 -99 q 360 -150 289 -150 m 336 1019 l 383 1019 l 607 778 l 449 778 l 360 874 l 271 778 l 113 778 l 336 1019 z ',
    },
    Ğ: {
      ha: 1011,
      x_min: 64,
      x_max: 931,
      o:
        'm 513 -11 q 290 45 392 -11 q 126 214 188 101 q 64 486 64 326 q 128 758 64 646 q 297 926 192 869 q 526 983 403 983 q 788 899 683 983 q 931 676 892 815 l 765 633 q 526 817 690 817 q 325 733 403 817 q 247 486 247 649 q 324 238 247 319 q 522 156 400 156 q 676 210 621 156 q 740 340 731 265 l 560 340 l 560 490 l 915 490 l 915 0 l 764 0 l 749 104 q 658 22 717 54 q 513 -11 599 -11 m 538 1093 q 419 1138 464 1093 q 374 1244 374 1182 l 500 1244 q 510 1217 500 1228 q 538 1206 521 1206 q 565 1217 554 1206 q 575 1244 575 1228 l 701 1244 q 656 1138 701 1182 q 538 1093 611 1093 z ',
    },
    ğ: {
      ha: 707,
      x_min: 43,
      x_max: 688,
      o:
        'm 360 -294 q 131 -235 219 -294 q 43 -64 43 -175 q 100 75 43 22 q 64 183 64 118 q 87 269 64 232 q 150 331 110 307 q 101 475 101 390 q 135 599 101 546 q 228 682 169 653 q 358 711 288 711 q 488 681 426 711 l 619 750 l 688 636 l 588 586 q 615 475 615 538 q 581 351 615 404 q 488 269 547 297 q 358 242 429 242 q 257 257 306 242 q 224 204 224 238 q 240 166 224 179 q 289 153 257 153 l 432 153 q 611 99 544 153 q 678 -53 678 46 q 633 -189 678 -135 q 515 -269 588 -243 q 360 -294 443 -294 m 358 381 q 427 407 400 381 q 454 475 454 433 q 427 545 454 518 q 358 572 400 572 q 290 545 317 572 q 263 475 263 518 q 290 407 263 433 q 358 381 317 381 m 360 -150 q 466 -129 426 -150 q 506 -64 506 -108 q 476 -8 506 -24 q 393 8 447 8 l 299 8 q 218 14 251 8 q 203 -50 203 -10 q 246 -124 203 -99 q 360 -150 289 -150 m 371 821 q 252 865 297 821 q 207 972 207 910 l 333 972 q 344 944 333 956 q 371 933 354 933 q 398 944 388 933 q 408 972 408 956 l 535 972 q 490 865 535 910 q 371 821 444 821 z ',
    },
    Ġ: {
      ha: 1011,
      x_min: 64,
      x_max: 931,
      o:
        'm 513 -11 q 290 45 392 -11 q 126 214 188 101 q 64 486 64 326 q 128 758 64 646 q 297 926 192 869 q 526 983 403 983 q 788 899 683 983 q 931 676 892 815 l 765 633 q 526 817 690 817 q 325 733 403 817 q 247 486 247 649 q 324 238 247 319 q 522 156 400 156 q 676 210 621 156 q 740 340 731 265 l 560 340 l 560 490 l 915 490 l 915 0 l 764 0 l 749 104 q 658 22 717 54 q 513 -11 599 -11 m 526 1063 q 447 1094 479 1063 q 415 1174 415 1126 q 447 1253 415 1221 q 526 1285 479 1285 q 606 1253 574 1285 q 638 1174 638 1221 q 606 1094 638 1126 q 526 1063 574 1063 z ',
    },
    ġ: {
      ha: 707,
      x_min: 43,
      x_max: 688,
      o:
        'm 360 -294 q 131 -235 219 -294 q 43 -64 43 -175 q 100 75 43 22 q 64 183 64 118 q 87 269 64 232 q 150 331 110 307 q 101 475 101 390 q 135 599 101 546 q 228 682 169 653 q 358 711 288 711 q 488 681 426 711 l 619 750 l 688 636 l 588 586 q 615 475 615 538 q 581 351 615 404 q 488 269 547 297 q 358 242 429 242 q 257 257 306 242 q 224 204 224 238 q 240 166 224 179 q 289 153 257 153 l 432 153 q 611 99 544 153 q 678 -53 678 46 q 633 -189 678 -135 q 515 -269 588 -243 q 360 -294 443 -294 m 358 381 q 427 407 400 381 q 454 475 454 433 q 427 545 454 518 q 358 572 400 572 q 290 545 317 572 q 263 475 263 518 q 290 407 263 433 q 358 381 317 381 m 360 -150 q 466 -129 426 -150 q 506 -64 506 -108 q 476 -8 506 -24 q 393 8 447 8 l 299 8 q 218 14 251 8 q 203 -50 203 -10 q 246 -124 203 -99 q 360 -150 289 -150 m 360 790 q 281 822 313 790 q 249 901 249 854 q 281 981 249 949 q 360 1013 313 1013 q 439 981 407 1013 q 471 901 471 949 q 439 822 471 854 q 360 790 407 790 z ',
    },
    Ģ: {
      ha: 1011,
      x_min: 64,
      x_max: 931,
      o:
        'm 513 -11 q 290 45 392 -11 q 126 214 188 101 q 64 486 64 326 q 128 758 64 646 q 297 926 192 869 q 526 983 403 983 q 788 899 683 983 q 931 676 892 815 l 765 633 q 526 817 690 817 q 325 733 403 817 q 247 486 247 649 q 324 238 247 319 q 522 156 400 156 q 676 210 621 156 q 740 340 731 265 l 560 340 l 560 490 l 915 490 l 915 0 l 764 0 l 749 104 q 658 22 717 54 q 513 -11 599 -11 m 419 -72 l 631 -72 l 450 -328 l 358 -328 l 419 -72 z ',
    },
    ģ: {
      ha: 707,
      x_min: 43,
      x_max: 688,
      o:
        'm 360 -294 q 131 -235 219 -294 q 43 -64 43 -175 q 100 75 43 22 q 64 183 64 118 q 87 269 64 232 q 150 331 110 307 q 101 475 101 390 q 135 599 101 546 q 228 682 169 653 q 358 711 288 711 q 488 681 426 711 l 619 750 l 688 636 l 588 586 q 615 475 615 538 q 581 351 615 404 q 488 269 547 297 q 358 242 429 242 q 257 257 306 242 q 224 204 224 238 q 240 166 224 179 q 289 153 257 153 l 432 153 q 611 99 544 153 q 678 -53 678 46 q 633 -189 678 -135 q 515 -269 588 -243 q 360 -294 443 -294 m 358 381 q 427 407 400 381 q 454 475 454 433 q 427 545 454 518 q 358 572 400 572 q 290 545 317 572 q 263 475 263 518 q 290 407 263 433 q 358 381 317 381 m 360 -150 q 466 -129 426 -150 q 506 -64 506 -108 q 476 -8 506 -24 q 393 8 447 8 l 299 8 q 218 14 251 8 q 203 -50 203 -10 q 246 -124 203 -99 q 360 -150 289 -150 m 403 1047 l 514 1047 l 454 814 l 265 814 l 403 1047 z ',
    },
    Ĥ: {
      ha: 972,
      x_min: 111,
      x_max: 861,
      o:
        'm 111 972 l 292 972 l 292 603 l 681 603 l 681 972 l 861 972 l 861 0 l 681 0 l 681 436 l 292 436 l 292 0 l 111 0 l 111 972 m 463 1292 l 510 1292 l 733 1050 l 575 1050 l 486 1146 l 397 1050 l 239 1050 l 463 1292 z ',
    },
    ĥ: {
      ha: 807,
      x_min: 97,
      x_max: 710,
      o:
        'm 97 983 l 269 983 l 269 588 q 362 677 304 643 q 492 711 419 711 q 651 658 593 711 q 710 500 710 604 l 710 0 l 538 0 l 538 439 q 512 533 538 503 q 433 564 486 564 q 354 535 392 564 q 293 446 317 506 q 269 296 269 386 l 269 0 l 97 0 l 97 983 m 321 1292 l 368 1292 l 592 1050 l 433 1050 l 344 1146 l 256 1050 l 97 1050 l 321 1292 z ',
    },
    Ħ: {
      ha: 972,
      x_min: 21,
      x_max: 950,
      o:
        'm 111 972 l 292 972 l 292 603 l 681 603 l 681 972 l 861 972 l 861 0 l 681 0 l 681 436 l 292 436 l 292 0 l 111 0 l 111 972 m 21 863 l 950 863 l 950 713 l 21 713 l 21 863 z ',
    },
    ħ: {
      ha: 807,
      x_min: 18,
      x_max: 710,
      o:
        'm 97 983 l 269 983 l 269 588 q 362 677 304 643 q 492 711 419 711 q 651 658 593 711 q 710 500 710 604 l 710 0 l 538 0 l 538 439 q 512 533 538 503 q 433 564 486 564 q 354 535 392 564 q 293 446 317 506 q 269 296 269 386 l 269 0 l 97 0 l 97 983 m 18 906 l 444 906 l 444 778 l 18 778 l 18 906 z ',
    },
    Ĩ: {
      ha: 403,
      x_min: -67,
      x_max: 468,
      o:
        'm 111 972 l 292 972 l 292 0 l 111 0 l 111 972 m -67 1139 q 4 1226 -43 1193 q 104 1260 51 1260 q 161 1251 138 1260 q 213 1228 185 1243 q 253 1209 238 1215 q 289 1203 268 1203 q 378 1263 335 1203 l 468 1186 q 397 1099 444 1132 q 297 1065 350 1065 q 240 1074 264 1065 q 189 1097 217 1082 q 149 1116 164 1110 q 113 1122 133 1122 q 24 1063 67 1122 l -67 1139 z ',
    },
    ĩ: {
      ha: 367,
      x_min: -85,
      x_max: 450,
      o:
        'm 97 700 l 269 700 l 269 0 l 97 0 l 97 700 m -85 867 q -14 954 -61 921 q 86 988 33 988 q 143 979 119 988 q 194 956 167 971 q 235 937 219 943 q 271 931 250 931 q 360 990 317 931 l 450 914 q 379 826 426 860 q 279 793 332 793 q 222 801 246 793 q 171 825 199 810 q 131 844 146 838 q 94 850 115 850 q 6 790 49 850 l -85 867 z ',
    },
    Ī: {
      ha: 403,
      x_min: 14,
      x_max: 388,
      o:
        'm 111 972 l 292 972 l 292 0 l 111 0 l 111 972 m 14 1233 l 388 1233 l 388 1097 l 14 1097 l 14 1233 z ',
    },
    ī: {
      ha: 367,
      x_min: -4,
      x_max: 369,
      o:
        'm 97 700 l 269 700 l 269 0 l 97 0 l 97 700 m -4 961 l 369 961 l 369 825 l -4 825 l -4 961 z ',
    },
    Ĭ: {
      ha: 403,
      x_min: 49,
      x_max: 376,
      o:
        'm 111 972 l 292 972 l 292 0 l 111 0 l 111 972 m 213 1093 q 94 1138 139 1093 q 49 1244 49 1182 l 175 1244 q 185 1217 175 1228 q 213 1206 196 1206 q 240 1217 229 1206 q 250 1244 250 1228 l 376 1244 q 331 1138 376 1182 q 213 1093 286 1093 z ',
    },
    ĭ: {
      ha: 367,
      x_min: 31,
      x_max: 358,
      o:
        'm 97 700 l 269 700 l 269 0 l 97 0 l 97 700 m 194 821 q 76 865 121 821 q 31 972 31 910 l 157 972 q 167 944 157 956 q 194 933 178 933 q 222 944 211 933 q 232 972 232 956 l 358 972 q 313 865 358 910 q 194 821 268 821 z ',
    },
    Į: {
      ha: 403,
      x_min: 93,
      x_max: 318,
      o:
        'm 111 972 l 292 972 l 292 0 l 111 0 l 111 972 m 228 -257 q 130 -224 167 -257 q 93 -132 93 -190 q 115 -58 93 -93 q 172 0 138 -22 l 292 0 q 211 -108 211 -65 q 220 -135 211 -125 q 247 -144 229 -144 q 290 -131 267 -144 l 318 -236 q 228 -257 279 -257 z ',
    },
    į: {
      ha: 367,
      x_min: 71,
      x_max: 296,
      o:
        'm 97 700 l 269 700 l 269 0 l 97 0 l 97 700 m 183 790 q 104 822 136 790 q 72 901 72 854 q 104 981 72 949 q 183 1013 136 1013 q 263 981 231 1013 q 294 901 294 949 q 263 822 294 854 q 183 790 231 790 m 206 -257 q 108 -224 144 -257 q 71 -132 71 -190 q 93 -58 71 -93 q 150 0 115 -22 l 269 0 q 189 -108 189 -65 q 198 -135 189 -125 q 225 -144 207 -144 q 268 -131 244 -144 l 296 -236 q 206 -257 257 -257 z ',
    },
    İ: {
      ha: 403,
      x_min: 90,
      x_max: 313,
      o:
        'm 111 972 l 292 972 l 292 0 l 111 0 l 111 972 m 201 1063 q 122 1094 154 1063 q 90 1174 90 1126 q 122 1253 90 1221 q 201 1285 154 1285 q 281 1253 249 1285 q 313 1174 313 1221 q 281 1094 313 1126 q 201 1063 249 1063 z ',
    },
    ı: {
      ha: 367,
      x_min: 97,
      x_max: 269,
      o: 'm 97 700 l 269 700 l 269 0 l 97 0 l 97 700 z ',
    },
    Ĳ: {
      ha: 1138,
      x_min: 111,
      x_max: 1038,
      o:
        'm 111 972 l 292 972 l 292 0 l 111 0 l 111 972 m 728 -11 q 522 56 601 -11 q 428 240 443 122 l 606 278 q 649 185 618 214 q 728 156 679 156 q 824 193 790 156 q 857 322 857 231 l 857 972 l 1038 972 l 1038 342 q 958 71 1038 153 q 728 -11 879 -11 z ',
    },
    ĳ: {
      ha: 733,
      x_min: 72,
      x_max: 661,
      o:
        'm 183 790 q 104 822 136 790 q 72 901 72 854 q 104 981 72 949 q 183 1013 136 1013 q 263 981 231 1013 q 294 901 294 949 q 263 822 294 854 q 183 790 231 790 m 97 700 l 269 700 l 269 0 l 97 0 l 97 700 m 550 790 q 471 822 503 790 q 439 901 439 854 q 471 981 439 949 q 550 1013 503 1013 q 629 981 597 1013 q 661 901 661 949 q 629 822 661 854 q 550 790 597 790 m 301 -143 q 424 -78 383 -122 q 464 60 464 -33 l 464 700 l 636 700 l 636 81 q 565 -172 636 -83 q 343 -294 493 -260 l 301 -143 z ',
    },
    Ĵ: {
      ha: 743,
      x_min: 33,
      x_max: 801,
      o:
        'm 333 -11 q 128 56 207 -11 q 33 240 49 122 l 211 278 q 254 185 224 214 q 333 156 285 156 q 429 193 396 156 q 463 322 463 231 l 463 972 l 643 972 l 643 342 q 564 71 643 153 q 333 -11 485 -11 m 531 1292 l 578 1292 l 801 1050 l 643 1050 l 554 1146 l 465 1050 l 307 1050 l 531 1292 z ',
    },
    ĵ: {
      ha: 367,
      x_min: -65,
      x_max: 431,
      o:
        'm -65 -143 q 57 -78 17 -122 q 97 60 97 -33 l 97 700 l 269 700 l 269 81 q 198 -172 269 -83 q -24 -294 126 -260 l -65 -143 m 160 1019 l 207 1019 l 431 778 l 272 778 l 183 874 l 94 778 l -64 778 l 160 1019 z ',
    },
    Ķ: {
      ha: 888,
      x_min: 111,
      x_max: 874,
      o:
        'm 111 972 l 292 972 l 292 611 l 624 972 l 846 972 l 451 538 l 874 0 l 644 0 l 292 464 l 292 0 l 111 0 l 111 972 m 361 -72 l 572 -72 l 392 -328 l 300 -328 l 361 -72 z ',
    },
    ķ: {
      ha: 736,
      x_min: 97,
      x_max: 728,
      o:
        'm 97 983 l 269 983 l 269 425 l 497 700 l 710 700 l 429 378 l 728 0 l 517 0 l 269 331 l 269 0 l 97 0 l 97 983 m 289 -72 l 500 -72 l 319 -328 l 228 -328 l 289 -72 z ',
    },
    ĸ: {
      ha: 736,
      x_min: 97,
      x_max: 728,
      o:
        'm 97 700 l 269 700 l 269 425 l 497 700 l 710 700 l 429 378 l 728 0 l 517 0 l 269 331 l 269 0 l 97 0 l 97 700 z ',
    },
    Ĺ: {
      ha: 751,
      x_min: 111,
      x_max: 704,
      o:
        'm 111 972 l 292 972 l 292 167 l 704 167 l 704 0 l 111 0 l 111 972 m 225 1256 l 458 1256 l 257 1039 l 132 1039 l 225 1256 z ',
    },
    ĺ: {
      ha: 367,
      x_min: 97,
      x_max: 440,
      o:
        'm 97 983 l 269 983 l 269 0 l 97 0 l 97 983 m 207 1256 l 440 1256 l 239 1039 l 114 1039 l 207 1256 z ',
    },
    Ļ: {
      ha: 751,
      x_min: 111,
      x_max: 704,
      o:
        'm 111 972 l 292 972 l 292 167 l 704 167 l 704 0 l 111 0 l 111 972 m 306 -72 l 517 -72 l 336 -328 l 244 -328 l 306 -72 z ',
    },
    ļ: {
      ha: 367,
      x_min: 17,
      x_max: 289,
      o:
        'm 97 983 l 269 983 l 269 0 l 97 0 l 97 983 m 78 -72 l 289 -72 l 108 -328 l 17 -328 l 78 -72 z ',
    },
    Ľ: {
      ha: 751,
      x_min: 111,
      x_max: 724,
      o:
        'm 111 972 l 292 972 l 292 167 l 704 167 l 704 0 l 111 0 l 111 972 m 535 1008 l 724 1008 l 610 753 l 500 753 l 535 1008 z ',
    },
    ľ: {
      ha: 563,
      x_min: 97,
      x_max: 563,
      o:
        'm 97 983 l 269 983 l 269 0 l 97 0 l 97 983 m 374 1008 l 563 1008 l 449 753 l 339 753 l 374 1008 z ',
    },
    Ŀ: {
      ha: 751,
      x_min: 111,
      x_max: 704,
      o:
        'm 111 972 l 292 972 l 292 167 l 704 167 l 704 0 l 111 0 l 111 972 m 518 396 q 435 429 468 396 q 401 513 401 463 q 435 596 401 563 q 518 629 468 629 q 601 596 568 629 q 635 513 635 563 q 601 429 635 463 q 518 396 568 396 z ',
    },
    ŀ: {
      ha: 678,
      x_min: 97,
      x_max: 642,
      o:
        'm 97 983 l 269 983 l 269 0 l 97 0 l 97 983 m 525 396 q 442 429 475 396 q 408 513 408 463 q 442 596 408 563 q 525 629 475 629 q 608 596 575 629 q 642 513 642 563 q 608 429 642 463 q 525 396 575 396 z ',
    },
    Ł: {
      ha: 751,
      x_min: -56,
      x_max: 704,
      o:
        'm 111 972 l 292 972 l 292 167 l 704 167 l 704 0 l 111 0 l 111 972 m -56 367 l 414 626 l 488 494 l 18 235 l -56 367 z ',
    },
    ł: {
      ha: 367,
      x_min: -44,
      x_max: 411,
      o:
        'm 97 983 l 269 983 l 269 0 l 97 0 l 97 983 m -44 447 l 338 656 l 411 524 l 29 315 l -44 447 z ',
    },
    Ń: {
      ha: 950,
      x_min: 111,
      x_max: 839,
      o:
        'm 111 972 l 301 972 l 658 331 l 658 972 l 839 972 l 839 0 l 649 0 l 292 642 l 292 0 l 111 0 l 111 972 m 499 1256 l 732 1256 l 531 1039 l 406 1039 l 499 1256 z ',
    },
    ń: {
      ha: 799,
      x_min: 97,
      x_max: 701,
      o:
        'm 97 700 l 269 700 l 269 588 q 365 678 310 644 q 486 711 421 711 q 642 657 583 711 q 701 500 701 603 l 701 0 l 529 0 l 529 449 q 502 536 529 508 q 429 564 475 564 q 350 531 386 564 q 292 433 314 497 q 269 279 269 368 l 269 0 l 97 0 l 97 700 m 438 983 l 671 983 l 469 767 l 344 767 l 438 983 z ',
    },
    Ņ: {
      ha: 950,
      x_min: 111,
      x_max: 839,
      o:
        'm 111 972 l 301 972 l 658 331 l 658 972 l 839 972 l 839 0 l 649 0 l 292 642 l 292 0 l 111 0 l 111 972 m 369 -72 l 581 -72 l 400 -328 l 308 -328 l 369 -72 z ',
    },
    ņ: {
      ha: 799,
      x_min: 97,
      x_max: 701,
      o:
        'm 97 700 l 269 700 l 269 588 q 365 678 310 644 q 486 711 421 711 q 642 657 583 711 q 701 500 701 603 l 701 0 l 529 0 l 529 449 q 502 536 529 508 q 429 564 475 564 q 350 531 386 564 q 292 433 314 497 q 269 279 269 368 l 269 0 l 97 0 l 97 700 m 293 -72 l 504 -72 l 324 -328 l 232 -328 l 293 -72 z ',
    },
    Ň: {
      ha: 950,
      x_min: 111,
      x_max: 839,
      o:
        'm 111 972 l 301 972 l 658 331 l 658 972 l 839 972 l 839 0 l 649 0 l 292 642 l 292 0 l 111 0 l 111 972 m 228 1292 l 386 1292 l 475 1196 l 564 1292 l 722 1292 l 499 1050 l 451 1050 l 228 1292 z ',
    },
    ň: {
      ha: 799,
      x_min: 97,
      x_max: 701,
      o:
        'm 97 700 l 269 700 l 269 588 q 365 678 310 644 q 486 711 421 711 q 642 657 583 711 q 701 500 701 603 l 701 0 l 529 0 l 529 449 q 502 536 529 508 q 429 564 475 564 q 350 531 386 564 q 292 433 314 497 q 269 279 269 368 l 269 0 l 97 0 l 97 700 m 167 1019 l 325 1019 l 414 924 l 503 1019 l 661 1019 l 438 778 l 390 778 l 167 1019 z ',
    },
    Ŋ: {
      ha: 950,
      x_min: 111,
      x_max: 839,
      o:
        'm 529 -128 q 622 -100 589 -128 q 658 0 654 -72 l 292 642 l 292 0 l 111 0 l 111 972 l 301 972 l 658 331 l 658 972 l 839 972 l 839 0 q 758 -223 839 -151 q 529 -294 676 -294 l 529 -128 z ',
    },
    ŋ: {
      ha: 799,
      x_min: 97,
      x_max: 701,
      o:
        'm 367 -143 q 489 -78 449 -122 q 529 60 529 -33 l 529 449 q 502 536 529 508 q 429 564 475 564 q 350 531 386 564 q 292 433 314 497 q 269 279 269 368 l 269 0 l 97 0 l 97 700 l 269 700 l 269 588 q 365 678 310 644 q 486 711 421 711 q 642 657 583 711 q 701 500 701 603 l 701 81 q 630 -172 701 -83 q 408 -294 558 -260 l 367 -143 z ',
    },
    Ō: {
      ha: 1044,
      x_min: 64,
      x_max: 981,
      o:
        'm 522 -11 q 292 44 396 -11 q 126 212 188 100 q 64 486 64 324 q 126 760 64 649 q 292 928 188 872 q 522 983 396 983 q 753 928 649 983 q 919 760 857 872 q 981 486 981 649 q 919 212 981 324 q 753 44 857 100 q 522 -11 649 -11 m 522 156 q 660 191 599 156 q 760 301 722 226 q 797 486 797 375 q 760 672 797 597 q 660 781 722 746 q 522 817 599 817 q 384 781 446 817 q 285 672 322 746 q 247 486 247 597 q 285 301 247 375 q 384 191 322 226 q 522 156 446 156 m 335 1233 l 708 1233 l 708 1097 l 335 1097 l 335 1233 z ',
    },
    ō: {
      ha: 828,
      x_min: 58,
      x_max: 769,
      o:
        'm 414 -11 q 224 36 304 -11 q 101 165 143 83 q 58 350 58 247 q 101 535 58 453 q 224 664 143 617 q 414 711 304 711 q 604 664 524 711 q 727 535 685 617 q 769 350 769 453 q 727 165 769 247 q 604 36 685 83 q 414 -11 524 -11 m 414 136 q 542 198 494 136 q 589 350 589 260 q 542 502 589 440 q 414 564 494 564 q 286 502 333 564 q 239 350 239 440 q 286 198 239 260 q 414 136 333 136 m 226 961 l 600 961 l 600 825 l 226 825 l 226 961 z ',
    },
    Ŏ: {
      ha: 1044,
      x_min: 64,
      x_max: 981,
      o:
        'm 522 -11 q 292 44 396 -11 q 126 212 188 100 q 64 486 64 324 q 126 760 64 649 q 292 928 188 872 q 522 983 396 983 q 753 928 649 983 q 919 760 857 872 q 981 486 981 649 q 919 212 981 324 q 753 44 857 100 q 522 -11 649 -11 m 522 156 q 660 191 599 156 q 760 301 722 226 q 797 486 797 375 q 760 672 797 597 q 660 781 722 746 q 522 817 599 817 q 384 781 446 817 q 285 672 322 746 q 247 486 247 597 q 285 301 247 375 q 384 191 322 226 q 522 156 446 156 m 533 1093 q 415 1138 460 1093 q 369 1244 369 1182 l 496 1244 q 506 1217 496 1228 q 533 1206 517 1206 q 560 1217 550 1206 q 571 1244 571 1228 l 697 1244 q 652 1138 697 1182 q 533 1093 607 1093 z ',
    },
    ŏ: {
      ha: 828,
      x_min: 58,
      x_max: 769,
      o:
        'm 414 -11 q 224 36 304 -11 q 101 165 143 83 q 58 350 58 247 q 101 535 58 453 q 224 664 143 617 q 414 711 304 711 q 604 664 524 711 q 727 535 685 617 q 769 350 769 453 q 727 165 769 247 q 604 36 685 83 q 414 -11 524 -11 m 414 136 q 542 198 494 136 q 589 350 589 260 q 542 502 589 440 q 414 564 494 564 q 286 502 333 564 q 239 350 239 440 q 286 198 239 260 q 414 136 333 136 m 425 821 q 306 865 351 821 q 261 972 261 910 l 388 972 q 398 944 388 956 q 425 933 408 933 q 452 944 442 933 q 463 972 463 956 l 589 972 q 544 865 589 910 q 425 821 499 821 z ',
    },
    Ő: {
      ha: 1044,
      x_min: 64,
      x_max: 981,
      o:
        'm 522 -11 q 292 44 396 -11 q 126 212 188 100 q 64 486 64 324 q 126 760 64 649 q 292 928 188 872 q 522 983 396 983 q 753 928 649 983 q 919 760 857 872 q 981 486 981 649 q 919 212 981 324 q 753 44 857 100 q 522 -11 649 -11 m 522 156 q 660 191 599 156 q 760 301 722 226 q 797 486 797 375 q 760 672 797 597 q 660 781 722 746 q 522 817 599 817 q 384 781 446 817 q 285 672 322 746 q 247 486 247 597 q 285 301 247 375 q 384 191 322 226 q 522 156 446 156 m 397 1256 l 631 1256 l 439 1050 l 308 1050 l 397 1256 m 679 1256 l 913 1256 l 721 1050 l 590 1050 l 679 1256 z ',
    },
    ő: {
      ha: 828,
      x_min: 58,
      x_max: 776,
      o:
        'm 414 -11 q 224 36 304 -11 q 101 165 143 83 q 58 350 58 247 q 101 535 58 453 q 224 664 143 617 q 414 711 304 711 q 604 664 524 711 q 727 535 685 617 q 769 350 769 453 q 727 165 769 247 q 604 36 685 83 q 414 -11 524 -11 m 414 136 q 542 198 494 136 q 589 350 589 260 q 542 502 589 440 q 414 564 494 564 q 286 502 333 564 q 239 350 239 440 q 286 198 239 260 q 414 136 333 136 m 261 983 l 494 983 l 303 778 l 172 778 l 261 983 m 543 983 l 776 983 l 585 778 l 454 778 l 543 983 z ',
    },
    Œ: {
      ha: 1483,
      x_min: 64,
      x_max: 1414,
      o:
        'm 522 -11 q 292 44 396 -11 q 126 212 188 100 q 64 486 64 324 q 126 760 64 649 q 292 928 188 872 q 522 983 396 983 q 671 962 600 983 q 799 899 742 940 l 799 972 l 1400 972 l 1400 806 l 979 806 l 979 601 l 1317 601 l 1317 435 l 979 435 l 979 167 l 1414 167 l 1414 0 l 799 0 l 799 72 q 669 10 740 31 q 522 -11 599 -11 m 522 156 q 661 191 599 156 q 761 301 724 226 q 799 486 799 375 q 761 672 799 597 q 661 781 724 746 q 522 817 599 817 q 384 781 446 817 q 285 672 322 746 q 247 486 247 597 q 285 301 247 375 q 384 191 322 226 q 522 156 446 156 z ',
    },
    œ: {
      ha: 1310,
      x_min: 58,
      x_max: 1251,
      o:
        'm 414 -11 q 224 36 304 -11 q 101 165 143 83 q 58 350 58 247 q 101 535 58 453 q 224 664 143 617 q 414 711 304 711 q 563 683 496 711 q 678 606 631 656 q 925 711 769 711 q 1108 659 1035 711 q 1217 528 1182 607 q 1251 365 1251 449 l 1251 294 l 769 294 q 816 183 772 231 q 935 136 860 136 q 1033 163 993 136 q 1104 244 1072 189 l 1243 193 q 1123 42 1200 94 q 925 -11 1046 -11 q 782 17 844 -11 q 676 94 719 44 q 563 17 629 44 q 414 -11 496 -11 m 414 136 q 542 198 494 136 q 589 350 589 260 q 541 501 589 439 q 414 564 493 564 q 286 502 333 564 q 239 350 239 440 q 286 198 239 260 q 414 136 333 136 m 1075 431 q 1026 526 1063 489 q 925 564 989 564 q 824 525 864 564 q 774 431 783 486 l 1075 431 z ',
    },
    Ŕ: {
      ha: 879,
      x_min: 111,
      x_max: 849,
      o:
        'm 111 972 l 465 972 q 684 897 607 972 q 761 696 761 821 q 714 530 761 599 q 579 435 667 461 l 849 0 l 647 0 l 386 419 l 292 419 l 292 0 l 111 0 l 111 972 m 467 586 q 550 613 519 586 q 581 696 581 639 q 550 779 581 753 q 467 806 519 806 l 292 806 l 292 586 l 467 586 m 386 1256 l 619 1256 l 418 1039 l 293 1039 l 386 1256 z ',
    },
    ŕ: {
      ha: 579,
      x_min: 97,
      x_max: 568,
      o:
        'm 97 700 l 269 700 l 269 586 q 361 678 307 646 q 476 711 415 711 q 561 697 515 711 l 529 538 q 457 557 497 557 q 322 483 375 557 q 269 249 269 408 l 269 0 l 97 0 l 97 700 m 335 983 l 568 983 l 367 767 l 242 767 l 335 983 z ',
    },
    Ŗ: {
      ha: 879,
      x_min: 111,
      x_max: 849,
      o:
        'm 111 972 l 465 972 q 684 897 607 972 q 761 696 761 821 q 714 530 761 599 q 579 435 667 461 l 849 0 l 647 0 l 386 419 l 292 419 l 292 0 l 111 0 l 111 972 m 467 586 q 550 613 519 586 q 581 696 581 639 q 550 779 581 753 q 467 806 519 806 l 292 806 l 292 586 l 467 586 m 363 -72 l 574 -72 l 393 -328 l 301 -328 l 363 -72 z ',
    },
    ŗ: {
      ha: 579,
      x_min: 17,
      x_max: 561,
      o:
        'm 97 700 l 269 700 l 269 586 q 361 678 307 646 q 476 711 415 711 q 561 697 515 711 l 529 538 q 457 557 497 557 q 322 483 375 557 q 269 249 269 408 l 269 0 l 97 0 l 97 700 m 78 -72 l 289 -72 l 108 -328 l 17 -328 l 78 -72 z ',
    },
    Ř: {
      ha: 879,
      x_min: 111,
      x_max: 849,
      o:
        'm 111 972 l 465 972 q 684 897 607 972 q 761 696 761 821 q 714 530 761 599 q 579 435 667 461 l 849 0 l 647 0 l 386 419 l 292 419 l 292 0 l 111 0 l 111 972 m 467 586 q 550 613 519 586 q 581 696 581 639 q 550 779 581 753 q 467 806 519 806 l 292 806 l 292 586 l 467 586 m 115 1292 l 274 1292 l 363 1196 l 451 1292 l 610 1292 l 386 1050 l 339 1050 l 115 1292 z ',
    },
    ř: {
      ha: 579,
      x_min: 64,
      x_max: 561,
      o:
        'm 97 700 l 269 700 l 269 586 q 361 678 307 646 q 476 711 415 711 q 561 697 515 711 l 529 538 q 457 557 497 557 q 322 483 375 557 q 269 249 269 408 l 269 0 l 97 0 l 97 700 m 64 1019 l 222 1019 l 311 924 l 400 1019 l 558 1019 l 335 778 l 288 778 l 64 1019 z ',
    },
    Ś: {
      ha: 738,
      x_min: 44,
      x_max: 690,
      o:
        'm 379 -11 q 223 25 293 -11 q 106 124 153 61 q 44 261 60 186 l 190 353 q 260 210 213 264 q 383 156 308 156 q 475 184 440 156 q 510 271 510 213 q 486 335 510 307 q 427 383 463 363 q 326 436 392 404 l 286 456 q 153 560 203 497 q 103 722 103 624 q 137 856 103 796 q 233 949 171 915 q 374 983 294 983 q 649 807 575 983 l 503 714 q 374 817 467 817 q 304 791 333 817 q 275 728 275 765 q 301 662 275 690 q 363 613 326 633 q 469 561 400 593 q 584 496 538 529 q 660 409 631 463 q 690 279 690 356 q 651 126 690 192 q 540 24 611 60 q 379 -11 469 -11 m 399 1256 l 632 1256 l 431 1039 l 306 1039 l 399 1256 z ',
    },
    ś: {
      ha: 619,
      x_min: 47,
      x_max: 571,
      o:
        'm 325 -11 q 144 44 217 -11 q 47 178 71 100 l 185 251 q 240 167 204 197 q 324 136 275 136 q 386 152 361 136 q 411 204 411 168 q 381 256 411 236 q 289 299 351 276 q 260 310 279 301 q 135 390 179 342 q 90 515 90 439 q 119 614 90 569 q 199 685 149 658 q 314 711 250 711 q 443 681 385 711 q 533 597 501 651 l 431 503 q 318 564 389 564 q 270 549 290 564 q 250 511 250 535 q 279 465 250 486 q 393 413 308 443 q 517 336 474 383 q 561 215 561 289 q 496 51 561 113 q 325 -11 431 -11 m 338 983 l 571 983 l 369 767 l 244 767 l 338 983 z ',
    },
    Ŝ: {
      ha: 738,
      x_min: 44,
      x_max: 690,
      o:
        'm 379 -11 q 223 25 293 -11 q 106 124 153 61 q 44 261 60 186 l 190 353 q 260 210 213 264 q 383 156 308 156 q 475 184 440 156 q 510 271 510 213 q 486 335 510 307 q 427 383 463 363 q 326 436 392 404 l 286 456 q 153 560 203 497 q 103 722 103 624 q 137 856 103 796 q 233 949 171 915 q 374 983 294 983 q 649 807 575 983 l 503 714 q 374 817 467 817 q 304 791 333 817 q 275 728 275 765 q 301 662 275 690 q 363 613 326 633 q 469 561 400 593 q 584 496 538 529 q 660 409 631 463 q 690 279 690 356 q 651 126 690 192 q 540 24 611 60 q 379 -11 469 -11 m 351 1292 l 399 1292 l 622 1050 l 464 1050 l 375 1146 l 286 1050 l 128 1050 l 351 1292 z ',
    },
    ŝ: {
      ha: 619,
      x_min: 47,
      x_max: 561,
      o:
        'm 325 -11 q 144 44 217 -11 q 47 178 71 100 l 185 251 q 240 167 204 197 q 324 136 275 136 q 386 152 361 136 q 411 204 411 168 q 381 256 411 236 q 289 299 351 276 q 260 310 279 301 q 135 390 179 342 q 90 515 90 439 q 119 614 90 569 q 199 685 149 658 q 314 711 250 711 q 443 681 385 711 q 533 597 501 651 l 431 503 q 318 564 389 564 q 270 549 290 564 q 250 511 250 535 q 279 465 250 486 q 393 413 308 443 q 517 336 474 383 q 561 215 561 289 q 496 51 561 113 q 325 -11 431 -11 m 290 1019 l 338 1019 l 561 778 l 403 778 l 314 874 l 225 778 l 67 778 l 290 1019 z ',
    },
    Ş: {
      ha: 738,
      x_min: 44,
      x_max: 690,
      o:
        'm 379 -11 q 223 25 293 -11 q 106 124 153 61 q 44 261 60 186 l 190 353 q 260 210 213 264 q 383 156 308 156 q 475 184 440 156 q 510 271 510 213 q 486 335 510 307 q 427 383 463 363 q 326 436 392 404 l 286 456 q 153 560 203 497 q 103 722 103 624 q 137 856 103 796 q 233 949 171 915 q 374 983 294 983 q 649 807 575 983 l 503 714 q 374 817 467 817 q 304 791 333 817 q 275 728 275 765 q 301 662 275 690 q 363 613 326 633 q 469 561 400 593 q 584 496 538 529 q 660 409 631 463 q 690 279 690 356 q 651 126 690 192 q 540 24 611 60 q 379 -11 469 -11 m 121 -278 l 317 -83 l 442 -83 l 326 -369 l 121 -278 z ',
    },
    ş: {
      ha: 619,
      x_min: 47,
      x_max: 561,
      o:
        'm 325 -11 q 144 44 217 -11 q 47 178 71 100 l 185 251 q 240 167 204 197 q 324 136 275 136 q 386 152 361 136 q 411 204 411 168 q 381 256 411 236 q 289 299 351 276 q 260 310 279 301 q 135 390 179 342 q 90 515 90 439 q 119 614 90 569 q 199 685 149 658 q 314 711 250 711 q 443 681 385 711 q 533 597 501 651 l 431 503 q 318 564 389 564 q 270 549 290 564 q 250 511 250 535 q 279 465 250 486 q 393 413 308 443 q 517 336 474 383 q 561 215 561 289 q 496 51 561 113 q 325 -11 431 -11 m 74 -278 l 269 -83 l 394 -83 l 279 -369 l 74 -278 z ',
    },
    Š: {
      ha: 738,
      x_min: 44,
      x_max: 690,
      o:
        'm 379 -11 q 223 25 293 -11 q 106 124 153 61 q 44 261 60 186 l 190 353 q 260 210 213 264 q 383 156 308 156 q 475 184 440 156 q 510 271 510 213 q 486 335 510 307 q 427 383 463 363 q 326 436 392 404 l 286 456 q 153 560 203 497 q 103 722 103 624 q 137 856 103 796 q 233 949 171 915 q 374 983 294 983 q 649 807 575 983 l 503 714 q 374 817 467 817 q 304 791 333 817 q 275 728 275 765 q 301 662 275 690 q 363 613 326 633 q 469 561 400 593 q 584 496 538 529 q 660 409 631 463 q 690 279 690 356 q 651 126 690 192 q 540 24 611 60 q 379 -11 469 -11 m 128 1292 l 286 1292 l 375 1196 l 464 1292 l 622 1292 l 399 1050 l 351 1050 l 128 1292 z ',
    },
    š: {
      ha: 619,
      x_min: 47,
      x_max: 561,
      o:
        'm 325 -11 q 144 44 217 -11 q 47 178 71 100 l 185 251 q 240 167 204 197 q 324 136 275 136 q 386 152 361 136 q 411 204 411 168 q 381 256 411 236 q 289 299 351 276 q 260 310 279 301 q 135 390 179 342 q 90 515 90 439 q 119 614 90 569 q 199 685 149 658 q 314 711 250 711 q 443 681 385 711 q 533 597 501 651 l 431 503 q 318 564 389 564 q 270 549 290 564 q 250 511 250 535 q 279 465 250 486 q 393 413 308 443 q 517 336 474 383 q 561 215 561 289 q 496 51 561 113 q 325 -11 431 -11 m 67 1019 l 225 1019 l 314 924 l 403 1019 l 561 1019 l 338 778 l 290 778 l 67 1019 z ',
    },
    Ţ: {
      ha: 789,
      x_min: 33,
      x_max: 756,
      o:
        'm 304 806 l 33 806 l 33 972 l 756 972 l 756 806 l 485 806 l 485 0 l 304 0 l 304 806 m 136 -278 l 332 -83 l 457 -83 l 342 -369 l 136 -278 z ',
    },
    ţ: {
      ha: 514,
      x_min: 13,
      x_max: 492,
      o:
        'm 378 -11 q 189 54 257 -11 q 121 247 121 119 l 121 553 l 13 553 l 13 700 l 121 700 l 121 875 l 293 983 l 293 700 l 478 700 l 478 553 l 293 553 l 293 250 q 316 162 293 188 q 385 136 339 136 q 451 153 419 136 l 492 14 q 378 -11 438 -11 m 71 -278 l 267 -83 l 392 -83 l 276 -369 l 71 -278 z ',
    },
    Ť: {
      ha: 789,
      x_min: 33,
      x_max: 756,
      o:
        'm 304 806 l 33 806 l 33 972 l 756 972 l 756 806 l 485 806 l 485 0 l 304 0 l 304 806 m 147 1292 l 306 1292 l 394 1196 l 483 1292 l 642 1292 l 418 1050 l 371 1050 l 147 1292 z ',
    },
    ť: {
      ha: 514,
      x_min: 13,
      x_max: 594,
      o:
        'm 378 -11 q 189 54 257 -11 q 121 247 121 119 l 121 553 l 13 553 l 13 700 l 121 700 l 121 875 l 293 983 l 293 700 l 478 700 l 478 553 l 293 553 l 293 250 q 316 162 293 188 q 385 136 339 136 q 451 153 419 136 l 492 14 q 378 -11 438 -11 m 406 1008 l 594 1008 l 481 753 l 371 753 l 406 1008 z ',
    },
    Ŧ: {
      ha: 789,
      x_min: 33,
      x_max: 756,
      o:
        'm 304 806 l 33 806 l 33 972 l 756 972 l 756 806 l 485 806 l 485 0 l 304 0 l 304 806 m 113 561 l 675 561 l 675 411 l 113 411 l 113 561 z ',
    },
    ŧ: {
      ha: 514,
      x_min: 13,
      x_max: 492,
      o:
        'm 378 -11 q 189 54 257 -11 q 121 247 121 119 l 121 553 l 13 553 l 13 700 l 121 700 l 121 875 l 293 983 l 293 700 l 478 700 l 478 553 l 293 553 l 293 250 q 316 162 293 188 q 385 136 339 136 q 451 153 419 136 l 492 14 q 378 -11 438 -11 m 28 442 l 454 442 l 454 314 l 28 314 l 28 442 z ',
    },
    Ũ: {
      ha: 925,
      x_min: 100,
      x_max: 825,
      o:
        'm 463 -11 q 198 85 296 -11 q 100 369 100 181 l 100 972 l 281 972 l 281 367 q 463 156 281 156 q 644 367 644 156 l 644 972 l 825 972 l 825 369 q 727 85 825 181 q 463 -11 629 -11 m 194 1139 q 265 1226 218 1193 q 365 1260 313 1260 q 422 1251 399 1260 q 474 1228 446 1243 q 514 1209 499 1215 q 550 1203 529 1203 q 639 1263 596 1203 l 729 1186 q 658 1099 706 1132 q 558 1065 611 1065 q 501 1074 525 1065 q 450 1097 478 1082 q 410 1116 425 1110 q 374 1122 394 1122 q 285 1063 328 1122 l 194 1139 z ',
    },
    ũ: {
      ha: 799,
      x_min: 97,
      x_max: 701,
      o:
        'm 313 -11 q 156 43 215 -11 q 97 200 97 97 l 97 700 l 269 700 l 269 251 q 297 164 269 192 q 369 136 324 136 q 449 169 413 136 q 507 267 485 203 q 529 421 529 332 l 529 700 l 701 700 l 701 0 l 529 0 l 529 113 q 433 22 489 56 q 313 -11 378 -11 m 131 867 q 201 954 154 921 q 301 988 249 988 q 358 979 335 988 q 410 956 382 971 q 450 937 435 943 q 486 931 465 931 q 575 990 532 931 l 665 914 q 594 826 642 860 q 494 793 547 793 q 438 801 461 793 q 386 825 414 810 q 346 844 361 838 q 310 850 331 850 q 221 790 264 850 l 131 867 z ',
    },
    Ū: {
      ha: 925,
      x_min: 100,
      x_max: 825,
      o:
        'm 463 -11 q 198 85 296 -11 q 100 369 100 181 l 100 972 l 281 972 l 281 367 q 463 156 281 156 q 644 367 644 156 l 644 972 l 825 972 l 825 369 q 727 85 825 181 q 463 -11 629 -11 m 275 1233 l 649 1233 l 649 1097 l 275 1097 l 275 1233 z ',
    },
    ū: {
      ha: 799,
      x_min: 97,
      x_max: 701,
      o:
        'm 313 -11 q 156 43 215 -11 q 97 200 97 97 l 97 700 l 269 700 l 269 251 q 297 164 269 192 q 369 136 324 136 q 449 169 413 136 q 507 267 485 203 q 529 421 529 332 l 529 700 l 701 700 l 701 0 l 529 0 l 529 113 q 433 22 489 56 q 313 -11 378 -11 m 211 961 l 585 961 l 585 825 l 211 825 l 211 961 z ',
    },
    Ŭ: {
      ha: 925,
      x_min: 100,
      x_max: 825,
      o:
        'm 463 -11 q 198 85 296 -11 q 100 369 100 181 l 100 972 l 281 972 l 281 367 q 463 156 281 156 q 644 367 644 156 l 644 972 l 825 972 l 825 369 q 727 85 825 181 q 463 -11 629 -11 m 474 1093 q 355 1138 400 1093 q 310 1244 310 1182 l 436 1244 q 447 1217 436 1228 q 474 1206 457 1206 q 501 1217 490 1206 q 511 1244 511 1228 l 638 1244 q 592 1138 638 1182 q 474 1093 547 1093 z ',
    },
    ŭ: {
      ha: 799,
      x_min: 97,
      x_max: 701,
      o:
        'm 313 -11 q 156 43 215 -11 q 97 200 97 97 l 97 700 l 269 700 l 269 251 q 297 164 269 192 q 369 136 324 136 q 449 169 413 136 q 507 267 485 203 q 529 421 529 332 l 529 700 l 701 700 l 701 0 l 529 0 l 529 113 q 433 22 489 56 q 313 -11 378 -11 m 410 821 q 291 865 336 821 q 246 972 246 910 l 372 972 q 383 944 372 956 q 410 933 393 933 q 437 944 426 933 q 447 972 447 956 l 574 972 q 528 865 574 910 q 410 821 483 821 z ',
    },
    Ů: {
      ha: 925,
      x_min: 100,
      x_max: 825,
      o:
        'm 463 -11 q 198 85 296 -11 q 100 369 100 181 l 100 972 l 281 972 l 281 367 q 463 156 281 156 q 644 367 644 156 l 644 972 l 825 972 l 825 369 q 727 85 825 181 q 463 -11 629 -11 m 461 1040 q 356 1081 399 1040 q 314 1182 314 1121 q 356 1283 314 1243 q 461 1324 399 1324 q 566 1283 524 1324 q 608 1182 608 1243 q 566 1081 608 1121 q 461 1040 524 1040 m 461 1138 q 493 1150 481 1138 q 506 1182 506 1163 q 493 1214 506 1201 q 461 1226 481 1226 q 429 1214 442 1226 q 417 1182 417 1201 q 429 1150 417 1163 q 461 1138 442 1138 z ',
    },
    ů: {
      ha: 799,
      x_min: 97,
      x_max: 701,
      o:
        'm 313 -11 q 156 43 215 -11 q 97 200 97 97 l 97 700 l 269 700 l 269 251 q 297 164 269 192 q 369 136 324 136 q 449 169 413 136 q 507 267 485 203 q 529 421 529 332 l 529 700 l 701 700 l 701 0 l 529 0 l 529 113 q 433 22 489 56 q 313 -11 378 -11 m 397 768 q 292 808 335 768 q 250 910 250 849 q 292 1011 250 971 q 397 1051 335 1051 q 502 1011 460 1051 q 544 910 544 971 q 502 808 544 849 q 397 768 460 768 m 397 865 q 429 878 417 865 q 442 910 442 890 q 429 942 442 929 q 397 954 417 954 q 365 942 378 954 q 353 910 353 929 q 365 878 353 890 q 397 865 378 865 z ',
    },
    Ű: {
      ha: 925,
      x_min: 100,
      x_max: 853,
      o:
        'm 463 -11 q 198 85 296 -11 q 100 369 100 181 l 100 972 l 281 972 l 281 367 q 463 156 281 156 q 644 367 644 156 l 644 972 l 825 972 l 825 369 q 727 85 825 181 q 463 -11 629 -11 m 338 1256 l 571 1256 l 379 1050 l 249 1050 l 338 1256 m 619 1256 l 853 1256 l 661 1050 l 531 1050 l 619 1256 z ',
    },
    ű: {
      ha: 799,
      x_min: 97,
      x_max: 761,
      o:
        'm 313 -11 q 156 43 215 -11 q 97 200 97 97 l 97 700 l 269 700 l 269 251 q 297 164 269 192 q 369 136 324 136 q 449 169 413 136 q 507 267 485 203 q 529 421 529 332 l 529 700 l 701 700 l 701 0 l 529 0 l 529 113 q 433 22 489 56 q 313 -11 378 -11 m 246 983 l 479 983 l 288 778 l 157 778 l 246 983 m 528 983 l 761 983 l 569 778 l 439 778 l 528 983 z ',
    },
    Ų: {
      ha: 925,
      x_min: 100,
      x_max: 825,
      o:
        'm 463 -11 q 198 85 296 -11 q 100 369 100 181 l 100 972 l 281 972 l 281 367 q 463 156 281 156 q 644 367 644 156 l 644 972 l 825 972 l 825 369 q 727 85 825 181 q 463 -11 629 -11 m 503 -257 q 405 -224 442 -257 q 368 -132 368 -190 q 390 -58 368 -93 q 447 0 413 -22 l 567 0 q 486 -108 486 -65 q 495 -135 486 -125 q 522 -144 504 -144 q 565 -131 542 -144 l 593 -236 q 503 -257 554 -257 z ',
    },
    ų: {
      ha: 799,
      x_min: 97,
      x_max: 728,
      o:
        'm 313 -11 q 156 43 215 -11 q 97 200 97 97 l 97 700 l 269 700 l 269 251 q 297 164 269 192 q 369 136 324 136 q 449 169 413 136 q 507 267 485 203 q 529 421 529 332 l 529 700 l 701 700 l 701 0 l 529 0 l 529 113 q 433 22 489 56 q 313 -11 378 -11 m 638 -257 q 540 -224 576 -257 q 503 -132 503 -190 q 525 -58 503 -93 q 582 0 547 -22 l 701 0 q 621 -108 621 -65 q 630 -135 621 -125 q 657 -144 639 -144 q 700 -131 676 -144 l 728 -236 q 638 -257 689 -257 z ',
    },
    Ŵ: {
      ha: 1256,
      x_min: 14,
      x_max: 1242,
      o:
        'm 14 972 l 206 972 l 368 257 l 550 869 l 706 869 l 888 257 l 1050 972 l 1242 972 l 988 0 l 804 0 l 628 572 l 451 0 l 268 0 l 14 972 m 604 1292 l 651 1292 l 875 1050 l 717 1050 l 628 1146 l 539 1050 l 381 1050 l 604 1292 z ',
    },
    ŵ: {
      ha: 1025,
      x_min: 15,
      x_max: 1010,
      o:
        'm 15 700 l 189 700 l 314 219 l 432 700 l 593 700 l 711 219 l 836 700 l 1010 700 l 786 0 l 633 0 l 513 453 l 392 0 l 239 0 l 15 700 m 489 1019 l 536 1019 l 760 778 l 601 778 l 513 874 l 424 778 l 265 778 l 489 1019 z ',
    },
    Ŷ: {
      ha: 767,
      x_min: 13,
      x_max: 754,
      o:
        'm 293 414 l 13 972 l 207 972 l 383 594 l 560 972 l 754 972 l 474 414 l 474 0 l 293 0 l 293 414 m 360 1292 l 407 1292 l 631 1050 l 472 1050 l 383 1146 l 294 1050 l 136 1050 l 360 1292 z ',
    },
    ŷ: {
      ha: 689,
      x_min: 14,
      x_max: 675,
      o:
        'm 268 44 l 14 700 l 188 700 l 350 261 l 503 700 l 675 700 l 314 -283 l 147 -283 l 268 44 m 321 1019 l 368 1019 l 592 778 l 433 778 l 344 874 l 256 778 l 97 778 l 321 1019 z ',
    },
    Ÿ: {
      ha: 767,
      x_min: 13,
      x_max: 754,
      o:
        'm 293 414 l 13 972 l 207 972 l 383 594 l 560 972 l 754 972 l 474 414 l 474 0 l 293 0 l 293 414 m 239 1072 q 168 1100 196 1072 q 140 1171 140 1128 q 168 1242 140 1214 q 239 1269 196 1269 q 310 1242 282 1269 q 338 1171 338 1214 q 310 1100 338 1128 q 239 1072 282 1072 m 526 1072 q 456 1100 483 1072 q 428 1171 428 1128 q 456 1242 428 1214 q 526 1269 483 1269 q 597 1242 569 1269 q 625 1171 625 1214 q 597 1100 625 1128 q 526 1072 569 1072 z ',
    },
    Ź: {
      ha: 788,
      x_min: 50,
      x_max: 738,
      o:
        'm 50 83 l 471 806 l 74 806 l 74 972 l 718 972 l 718 889 l 301 167 l 738 167 l 738 0 l 50 0 l 50 83 m 419 1256 l 653 1256 l 451 1039 l 326 1039 l 419 1256 z ',
    },
    ź: {
      ha: 629,
      x_min: 42,
      x_max: 578,
      o:
        'm 42 67 l 344 553 l 64 553 l 64 700 l 558 700 l 558 633 l 258 147 l 578 147 l 578 0 l 42 0 l 42 67 m 335 983 l 568 983 l 367 767 l 242 767 l 335 983 z ',
    },
    Ż: {
      ha: 788,
      x_min: 50,
      x_max: 738,
      o:
        'm 50 83 l 471 806 l 74 806 l 74 972 l 718 972 l 718 889 l 301 167 l 738 167 l 738 0 l 50 0 l 50 83 m 396 1063 q 317 1094 349 1063 q 285 1174 285 1126 q 317 1253 285 1221 q 396 1285 349 1285 q 475 1253 443 1285 q 507 1174 507 1221 q 475 1094 507 1126 q 396 1063 443 1063 z ',
    },
    ż: {
      ha: 629,
      x_min: 42,
      x_max: 578,
      o:
        'm 42 67 l 344 553 l 64 553 l 64 700 l 558 700 l 558 633 l 258 147 l 578 147 l 578 0 l 42 0 l 42 67 m 311 790 q 232 822 264 790 q 200 901 200 854 q 232 981 200 949 q 311 1013 264 1013 q 390 981 358 1013 q 422 901 422 949 q 390 822 422 854 q 311 790 358 790 z ',
    },
    Ž: {
      ha: 788,
      x_min: 50,
      x_max: 738,
      o:
        'm 50 83 l 471 806 l 74 806 l 74 972 l 718 972 l 718 889 l 301 167 l 738 167 l 738 0 l 50 0 l 50 83 m 149 1292 l 307 1292 l 396 1196 l 485 1292 l 643 1292 l 419 1050 l 372 1050 l 149 1292 z ',
    },
    ž: {
      ha: 629,
      x_min: 42,
      x_max: 578,
      o:
        'm 42 67 l 344 553 l 64 553 l 64 700 l 558 700 l 558 633 l 258 147 l 578 147 l 578 0 l 42 0 l 42 67 m 64 1019 l 222 1019 l 311 924 l 400 1019 l 558 1019 l 335 778 l 288 778 l 64 1019 z ',
    },
    ƒ: {
      ha: 676,
      x_min: -114,
      x_max: 696,
      o:
        'm 11 -294 q -114 -267 -69 -294 l -50 -128 q 29 -147 -8 -147 q 126 -60 108 -147 l 244 553 l 135 553 l 164 700 l 275 700 l 282 736 q 382 922 306 860 q 571 983 458 983 q 696 956 651 983 l 632 817 q 553 836 590 836 q 456 749 474 836 l 447 700 l 597 700 l 568 553 l 418 553 l 300 -47 q 200 -233 276 -171 q 11 -294 124 -294 z ',
    },
    Ƶ: {
      ha: 788,
      x_min: 50,
      x_max: 738,
      o:
        'm 738 167 l 738 0 l 50 0 l 50 83 l 242 411 l 115 411 l 115 561 l 328 561 l 471 806 l 74 806 l 74 972 l 718 972 l 718 889 l 529 561 l 672 561 l 672 411 l 443 411 l 301 167 l 738 167 z ',
    },
    ƶ: {
      ha: 629,
      x_min: 42,
      x_max: 578,
      o:
        'm 42 67 l 189 303 l 79 303 l 79 431 l 267 431 l 344 553 l 64 553 l 64 700 l 558 700 l 558 633 l 433 431 l 528 431 l 528 303 l 356 303 l 258 147 l 578 147 l 578 0 l 42 0 l 42 67 z ',
    },
    Ǻ: {
      ha: 867,
      x_min: 14,
      x_max: 853,
      o:
        'm 343 972 l 524 972 l 853 0 l 658 0 l 588 229 l 279 229 l 208 0 l 14 0 l 343 972 m 536 396 l 433 733 l 331 396 l 536 396 m 432 1040 q 327 1081 369 1040 q 285 1182 285 1121 q 327 1283 285 1243 q 432 1324 369 1324 q 537 1283 494 1324 q 579 1182 579 1243 q 537 1081 579 1121 q 432 1040 494 1040 m 432 1138 q 464 1150 451 1138 q 476 1182 476 1163 q 464 1214 476 1201 q 432 1226 451 1226 q 400 1214 413 1226 q 388 1182 388 1201 q 400 1150 388 1163 q 432 1138 413 1138 m 457 1568 l 690 1568 l 489 1351 l 364 1351 l 457 1568 z ',
    },
    ǻ: {
      ha: 732,
      x_min: 61,
      x_max: 649,
      o:
        'm 274 -11 q 121 44 181 -11 q 61 201 61 100 q 140 368 61 306 q 354 431 219 431 l 476 431 l 476 461 q 442 538 476 513 q 354 564 407 564 q 233 483 264 564 l 88 517 q 177 658 104 604 q 354 711 250 711 q 572 637 494 711 q 649 418 649 563 l 649 0 l 507 0 l 489 89 q 274 -11 407 -11 m 319 136 q 429 176 382 136 q 476 281 476 215 l 476 294 l 361 294 q 273 272 304 294 q 242 204 242 250 q 263 155 242 174 q 319 136 285 136 m 356 768 q 251 808 293 768 q 208 910 208 849 q 251 1011 208 971 q 356 1051 293 1051 q 460 1011 418 1051 q 503 910 503 971 q 460 808 503 849 q 356 768 418 768 m 356 865 q 388 878 375 865 q 400 910 400 890 q 388 942 400 929 q 356 954 375 954 q 324 942 336 954 q 311 910 311 929 q 324 878 311 890 q 356 865 336 865 m 381 1313 l 614 1313 l 413 1096 l 288 1096 l 381 1313 z ',
    },
    Ǽ: {
      ha: 1207,
      x_min: 14,
      x_max: 1138,
      o:
        'm 439 972 l 1124 972 l 1124 806 l 703 806 l 703 601 l 1040 601 l 1040 435 l 703 435 l 703 167 l 1138 167 l 1138 0 l 522 0 l 522 229 l 300 229 l 208 0 l 14 0 l 439 972 m 522 396 l 522 733 l 504 733 l 368 396 l 522 396 m 846 1256 l 1079 1256 l 878 1039 l 753 1039 l 846 1256 z ',
    },
    ǽ: {
      ha: 1197,
      x_min: 61,
      x_max: 1139,
      o:
        'm 274 -11 q 121 45 181 -11 q 61 201 61 101 q 99 322 61 269 q 204 402 136 374 q 360 431 272 431 l 476 431 l 476 461 q 442 540 476 515 q 354 564 408 564 q 233 483 261 564 l 88 517 q 176 658 104 604 q 354 711 249 711 q 585 626 511 711 q 813 711 674 711 q 996 659 922 711 q 1104 528 1069 607 q 1139 365 1139 449 l 1139 294 l 657 294 q 703 183 660 231 q 822 136 747 136 q 920 163 881 136 q 992 244 960 189 l 1131 193 q 1010 42 1088 94 q 813 -11 933 -11 q 647 28 715 -11 q 535 135 578 68 q 417 22 482 56 q 274 -11 353 -11 m 963 431 q 913 526 950 489 q 813 564 876 564 q 710 524 751 564 q 660 431 669 485 l 963 431 m 314 136 q 427 176 378 136 q 476 281 476 217 l 476 294 l 361 294 q 273 272 304 294 q 242 204 242 249 q 260 156 242 176 q 314 136 279 136 m 617 983 l 850 983 l 649 767 l 524 767 l 617 983 z ',
    },
    Ș: {
      ha: 738,
      x_min: 44,
      x_max: 690,
      o:
        'm 379 -11 q 223 25 293 -11 q 106 124 153 61 q 44 261 60 186 l 190 353 q 260 210 213 264 q 383 156 308 156 q 475 184 440 156 q 510 271 510 213 q 486 335 510 307 q 427 383 463 363 q 326 436 392 404 l 286 456 q 153 560 203 497 q 103 722 103 624 q 137 856 103 796 q 233 949 171 915 q 374 983 294 983 q 649 807 575 983 l 503 714 q 374 817 467 817 q 304 791 333 817 q 275 728 275 765 q 301 662 275 690 q 363 613 326 633 q 469 561 400 593 q 584 496 538 529 q 660 409 631 463 q 690 279 690 356 q 651 126 690 192 q 540 24 611 60 q 379 -11 469 -11 m 274 -72 l 485 -72 l 304 -328 l 213 -328 l 274 -72 z ',
    },
    ș: {
      ha: 619,
      x_min: 47,
      x_max: 561,
      o:
        'm 325 -11 q 144 44 217 -11 q 47 178 71 100 l 185 251 q 240 167 204 197 q 324 136 275 136 q 386 152 361 136 q 411 204 411 168 q 381 256 411 236 q 289 299 351 276 q 260 310 279 301 q 135 390 179 342 q 90 515 90 439 q 119 614 90 569 q 199 685 149 658 q 314 711 250 711 q 443 681 385 711 q 533 597 501 651 l 431 503 q 318 564 389 564 q 270 549 290 564 q 250 511 250 535 q 279 465 250 486 q 393 413 308 443 q 517 336 474 383 q 561 215 561 289 q 496 51 561 113 q 325 -11 431 -11 m 226 -72 l 438 -72 l 257 -328 l 165 -328 l 226 -72 z ',
    },
    Ț: {
      ha: 789,
      x_min: 33,
      x_max: 756,
      o:
        'm 304 806 l 33 806 l 33 972 l 756 972 l 756 806 l 485 806 l 485 0 l 304 0 l 304 806 m 289 -72 l 500 -72 l 319 -328 l 228 -328 l 289 -72 z ',
    },
    ț: {
      ha: 514,
      x_min: 13,
      x_max: 492,
      o:
        'm 378 -11 q 189 54 257 -11 q 121 247 121 119 l 121 553 l 13 553 l 13 700 l 121 700 l 121 875 l 293 983 l 293 700 l 478 700 l 478 553 l 293 553 l 293 250 q 316 162 293 188 q 385 136 339 136 q 451 153 419 136 l 492 14 q 378 -11 438 -11 m 224 -72 l 435 -72 l 254 -328 l 163 -328 l 224 -72 z ',
    },
    ȷ: {
      ha: 367,
      x_min: -65,
      x_max: 269,
      o:
        'm -65 -143 q 57 -78 17 -122 q 97 60 97 -33 l 97 700 l 269 700 l 269 81 q 198 -172 269 -83 q -24 -294 126 -260 l -65 -143 z ',
    },
    ˆ: {
      ha: 594,
      x_min: 50,
      x_max: 544,
      o:
        'm 274 1019 l 321 1019 l 544 778 l 386 778 l 297 874 l 208 778 l 50 778 l 274 1019 z ',
    },
    ˇ: {
      ha: 594,
      x_min: 50,
      x_max: 544,
      o:
        'm 50 1019 l 208 1019 l 297 924 l 386 1019 l 544 1019 l 321 778 l 274 778 l 50 1019 z ',
    },
    ˉ: {
      ha: 374,
      x_min: 0,
      x_max: 374,
      o: 'm 0 961 l 374 961 l 374 825 l 0 825 l 0 961 z ',
    },
    '˘': {
      ha: 372,
      x_min: 22,
      x_max: 350,
      o:
        'm 186 821 q 67 865 113 821 q 22 972 22 910 l 149 972 q 159 944 149 956 q 186 933 169 933 q 213 944 203 933 q 224 972 224 956 l 350 972 q 305 865 350 910 q 186 821 260 821 z ',
    },
    '˙': {
      ha: 400,
      x_min: 89,
      x_max: 311,
      o:
        'm 200 790 q 121 822 153 790 q 89 901 89 854 q 121 981 89 949 q 200 1013 153 1013 q 279 981 247 1013 q 311 901 311 949 q 279 822 311 854 q 200 790 247 790 z ',
    },
    '˚': {
      ha: 322,
      x_min: 14,
      x_max: 308,
      o:
        'm 161 768 q 56 808 99 768 q 14 910 14 849 q 56 1011 14 971 q 161 1051 99 1051 q 266 1011 224 1051 q 308 910 308 971 q 266 808 308 849 q 161 768 224 768 m 161 865 q 193 878 181 865 q 206 910 206 890 q 193 942 206 929 q 161 954 181 954 q 129 942 142 954 q 117 910 117 929 q 129 878 117 890 q 161 865 142 865 z ',
    },
    '˛': {
      ha: 318,
      x_min: 39,
      x_max: 264,
      o:
        'm 174 -257 q 76 -224 113 -257 q 39 -132 39 -190 q 61 -58 39 -93 q 118 0 83 -22 l 238 0 q 157 -108 157 -65 q 166 -135 157 -125 q 193 -144 175 -144 q 236 -131 213 -144 l 264 -236 q 174 -257 225 -257 z ',
    },
    '˜': {
      ha: 576,
      x_min: 21,
      x_max: 556,
      o:
        'm 21 867 q 92 954 44 921 q 192 988 139 988 q 249 979 225 988 q 300 956 272 971 q 340 937 325 943 q 376 931 356 931 q 465 990 422 931 l 556 914 q 485 826 532 860 q 385 793 438 793 q 328 801 351 793 q 276 825 304 810 q 236 844 251 838 q 200 850 221 850 q 111 790 154 850 l 21 867 z ',
    },
    '˝': {
      ha: 639,
      x_min: 17,
      x_max: 621,
      o:
        'm 106 983 l 339 983 l 147 778 l 17 778 l 106 983 m 388 983 l 621 983 l 429 778 l 299 778 l 388 983 z ',
    },
    '̀': {
      ha: 0,
      x_min: -326,
      x_max: 0,
      o: 'm -326 983 l -93 983 l 0 767 l -125 767 l -326 983 z ',
    },
    '́': {
      ha: 0,
      x_min: -326,
      x_max: 0,
      o: 'm -233 983 l 0 983 l -201 767 l -326 767 l -233 983 z ',
    },
    '̂': {
      ha: 0,
      x_min: -494,
      x_max: 0,
      o:
        'm -271 1019 l -224 1019 l 0 778 l -158 778 l -247 874 l -336 778 l -494 778 l -271 1019 z ',
    },
    '̃': {
      ha: 0,
      x_min: -535,
      x_max: 0,
      o:
        'm -535 867 q -464 954 -511 921 q -364 988 -417 988 q -307 979 -331 988 q -256 956 -283 971 q -215 937 -231 943 q -179 931 -200 931 q -90 990 -133 931 l 0 914 q -71 826 -24 860 q -171 793 -118 793 q -228 801 -204 793 q -279 825 -251 810 q -319 844 -304 838 q -356 850 -335 850 q -444 790 -401 850 l -535 867 z ',
    },
    '̄': {
      ha: 0,
      x_min: -374,
      x_max: 0,
      o: 'm -374 961 l 0 961 l 0 825 l -374 825 l -374 961 z ',
    },
    '̆': {
      ha: 0,
      x_min: -328,
      x_max: 0,
      o:
        'm -164 821 q -283 865 -237 821 q -328 972 -328 910 l -201 972 q -191 944 -201 956 q -164 933 -181 933 q -137 944 -147 933 q -126 972 -126 956 l 0 972 q -45 865 0 910 q -164 821 -90 821 z ',
    },
    '̇': {
      ha: 0,
      x_min: -222,
      x_max: 0,
      o:
        'm -111 790 q -190 822 -158 790 q -222 901 -222 854 q -190 981 -222 949 q -111 1013 -158 1013 q -32 981 -64 1013 q 0 901 0 949 q -32 822 0 854 q -111 790 -64 790 z ',
    },
    '̈': {
      ha: 0,
      x_min: -485,
      x_max: 0,
      o:
        'm -386 800 q -457 828 -429 800 q -485 899 -485 856 q -457 969 -485 942 q -386 997 -429 997 q -315 969 -343 997 q -287 899 -287 942 q -315 828 -287 856 q -386 800 -343 800 m -99 800 q -169 828 -142 800 q -197 899 -197 856 q -169 969 -197 942 q -99 997 -142 997 q -28 969 -56 997 q 0 899 0 942 q -28 828 0 856 q -99 800 -56 800 z ',
    },
    '̊': {
      ha: 0,
      x_min: -294,
      x_max: 0,
      o:
        'm -147 768 q -252 808 -210 768 q -294 910 -294 849 q -252 1011 -294 971 q -147 1051 -210 1051 q -42 1011 -85 1051 q 0 910 0 971 q -42 808 0 849 q -147 768 -85 768 m -147 865 q -115 878 -128 865 q -103 910 -103 890 q -115 942 -103 929 q -147 954 -128 954 q -179 942 -167 954 q -192 910 -192 929 q -179 878 -192 890 q -147 865 -167 865 z ',
    },
    '̋': {
      ha: 0,
      x_min: -604,
      x_max: 0,
      o:
        'm -515 983 l -282 983 l -474 778 l -604 778 l -515 983 m -233 983 l 0 983 l -192 778 l -322 778 l -233 983 z ',
    },
    '̌': {
      ha: 0,
      x_min: -494,
      x_max: 0,
      o:
        'm -494 1019 l -336 1019 l -247 924 l -158 1019 l 0 1019 l -224 778 l -271 778 l -494 1019 z ',
    },
    '̒': {
      ha: 0,
      x_min: -249,
      x_max: 0,
      o: 'm -111 1047 l 0 1047 l -60 814 l -249 814 l -111 1047 z ',
    },
    '̦': {
      ha: 0,
      x_min: -272,
      x_max: 0,
      o: 'm -211 -72 l 0 -72 l -181 -328 l -272 -328 l -211 -72 z ',
    },
    '̧': {
      ha: 0,
      x_min: -321,
      x_max: 0,
      o: 'm -321 -278 l -125 -83 l 0 -83 l -115 -369 l -321 -278 z ',
    },
    '̨': {
      ha: 0,
      x_min: -225,
      x_max: 0,
      o:
        'm -90 -257 q -188 -224 -151 -257 q -225 -132 -225 -190 q -203 -58 -225 -93 q -146 0 -181 -22 l -26 0 q -107 -108 -107 -65 q -98 -135 -107 -125 q -71 -144 -89 -144 q -28 -131 -51 -144 l 0 -236 q -90 -257 -39 -257 z ',
    },
    '̵': {
      ha: 0,
      x_min: -426,
      x_max: 0,
      o: 'm -426 550 l 0 550 l 0 422 l -426 422 l -426 550 z ',
    },
    '̶': {
      ha: 0,
      x_min: -929,
      x_max: 0,
      o: 'm -929 561 l 0 561 l 0 411 l -929 411 l -929 561 z ',
    },
    '̷': {
      ha: 0,
      x_min: -456,
      x_max: 0,
      o: 'm -456 467 l -74 675 l 0 543 l -382 335 l -456 467 z ',
    },
    '̸': {
      ha: 0,
      x_min: -731,
      x_max: 0,
      o: 'm -731 4 l -119 783 l 0 696 l -611 -83 l -731 4 z ',
    },
    ';': {
      ha: 383,
      x_min: 32,
      x_max: 357,
      o:
        'm 240 478 q 157 511 190 478 q 124 594 124 544 q 157 678 124 644 q 240 711 190 711 q 324 678 290 711 q 357 594 357 644 q 324 511 357 544 q 240 478 290 478 m 125 189 l 357 189 l 163 -189 l 32 -189 l 125 189 z ',
    },
    '΄': {
      ha: 453,
      x_min: 83,
      x_max: 369,
      o: 'm 142 983 l 369 983 l 214 778 l 83 778 l 142 983 z ',
    },
    '΅': {
      ha: 610,
      x_min: 22,
      x_max: 588,
      o:
        'm 254 983 l 440 983 l 299 778 l 196 778 l 254 983 m 97 800 q 44 822 65 800 q 22 875 22 843 q 44 930 22 907 q 97 953 65 953 q 153 931 131 953 q 175 875 175 908 q 153 822 175 843 q 97 800 131 800 m 510 800 q 457 822 479 800 q 435 875 435 844 q 457 930 435 907 q 510 953 479 953 q 565 930 543 953 q 588 875 588 907 q 565 822 588 843 q 510 800 543 800 z ',
    },
    Ά: {
      ha: 917,
      x_min: 0,
      x_max: 903,
      o:
        'm 393 972 l 574 972 l 903 0 l 708 0 l 638 229 l 329 229 l 258 0 l 64 0 l 393 972 m 586 396 l 483 733 l 381 396 l 586 396 m 58 972 l 286 972 l 131 767 l 0 767 l 58 972 z ',
    },
    '·': {
      ha: 383,
      x_min: 75,
      x_max: 308,
      o:
        'm 192 369 q 108 403 142 369 q 75 486 75 436 q 108 569 75 536 q 192 603 142 603 q 275 569 242 603 q 308 486 308 536 q 275 403 308 436 q 192 369 242 369 z ',
    },
    Έ: {
      ha: 1038,
      x_min: 0,
      x_max: 968,
      o:
        'm 353 972 l 954 972 l 954 806 l 533 806 l 533 601 l 871 601 l 871 435 l 533 435 l 533 167 l 968 167 l 968 0 l 353 0 l 353 972 m 58 972 l 286 972 l 131 767 l 0 767 l 58 972 z ',
    },
    Ή: {
      ha: 1214,
      x_min: 0,
      x_max: 1103,
      o:
        'm 353 972 l 533 972 l 533 603 l 922 603 l 922 972 l 1103 972 l 1103 0 l 922 0 l 922 436 l 533 436 l 533 0 l 353 0 l 353 972 m 58 972 l 286 972 l 131 767 l 0 767 l 58 972 z ',
    },
    Ί: {
      ha: 644,
      x_min: 0,
      x_max: 533,
      o:
        'm 353 972 l 533 972 l 533 0 l 353 0 l 353 972 m 58 972 l 286 972 l 131 767 l 0 767 l 58 972 z ',
    },
    Ό: {
      ha: 1186,
      x_min: 0,
      x_max: 1122,
      o:
        'm 664 -11 q 433 44 538 -11 q 267 212 329 100 q 206 486 206 324 q 267 760 206 649 q 433 928 329 872 q 664 983 538 983 q 894 928 790 983 q 1060 760 999 872 q 1122 486 1122 649 q 1060 212 1122 324 q 894 44 999 100 q 664 -11 790 -11 m 664 156 q 802 191 740 156 q 901 301 864 226 q 939 486 939 375 q 901 672 939 597 q 802 781 864 746 q 664 817 740 817 q 526 781 588 817 q 426 672 464 746 q 389 486 389 597 q 426 301 389 375 q 526 191 464 226 q 664 156 588 156 m 58 972 l 286 972 l 131 767 l 0 767 l 58 972 z ',
    },
    Ύ: {
      ha: 1067,
      x_min: 0,
      x_max: 1054,
      o:
        'm 593 414 l 313 972 l 507 972 l 683 594 l 860 972 l 1054 972 l 774 414 l 774 0 l 593 0 l 593 414 m 58 972 l 286 972 l 131 767 l 0 767 l 58 972 z ',
    },
    Ώ: {
      ha: 1128,
      x_min: 0,
      x_max: 1089,
      o:
        'm 200 153 l 399 153 q 255 331 310 238 q 200 560 200 425 q 254 778 200 682 q 409 928 308 874 q 644 983 510 983 q 880 928 779 983 q 1035 778 981 874 q 1089 560 1089 682 q 1034 331 1089 425 q 890 153 979 238 l 1089 153 l 1089 0 l 704 0 l 704 153 q 851 326 797 224 q 906 543 906 428 q 833 744 906 671 q 644 817 760 817 q 456 744 529 817 q 383 543 383 671 q 438 326 383 428 q 585 153 492 224 l 585 0 l 200 0 l 200 153 m 58 972 l 286 972 l 131 767 l 0 767 l 58 972 z ',
    },
    ΐ: {
      ha: 367,
      x_min: -100,
      x_max: 465,
      o:
        'm 97 700 l 269 700 l 269 0 l 97 0 l 97 700 m 132 983 l 318 983 l 176 778 l 74 778 l 132 983 m -25 800 q -78 822 -57 800 q -100 875 -100 843 q -78 930 -100 907 q -25 953 -57 953 q 31 931 8 953 q 53 875 53 908 q 31 822 53 843 q -25 800 8 800 m 388 800 q 335 822 357 800 q 313 875 313 844 q 335 930 313 907 q 388 953 357 953 q 443 930 421 953 q 465 875 465 907 q 443 822 465 843 q 388 800 421 800 z ',
    },
    Α: {
      ha: 867,
      x_min: 14,
      x_max: 853,
      o:
        'm 343 972 l 524 972 l 853 0 l 658 0 l 588 229 l 279 229 l 208 0 l 14 0 l 343 972 m 536 396 l 433 733 l 331 396 l 536 396 z ',
    },
    Β: {
      ha: 858,
      x_min: 111,
      x_max: 794,
      o:
        'm 111 972 l 467 972 q 669 906 594 972 q 744 710 744 839 q 719 602 744 650 q 649 531 694 554 q 794 293 794 471 q 709 76 794 153 q 474 0 624 0 l 111 0 l 111 972 m 457 594 q 542 619 514 594 q 571 700 571 643 q 542 781 571 757 q 453 806 513 806 l 292 806 l 292 594 l 457 594 m 457 167 q 576 200 539 167 q 614 297 614 233 q 576 394 614 361 q 457 428 539 428 l 292 428 l 292 167 l 457 167 z ',
    },
    Γ: {
      ha: 747,
      x_min: 111,
      x_max: 714,
      o: 'm 111 972 l 714 972 l 714 806 l 292 806 l 292 0 l 111 0 l 111 972 z ',
    },
    Δ: {
      ha: 867,
      x_min: 14,
      x_max: 853,
      o:
        'm 853 0 l 14 0 l 343 972 l 524 972 l 853 0 m 607 167 l 433 733 l 260 167 l 607 167 z ',
    },
    Ε: {
      ha: 796,
      x_min: 111,
      x_max: 726,
      o:
        'm 111 972 l 713 972 l 713 806 l 292 806 l 292 601 l 629 601 l 629 435 l 292 435 l 292 167 l 726 167 l 726 0 l 111 0 l 111 972 z ',
    },
    Ζ: {
      ha: 788,
      x_min: 50,
      x_max: 738,
      o:
        'm 50 83 l 471 806 l 74 806 l 74 972 l 718 972 l 718 889 l 301 167 l 738 167 l 738 0 l 50 0 l 50 83 z ',
    },
    Η: {
      ha: 972,
      x_min: 111,
      x_max: 861,
      o:
        'm 111 972 l 292 972 l 292 603 l 681 603 l 681 972 l 861 972 l 861 0 l 681 0 l 681 436 l 292 436 l 292 0 l 111 0 l 111 972 z ',
    },
    Θ: {
      ha: 1044,
      x_min: 64,
      x_max: 981,
      o:
        'm 522 -11 q 292 44 396 -11 q 126 212 188 100 q 64 486 64 324 q 126 760 64 649 q 292 928 188 872 q 522 983 396 983 q 753 928 649 983 q 919 760 857 872 q 981 486 981 649 q 919 212 981 324 q 753 44 857 100 q 522 -11 649 -11 m 522 156 q 660 191 599 156 q 760 301 722 226 q 797 486 797 375 q 760 672 797 597 q 660 781 722 746 q 522 817 599 817 q 384 781 446 817 q 285 672 322 746 q 247 486 247 597 q 285 301 247 375 q 384 191 322 226 q 522 156 446 156 m 336 554 l 710 554 l 710 418 l 336 418 l 336 554 z ',
    },
    Ι: {
      ha: 403,
      x_min: 111,
      x_max: 292,
      o: 'm 111 972 l 292 972 l 292 0 l 111 0 l 111 972 z ',
    },
    Κ: {
      ha: 888,
      x_min: 111,
      x_max: 874,
      o:
        'm 111 972 l 292 972 l 292 611 l 624 972 l 846 972 l 451 538 l 874 0 l 644 0 l 292 464 l 292 0 l 111 0 l 111 972 z ',
    },
    Λ: {
      ha: 867,
      x_min: 14,
      x_max: 853,
      o:
        'm 343 972 l 524 972 l 853 0 l 658 0 l 433 733 l 208 0 l 14 0 l 343 972 z ',
    },
    Μ: {
      ha: 1086,
      x_min: 111,
      x_max: 975,
      o:
        'm 111 972 l 314 972 l 543 365 l 772 972 l 975 972 l 975 0 l 794 0 l 794 600 l 608 89 l 478 89 l 292 600 l 292 0 l 111 0 l 111 972 z ',
    },
    Ν: {
      ha: 950,
      x_min: 111,
      x_max: 839,
      o:
        'm 111 972 l 301 972 l 658 331 l 658 972 l 839 972 l 839 0 l 649 0 l 292 642 l 292 0 l 111 0 l 111 972 z ',
    },
    Ξ: {
      ha: 786,
      x_min: 69,
      x_max: 717,
      o:
        'm 83 972 l 703 972 l 703 806 l 83 806 l 83 972 m 158 601 l 628 601 l 628 435 l 158 435 l 158 601 m 69 167 l 717 167 l 717 0 l 69 0 l 69 167 z ',
    },
    Ο: {
      ha: 1044,
      x_min: 64,
      x_max: 981,
      o:
        'm 522 -11 q 292 44 396 -11 q 126 212 188 100 q 64 486 64 324 q 126 760 64 649 q 292 928 188 872 q 522 983 396 983 q 753 928 649 983 q 919 760 857 872 q 981 486 981 649 q 919 212 981 324 q 753 44 857 100 q 522 -11 649 -11 m 522 156 q 660 191 599 156 q 760 301 722 226 q 797 486 797 375 q 760 672 797 597 q 660 781 722 746 q 522 817 599 817 q 384 781 446 817 q 285 672 322 746 q 247 486 247 597 q 285 301 247 375 q 384 191 322 226 q 522 156 446 156 z ',
    },
    Π: {
      ha: 933,
      x_min: 111,
      x_max: 822,
      o:
        'm 111 972 l 822 972 l 822 0 l 642 0 l 642 800 l 292 800 l 292 0 l 111 0 l 111 972 z ',
    },
    Ρ: {
      ha: 829,
      x_min: 111,
      x_max: 782,
      o:
        'm 111 972 l 478 972 q 704 891 626 972 q 782 676 782 810 q 704 462 782 543 q 478 381 626 381 l 292 381 l 292 0 l 111 0 l 111 972 m 471 547 q 565 579 532 547 q 599 676 599 611 q 565 774 599 742 q 471 806 532 806 l 292 806 l 292 547 l 471 547 z ',
    },
    Σ: {
      ha: 778,
      x_min: 72,
      x_max: 708,
      o:
        'm 72 83 l 331 486 l 72 889 l 72 972 l 697 972 l 697 806 l 326 806 l 514 506 l 514 467 l 326 167 l 708 167 l 708 0 l 72 0 l 72 83 z ',
    },
    Τ: {
      ha: 789,
      x_min: 33,
      x_max: 756,
      o:
        'm 304 806 l 33 806 l 33 972 l 756 972 l 756 806 l 485 806 l 485 0 l 304 0 l 304 806 z ',
    },
    Υ: {
      ha: 767,
      x_min: 13,
      x_max: 754,
      o:
        'm 293 414 l 13 972 l 207 972 l 383 594 l 560 972 l 754 972 l 474 414 l 474 0 l 293 0 l 293 414 z ',
    },
    Φ: {
      ha: 1067,
      x_min: 64,
      x_max: 1003,
      o:
        'm 443 103 q 263 149 350 103 q 119 283 175 196 q 64 486 64 371 q 119 689 64 601 q 263 823 175 776 q 443 869 350 869 l 443 972 l 624 972 l 624 869 q 804 823 717 869 q 947 689 892 776 q 1003 486 1003 601 q 947 283 1003 371 q 804 149 892 196 q 624 103 717 103 l 624 0 l 443 0 l 443 103 m 443 703 q 306 651 364 703 q 247 486 247 599 q 306 322 247 374 q 443 269 364 269 l 443 703 m 624 269 q 761 322 703 269 q 819 486 819 374 q 761 651 819 599 q 624 703 703 703 l 624 269 z ',
    },
    Χ: {
      ha: 839,
      x_min: 18,
      x_max: 821,
      o:
        'm 321 525 l 64 972 l 261 972 l 419 697 l 578 972 l 775 972 l 518 525 l 821 0 l 621 0 l 419 351 l 218 0 l 18 0 l 321 525 z ',
    },
    Ψ: {
      ha: 1064,
      x_min: 100,
      x_max: 964,
      o:
        'm 442 253 q 184 349 268 256 q 100 611 100 442 l 100 972 l 281 972 l 281 611 q 323 473 281 522 q 442 419 365 424 l 442 972 l 622 972 l 622 419 q 741 473 699 424 q 783 611 783 522 l 783 972 l 964 972 l 964 611 q 880 349 964 442 q 622 253 796 256 l 622 0 l 442 0 l 442 253 z ',
    },
    Ω: {
      ha: 967,
      x_min: 39,
      x_max: 928,
      o:
        'm 39 153 l 238 153 q 94 331 149 238 q 39 560 39 425 q 93 778 39 682 q 248 928 147 874 q 483 983 349 983 q 719 928 618 983 q 874 778 819 874 q 928 560 928 682 q 873 331 928 425 q 729 153 818 238 l 928 153 l 928 0 l 543 0 l 543 153 q 690 326 636 224 q 744 543 744 428 q 672 744 744 671 q 483 817 599 817 q 295 744 368 817 q 222 543 222 671 q 276 326 222 428 q 424 153 331 224 l 424 0 l 39 0 l 39 153 z ',
    },
    Ϊ: {
      ha: 403,
      x_min: -42,
      x_max: 443,
      o:
        'm 111 972 l 292 972 l 292 0 l 111 0 l 111 972 m 57 1072 q -14 1100 14 1072 q -42 1171 -42 1128 q -14 1242 -42 1214 q 57 1269 14 1269 q 128 1242 100 1269 q 156 1171 156 1214 q 128 1100 156 1128 q 57 1072 100 1072 m 344 1072 q 274 1100 301 1072 q 246 1171 246 1128 q 274 1242 246 1214 q 344 1269 301 1269 q 415 1242 388 1269 q 443 1171 443 1214 q 415 1100 443 1128 q 344 1072 388 1072 z ',
    },
    Ϋ: {
      ha: 767,
      x_min: 13,
      x_max: 754,
      o:
        'm 293 414 l 13 972 l 207 972 l 383 594 l 560 972 l 754 972 l 474 414 l 474 0 l 293 0 l 293 414 m 239 1072 q 168 1100 196 1072 q 140 1171 140 1128 q 168 1242 140 1214 q 239 1269 196 1269 q 310 1242 282 1269 q 338 1171 338 1214 q 310 1100 338 1128 q 239 1072 282 1072 m 526 1072 q 456 1100 483 1072 q 428 1171 428 1128 q 456 1242 428 1214 q 526 1269 483 1269 q 597 1242 569 1269 q 625 1171 625 1214 q 597 1100 625 1128 q 526 1072 569 1072 z ',
    },
    ά: {
      ha: 817,
      x_min: 58,
      x_max: 719,
      o:
        'm 364 -11 q 138 87 218 -11 q 58 350 58 185 q 138 613 58 515 q 364 711 218 711 q 473 690 424 711 q 547 636 522 668 l 547 700 l 719 700 l 719 0 l 547 0 l 547 72 q 481 15 531 40 q 364 -11 432 -11 m 401 136 q 517 192 472 136 q 563 350 563 249 q 517 508 563 451 q 401 564 472 564 q 285 508 331 564 q 239 350 239 451 q 285 193 239 250 q 401 136 331 136 m 374 983 l 601 983 l 446 778 l 315 778 l 374 983 z ',
    },
    έ: {
      ha: 618,
      x_min: 56,
      x_max: 571,
      o:
        'm 315 -11 q 127 49 199 -11 q 56 210 56 110 q 86 313 56 271 q 168 375 117 354 q 88 526 88 426 q 147 658 88 604 q 315 711 207 711 q 472 666 414 711 q 547 547 531 621 l 404 513 q 374 562 394 546 q 318 578 354 578 q 257 557 279 578 q 235 504 235 536 q 263 447 235 468 q 340 425 290 425 l 376 425 l 376 308 l 336 308 q 251 285 283 308 q 219 219 219 261 q 246 157 219 181 q 315 133 272 133 q 383 157 356 133 q 417 224 411 181 l 571 203 q 492 49 563 108 q 315 -11 422 -11 m 299 983 l 526 983 l 371 778 l 240 778 l 299 983 z ',
    },
    ή: {
      ha: 799,
      x_min: 97,
      x_max: 701,
      o:
        'm 529 449 q 502 536 529 508 q 429 564 475 564 q 350 531 386 564 q 292 433 314 497 q 269 279 269 368 l 269 0 l 97 0 l 97 700 l 269 700 l 269 588 q 365 678 310 644 q 486 711 421 711 q 642 657 583 711 q 701 500 701 603 l 701 -283 l 529 -283 l 529 449 m 392 983 l 619 983 l 464 778 l 333 778 l 392 983 z ',
    },
    ί: {
      ha: 367,
      x_min: 97,
      x_max: 397,
      o:
        'm 97 700 l 269 700 l 269 0 l 97 0 l 97 700 m 169 983 l 397 983 l 242 778 l 111 778 l 169 983 z ',
    },
    ΰ: {
      ha: 789,
      x_min: 92,
      x_max: 697,
      o:
        'm 394 -11 q 168 71 244 -11 q 92 306 92 153 l 92 700 l 264 700 l 264 283 q 301 173 264 210 q 394 136 339 136 q 488 173 450 136 q 525 283 525 210 l 525 700 l 697 700 l 697 306 q 621 71 697 153 q 394 -11 544 -11 m 343 983 l 529 983 l 388 778 l 285 778 l 343 983 m 186 800 q 133 822 154 800 q 111 875 111 843 q 133 930 111 907 q 186 953 154 953 q 242 931 219 953 q 264 875 264 908 q 242 822 264 843 q 186 800 219 800 m 599 800 q 546 822 568 800 q 524 875 524 844 q 546 930 524 907 q 599 953 568 953 q 654 930 632 953 q 676 875 676 907 q 654 822 676 843 q 599 800 632 800 z ',
    },
    α: {
      ha: 817,
      x_min: 58,
      x_max: 719,
      o:
        'm 364 -11 q 138 87 218 -11 q 58 350 58 185 q 138 613 58 515 q 364 711 218 711 q 473 690 424 711 q 547 636 522 668 l 547 700 l 719 700 l 719 0 l 547 0 l 547 72 q 481 15 531 40 q 364 -11 432 -11 m 401 136 q 517 192 472 136 q 563 350 563 249 q 517 508 563 451 q 401 564 472 564 q 285 508 331 564 q 239 350 239 451 q 285 193 239 250 q 401 136 331 136 z ',
    },
    β: {
      ha: 776,
      x_min: 97,
      x_max: 718,
      o:
        'm 97 681 q 134 847 97 779 q 235 949 171 915 q 376 983 299 983 q 572 917 503 983 q 640 738 640 850 q 608 623 640 672 q 529 557 576 574 q 664 466 610 535 q 718 296 718 397 q 642 67 718 146 q 436 -11 567 -11 q 333 10 379 -11 q 264 65 288 32 l 264 -283 l 97 -283 l 97 681 m 406 139 q 515 181 478 139 q 551 294 551 222 q 506 411 551 369 q 385 453 461 453 l 339 453 l 339 608 l 367 608 q 452 637 421 608 q 483 722 483 665 q 455 806 483 776 q 376 836 426 836 q 294 803 324 836 q 264 706 264 771 l 264 297 q 302 181 264 224 q 406 139 340 139 z ',
    },
    γ: {
      ha: 667,
      x_min: 18,
      x_max: 649,
      o:
        'm 244 25 l 18 700 l 192 700 l 333 213 l 475 700 l 649 700 l 417 25 l 417 -283 l 244 -283 l 244 25 z ',
    },
    δ: {
      ha: 828,
      x_min: 58,
      x_max: 769,
      o:
        'm 414 -11 q 224 36 304 -11 q 101 165 143 83 q 58 350 58 247 q 99 526 58 447 q 205 650 139 604 q 342 703 271 696 l 153 842 l 153 972 l 685 972 l 685 825 l 407 825 l 619 654 q 732 519 694 593 q 769 350 769 444 q 727 165 769 247 q 604 36 685 83 q 414 -11 524 -11 m 414 136 q 542 198 494 136 q 589 350 589 260 q 542 502 589 440 q 414 564 494 564 q 286 502 333 564 q 239 350 239 440 q 286 198 239 260 q 414 136 333 136 z ',
    },
    ε: {
      ha: 618,
      x_min: 56,
      x_max: 571,
      o:
        'm 315 -11 q 127 49 199 -11 q 56 210 56 110 q 86 313 56 271 q 168 375 117 354 q 88 526 88 426 q 147 658 88 604 q 315 711 207 711 q 472 666 414 711 q 547 547 531 621 l 404 513 q 374 562 394 546 q 318 578 354 578 q 257 557 279 578 q 235 504 235 536 q 263 447 235 468 q 340 425 290 425 l 376 425 l 376 308 l 336 308 q 251 285 283 308 q 219 219 219 261 q 246 157 219 181 q 315 133 272 133 q 383 157 356 133 q 417 224 411 181 l 571 203 q 492 49 563 108 q 315 -11 422 -11 z ',
    },
    ζ: {
      ha: 689,
      x_min: 47,
      x_max: 676,
      o:
        'm 407 -294 q 194 -231 272 -294 l 281 -99 q 407 -150 328 -150 q 475 -130 449 -150 q 501 -69 501 -110 q 471 -6 501 -28 q 382 15 440 15 l 324 15 q 122 90 196 15 q 47 292 47 164 q 87 451 47 381 q 207 601 126 521 l 428 825 l 86 825 l 86 972 l 647 972 l 647 836 l 335 513 q 247 403 274 450 q 219 300 219 357 q 260 197 219 233 q 364 160 300 160 l 415 160 q 607 99 538 160 q 676 -72 676 38 q 603 -233 676 -172 q 407 -294 531 -294 z ',
    },
    η: {
      ha: 799,
      x_min: 97,
      x_max: 701,
      o:
        'm 529 449 q 502 536 529 508 q 429 564 475 564 q 350 531 386 564 q 292 433 314 497 q 269 279 269 368 l 269 0 l 97 0 l 97 700 l 269 700 l 269 588 q 365 678 310 644 q 486 711 421 711 q 642 657 583 711 q 701 500 701 603 l 701 -283 l 529 -283 l 529 449 z ',
    },
    θ: {
      ha: 883,
      x_min: 58,
      x_max: 825,
      o:
        'm 442 983 q 726 850 628 983 q 825 486 825 717 q 726 122 825 256 q 442 -11 628 -11 q 157 122 256 -11 q 58 486 58 256 q 157 850 58 717 q 442 983 256 983 m 442 836 q 306 767 358 836 q 242 560 253 697 l 642 560 q 578 767 631 697 q 442 836 525 836 m 442 136 q 578 206 525 136 q 642 413 631 275 l 242 413 q 306 206 253 275 q 442 136 358 136 z ',
    },
    ι: {
      ha: 367,
      x_min: 97,
      x_max: 269,
      o: 'm 97 700 l 269 700 l 269 0 l 97 0 l 97 700 z ',
    },
    κ: {
      ha: 736,
      x_min: 97,
      x_max: 728,
      o:
        'm 97 700 l 269 700 l 269 425 l 497 700 l 710 700 l 429 378 l 728 0 l 517 0 l 269 331 l 269 0 l 97 0 l 97 700 z ',
    },
    λ: {
      ha: 689,
      x_min: 14,
      x_max: 675,
      o:
        'm 268 656 l 231 757 q 199 817 214 799 q 149 835 183 835 q 110 829 126 835 l 69 968 q 165 983 119 983 q 372 824 315 982 l 675 0 l 503 0 l 350 439 l 188 0 l 14 0 l 268 656 z ',
    },
    μ: {
      ha: 799,
      x_min: 97,
      x_max: 701,
      o:
        'm 97 700 l 269 700 l 269 251 q 297 164 269 192 q 369 136 324 136 q 449 169 413 136 q 507 267 485 203 q 529 421 529 332 l 529 700 l 701 700 l 701 0 l 529 0 l 529 113 q 457 20 499 51 q 360 -11 415 -11 q 306 -2 329 -11 q 269 21 282 7 l 269 -283 l 97 -283 l 97 700 z ',
    },
    ν: {
      ha: 667,
      x_min: 18,
      x_max: 649,
      o:
        'm 18 700 l 192 700 l 333 213 l 475 700 l 649 700 l 411 0 l 256 0 l 18 700 z ',
    },
    ξ: {
      ha: 689,
      x_min: 58,
      x_max: 676,
      o:
        'm 393 -294 q 263 -267 325 -294 q 150 -185 200 -240 l 239 -76 q 317 -135 282 -121 q 393 -150 353 -150 q 461 -130 435 -150 q 488 -69 488 -110 q 457 -6 488 -28 q 368 15 426 15 l 354 15 q 141 88 224 15 q 58 296 58 161 q 101 440 58 382 q 208 531 143 499 q 90 739 90 594 q 128 859 90 803 q 233 949 165 915 q 385 983 300 983 q 580 928 500 983 q 676 764 660 872 l 521 719 q 474 806 511 775 q 385 836 438 836 q 296 806 332 836 q 260 721 260 775 q 298 636 260 669 q 400 603 336 603 l 506 603 l 506 461 l 396 461 q 278 419 325 461 q 231 307 231 378 q 272 199 231 239 q 390 160 314 160 l 417 160 q 598 103 533 160 q 663 -69 663 47 q 627 -186 663 -135 q 530 -266 592 -237 q 393 -294 468 -294 z ',
    },
    ο: {
      ha: 828,
      x_min: 58,
      x_max: 769,
      o:
        'm 414 -11 q 224 36 304 -11 q 101 165 143 83 q 58 350 58 247 q 101 535 58 453 q 224 664 143 617 q 414 711 304 711 q 604 664 524 711 q 727 535 685 617 q 769 350 769 453 q 727 165 769 247 q 604 36 685 83 q 414 -11 524 -11 m 414 136 q 542 198 494 136 q 589 350 589 260 q 542 502 589 440 q 414 564 494 564 q 286 502 333 564 q 239 350 239 440 q 286 198 239 260 q 414 136 333 136 z ',
    },
    π: {
      ha: 829,
      x_min: 28,
      x_max: 801,
      o:
        'm 143 550 l 28 550 l 28 700 l 801 700 l 801 550 l 686 550 l 686 0 l 514 0 l 514 550 l 315 550 l 315 0 l 143 0 l 143 550 z ',
    },
    ρ: {
      ha: 817,
      x_min: 97,
      x_max: 758,
      o:
        'm 97 356 q 139 544 97 464 q 258 667 181 624 q 439 711 335 711 q 676 613 593 711 q 758 350 758 515 q 676 87 758 185 q 439 -11 593 -11 q 340 11 388 -11 q 269 64 293 33 l 269 -283 l 97 -283 l 97 356 m 424 136 q 535 192 493 136 q 578 350 578 249 q 535 508 578 451 q 424 564 493 564 q 312 508 354 564 q 269 350 269 451 q 312 192 269 249 q 424 136 354 136 z ',
    },
    ς: {
      ha: 768,
      x_min: 58,
      x_max: 718,
      o:
        'm 419 -294 q 207 -231 285 -294 l 293 -99 q 419 -150 340 -150 q 486 -132 458 -150 q 514 -76 514 -114 q 488 -18 514 -39 q 418 3 463 3 l 400 3 q 216 48 293 3 q 99 172 139 93 q 58 350 58 250 q 97 533 58 451 q 213 663 136 615 q 400 711 290 711 q 598 660 517 711 q 718 511 679 610 l 564 449 q 497 535 536 506 q 400 564 457 564 q 284 510 329 564 q 239 367 239 457 q 297 204 239 258 q 443 150 356 150 l 474 150 q 628 93 568 150 q 689 -72 689 36 q 613 -236 689 -178 q 419 -294 536 -294 z ',
    },
    σ: {
      ha: 828,
      x_min: 58,
      x_max: 803,
      o:
        'm 803 553 l 710 553 q 769 343 769 475 q 727 163 769 243 q 604 35 685 82 q 414 -11 524 -11 q 224 36 304 -11 q 101 165 143 83 q 58 350 58 247 q 101 535 58 453 q 224 664 143 617 q 414 711 304 711 q 513 700 464 711 l 803 700 l 803 553 m 414 136 q 542 198 494 136 q 589 350 589 260 q 542 502 589 440 q 414 564 494 564 q 286 502 333 564 q 239 350 239 440 q 286 198 239 260 q 414 136 333 136 z ',
    },
    τ: {
      ha: 572,
      x_min: 13,
      x_max: 560,
      o:
        'm 200 553 l 13 553 l 13 700 l 560 700 l 560 553 l 372 553 l 372 0 l 200 0 l 200 553 z ',
    },
    υ: {
      ha: 789,
      x_min: 92,
      x_max: 697,
      o:
        'm 394 -11 q 168 71 244 -11 q 92 306 92 153 l 92 700 l 264 700 l 264 283 q 301 173 264 210 q 394 136 339 136 q 488 173 450 136 q 525 283 525 210 l 525 700 l 697 700 l 697 306 q 621 71 697 153 q 394 -11 544 -11 z ',
    },
    φ: {
      ha: 1000,
      x_min: 58,
      x_max: 942,
      o:
        'm 414 -11 q 229 38 310 -8 q 103 166 149 85 q 58 350 58 247 q 101 527 58 449 q 223 654 143 606 q 414 710 303 703 l 414 867 l 586 867 l 586 710 q 777 654 697 703 q 899 527 857 606 q 942 350 942 449 q 897 166 942 247 q 771 38 851 85 q 586 -11 690 -8 l 586 -283 l 414 -283 l 414 -11 m 414 564 q 288 502 336 563 q 239 350 239 442 q 288 198 239 258 q 414 136 336 138 l 414 564 m 586 136 q 713 198 664 138 q 761 350 761 258 q 713 502 761 442 q 586 564 664 563 l 586 136 z ',
    },
    χ: {
      ha: 667,
      x_min: 10,
      x_max: 657,
      o:
        'm 242 374 l 39 700 l 219 700 l 333 518 l 447 700 l 628 700 l 425 374 l 657 0 l 476 0 l 333 228 l 190 0 l 10 0 l 242 374 z ',
    },
    ψ: {
      ha: 1011,
      x_min: 97,
      x_max: 914,
      o:
        'm 419 -11 q 182 72 267 -11 q 97 306 97 156 l 97 700 l 269 700 l 269 297 q 311 178 269 221 q 419 136 353 136 l 419 867 l 592 867 l 592 136 q 700 178 658 136 q 742 297 742 221 l 742 700 l 914 700 l 914 306 q 829 72 914 156 q 592 -11 744 -11 l 592 -283 l 419 -283 l 419 -11 z ',
    },
    ω: {
      ha: 1047,
      x_min: 50,
      x_max: 997,
      o:
        'm 315 -11 q 128 60 206 -11 q 50 289 50 132 q 204 711 50 496 l 346 613 q 259 449 288 526 q 231 279 231 371 q 261 172 231 208 q 339 136 292 136 q 411 170 385 136 q 438 265 438 204 l 438 519 l 610 519 l 610 265 q 636 170 610 204 q 708 136 663 136 q 786 172 756 136 q 817 279 817 208 q 788 449 817 371 q 701 613 760 526 l 843 711 q 997 289 997 496 q 919 60 997 132 q 732 -11 842 -11 q 596 31 650 -11 q 524 136 542 72 q 451 31 504 72 q 315 -11 397 -11 z ',
    },
    ϊ: {
      ha: 367,
      x_min: -60,
      x_max: 425,
      o:
        'm 97 700 l 269 700 l 269 0 l 97 0 l 97 700 m 39 800 q -32 828 -4 800 q -60 899 -60 856 q -32 969 -60 942 q 39 997 -4 997 q 110 969 82 997 q 138 899 138 942 q 110 828 138 856 q 39 800 82 800 m 326 800 q 256 828 283 800 q 228 899 228 856 q 256 969 228 942 q 326 997 283 997 q 397 969 369 997 q 425 899 425 942 q 397 828 425 856 q 326 800 369 800 z ',
    },
    ϋ: {
      ha: 789,
      x_min: 92,
      x_max: 697,
      o:
        'm 394 -11 q 168 71 244 -11 q 92 306 92 153 l 92 700 l 264 700 l 264 283 q 301 173 264 210 q 394 136 339 136 q 488 173 450 136 q 525 283 525 210 l 525 700 l 697 700 l 697 306 q 621 71 697 153 q 394 -11 544 -11 m 250 800 q 179 828 207 800 q 151 899 151 856 q 179 969 151 942 q 250 997 207 997 q 321 969 293 997 q 349 899 349 942 q 321 828 349 856 q 250 800 293 800 m 538 800 q 467 828 494 800 q 439 899 439 856 q 467 969 439 942 q 538 997 494 997 q 608 969 581 997 q 636 899 636 942 q 608 828 636 856 q 538 800 581 800 z ',
    },
    ό: {
      ha: 828,
      x_min: 58,
      x_max: 769,
      o:
        'm 414 -11 q 224 36 304 -11 q 101 165 143 83 q 58 350 58 247 q 101 535 58 453 q 224 664 143 617 q 414 711 304 711 q 604 664 524 711 q 727 535 685 617 q 769 350 769 453 q 727 165 769 247 q 604 36 685 83 q 414 -11 524 -11 m 414 136 q 542 198 494 136 q 589 350 589 260 q 542 502 589 440 q 414 564 494 564 q 286 502 333 564 q 239 350 239 440 q 286 198 239 260 q 414 136 333 136 m 400 983 l 628 983 l 472 778 l 342 778 l 400 983 z ',
    },
    ύ: {
      ha: 789,
      x_min: 92,
      x_max: 697,
      o:
        'm 394 -11 q 168 71 244 -11 q 92 306 92 153 l 92 700 l 264 700 l 264 283 q 301 173 264 210 q 394 136 339 136 q 488 173 450 136 q 525 283 525 210 l 525 700 l 697 700 l 697 306 q 621 71 697 153 q 394 -11 544 -11 m 381 983 l 608 983 l 453 778 l 322 778 l 381 983 z ',
    },
    ώ: {
      ha: 1047,
      x_min: 50,
      x_max: 997,
      o:
        'm 315 -11 q 128 60 206 -11 q 50 289 50 132 q 204 711 50 496 l 346 613 q 259 449 288 526 q 231 279 231 371 q 261 172 231 208 q 339 136 292 136 q 411 170 385 136 q 438 265 438 204 l 438 519 l 610 519 l 610 265 q 636 170 610 204 q 708 136 663 136 q 786 172 756 136 q 817 279 817 208 q 788 449 817 371 q 701 613 760 526 l 843 711 q 997 289 997 496 q 919 60 997 132 q 732 -11 842 -11 q 596 31 650 -11 q 524 136 542 72 q 451 31 504 72 q 315 -11 397 -11 m 510 983 l 738 983 l 582 778 l 451 778 l 510 983 z ',
    },
    Ѐ: {
      ha: 796,
      x_min: 111,
      x_max: 726,
      o:
        'm 111 972 l 713 972 l 713 806 l 292 806 l 292 601 l 629 601 l 629 435 l 292 435 l 292 167 l 726 167 l 726 0 l 111 0 l 111 972 m 157 1256 l 390 1256 l 483 1039 l 358 1039 l 157 1256 z ',
    },
    Ё: {
      ha: 796,
      x_min: 111,
      x_max: 726,
      o:
        'm 111 972 l 713 972 l 713 806 l 292 806 l 292 601 l 629 601 l 629 435 l 292 435 l 292 167 l 726 167 l 726 0 l 111 0 l 111 972 m 269 1072 q 199 1100 226 1072 q 171 1171 171 1128 q 199 1242 171 1214 q 269 1269 226 1269 q 340 1242 313 1269 q 368 1171 368 1214 q 340 1100 368 1128 q 269 1072 313 1072 m 557 1072 q 486 1100 514 1072 q 458 1171 458 1128 q 486 1242 458 1214 q 557 1269 514 1269 q 628 1242 600 1269 q 656 1171 656 1214 q 628 1100 656 1128 q 557 1072 600 1072 z ',
    },
    Ђ: {
      ha: 1021,
      x_min: 33,
      x_max: 924,
      o:
        'm 589 140 q 711 206 671 161 q 751 343 751 250 l 751 439 q 726 533 751 503 q 647 564 700 564 q 568 535 606 564 q 507 445 531 506 q 483 296 483 385 l 483 0 l 303 0 l 303 806 l 33 806 l 33 972 l 753 972 l 753 806 l 483 806 l 483 588 q 576 677 518 643 q 706 711 633 711 q 865 658 807 711 q 924 500 924 604 l 924 364 q 852 112 924 200 q 631 -11 781 24 l 589 140 z ',
    },
    Ѓ: {
      ha: 747,
      x_min: 111,
      x_max: 714,
      o:
        'm 111 972 l 714 972 l 714 806 l 292 806 l 292 0 l 111 0 l 111 972 m 436 1256 l 669 1256 l 468 1039 l 343 1039 l 436 1256 z ',
    },
    Є: {
      ha: 964,
      x_min: 64,
      x_max: 906,
      o:
        'm 501 -11 q 275 47 374 -11 q 120 216 176 104 q 64 486 64 328 q 120 756 64 644 q 275 926 176 868 q 501 983 374 983 q 753 903 644 983 q 906 689 861 822 l 743 644 q 651 769 710 722 q 501 817 592 817 q 336 754 401 817 q 253 569 271 692 l 692 569 l 692 403 l 253 403 q 336 218 271 281 q 501 156 401 156 q 650 203 590 156 q 743 328 710 250 l 906 283 q 753 69 861 150 q 501 -11 644 -11 z ',
    },
    Ѕ: {
      ha: 738,
      x_min: 44,
      x_max: 690,
      o:
        'm 379 -11 q 223 25 293 -11 q 106 124 153 61 q 44 261 60 186 l 190 353 q 260 210 213 264 q 383 156 308 156 q 475 184 440 156 q 510 271 510 213 q 486 335 510 307 q 427 383 463 363 q 326 436 392 404 l 286 456 q 153 560 203 497 q 103 722 103 624 q 137 856 103 796 q 233 949 171 915 q 374 983 294 983 q 649 807 575 983 l 503 714 q 374 817 467 817 q 304 791 333 817 q 275 728 275 765 q 301 662 275 690 q 363 613 326 633 q 469 561 400 593 q 584 496 538 529 q 660 409 631 463 q 690 279 690 356 q 651 126 690 192 q 540 24 611 60 q 379 -11 469 -11 z ',
    },
    І: {
      ha: 403,
      x_min: 111,
      x_max: 292,
      o: 'm 111 972 l 292 972 l 292 0 l 111 0 l 111 972 z ',
    },
    Ї: {
      ha: 403,
      x_min: -42,
      x_max: 443,
      o:
        'm 111 972 l 292 972 l 292 0 l 111 0 l 111 972 m 57 1072 q -14 1100 14 1072 q -42 1171 -42 1128 q -14 1242 -42 1214 q 57 1269 14 1269 q 128 1242 100 1269 q 156 1171 156 1214 q 128 1100 156 1128 q 57 1072 100 1072 m 344 1072 q 274 1100 301 1072 q 246 1171 246 1128 q 274 1242 246 1214 q 344 1269 301 1269 q 415 1242 388 1269 q 443 1171 443 1214 q 415 1100 443 1128 q 344 1072 388 1072 z ',
    },
    Ј: {
      ha: 743,
      x_min: 33,
      x_max: 643,
      o:
        'm 333 -11 q 128 56 207 -11 q 33 240 49 122 l 211 278 q 254 185 224 214 q 333 156 285 156 q 429 193 396 156 q 463 322 463 231 l 463 972 l 643 972 l 643 342 q 564 71 643 153 q 333 -11 485 -11 z ',
    },
    Љ: {
      ha: 1308,
      x_min: 39,
      x_max: 1244,
      o:
        'm 39 172 q 110 178 85 172 q 151 206 135 183 q 169 278 167 229 l 221 972 l 742 972 l 742 594 l 924 594 q 1160 517 1075 594 q 1244 297 1244 440 q 1160 77 1244 154 q 924 0 1075 0 l 561 0 l 561 800 l 383 800 l 344 264 q 257 66 335 132 q 39 0 179 0 l 39 172 m 907 167 q 1026 200 989 167 q 1064 297 1064 233 q 1026 394 1064 361 q 907 428 989 428 l 742 428 l 742 167 l 907 167 z ',
    },
    Њ: {
      ha: 1314,
      x_min: 111,
      x_max: 1250,
      o:
        'm 111 972 l 292 972 l 292 594 l 567 594 l 567 972 l 747 972 l 747 594 l 929 594 q 1165 517 1081 594 q 1250 297 1250 440 q 1165 77 1250 154 q 929 0 1081 0 l 567 0 l 567 428 l 292 428 l 292 0 l 111 0 l 111 972 m 913 167 q 1032 200 994 167 q 1069 297 1069 233 q 1032 394 1069 361 q 913 428 994 428 l 747 428 l 747 167 l 913 167 z ',
    },
    Ћ: {
      ha: 1021,
      x_min: 33,
      x_max: 924,
      o:
        'm 303 806 l 33 806 l 33 972 l 753 972 l 753 806 l 483 806 l 483 588 q 576 677 518 643 q 706 711 633 711 q 865 658 807 711 q 924 500 924 604 l 924 0 l 751 0 l 751 439 q 726 533 751 503 q 647 564 700 564 q 568 535 606 564 q 507 446 531 506 q 483 296 483 386 l 483 0 l 303 0 l 303 806 z ',
    },
    Ќ: {
      ha: 888,
      x_min: 111,
      x_max: 874,
      o:
        'm 111 972 l 292 972 l 292 611 l 624 972 l 846 972 l 451 538 l 874 0 l 644 0 l 292 464 l 292 0 l 111 0 l 111 972 m 457 1256 l 690 1256 l 489 1039 l 364 1039 l 457 1256 z ',
    },
    Ѝ: {
      ha: 950,
      x_min: 111,
      x_max: 839,
      o:
        'm 111 972 l 292 972 l 292 331 l 649 972 l 839 972 l 839 0 l 658 0 l 658 642 l 301 0 l 111 0 l 111 972 m 218 1256 l 451 1256 l 544 1039 l 419 1039 l 218 1256 z ',
    },
    Ў: {
      ha: 753,
      x_min: 13,
      x_max: 740,
      o:
        'm 288 299 l 13 972 l 201 972 l 381 521 l 558 972 l 740 972 l 342 0 l 165 0 l 288 299 m 388 1093 q 269 1138 314 1093 q 224 1244 224 1182 l 350 1244 q 360 1217 350 1228 q 388 1206 371 1206 q 415 1217 404 1206 q 425 1244 425 1228 l 551 1244 q 506 1138 551 1182 q 388 1093 461 1093 z ',
    },
    Џ: {
      ha: 933,
      x_min: 111,
      x_max: 822,
      o:
        'm 376 0 l 111 0 l 111 972 l 292 972 l 292 172 l 642 172 l 642 972 l 822 972 l 822 0 l 557 0 l 557 -172 l 376 -172 l 376 0 z ',
    },
    А: {
      ha: 867,
      x_min: 14,
      x_max: 853,
      o:
        'm 343 972 l 524 972 l 853 0 l 658 0 l 588 229 l 279 229 l 208 0 l 14 0 l 343 972 m 536 396 l 433 733 l 331 396 l 536 396 z ',
    },
    Б: {
      ha: 858,
      x_min: 111,
      x_max: 794,
      o:
        'm 111 972 l 703 972 l 703 806 l 292 806 l 292 594 l 474 594 q 710 517 625 594 q 794 297 794 440 q 710 77 794 154 q 474 0 625 0 l 111 0 l 111 972 m 457 167 q 576 200 539 167 q 614 297 614 233 q 576 394 614 361 q 457 428 539 428 l 292 428 l 292 167 l 457 167 z ',
    },
    В: {
      ha: 858,
      x_min: 111,
      x_max: 794,
      o:
        'm 111 972 l 467 972 q 669 906 594 972 q 744 710 744 839 q 719 602 744 650 q 649 531 694 554 q 794 293 794 471 q 709 76 794 153 q 474 0 624 0 l 111 0 l 111 972 m 457 594 q 542 619 514 594 q 571 700 571 643 q 542 781 571 757 q 453 806 513 806 l 292 806 l 292 594 l 457 594 m 457 167 q 576 200 539 167 q 614 297 614 233 q 576 394 614 361 q 457 428 539 428 l 292 428 l 292 167 l 457 167 z ',
    },
    Г: {
      ha: 747,
      x_min: 111,
      x_max: 714,
      o: 'm 111 972 l 714 972 l 714 806 l 292 806 l 292 0 l 111 0 l 111 972 z ',
    },
    Д: {
      ha: 958,
      x_min: 44,
      x_max: 914,
      o:
        'm 44 172 l 133 172 l 269 972 l 829 972 l 829 172 l 914 172 l 894 -172 l 739 -172 l 739 0 l 219 0 l 219 -172 l 64 -172 l 44 172 m 649 172 l 649 806 l 428 806 l 311 172 l 649 172 z ',
    },
    Е: {
      ha: 796,
      x_min: 111,
      x_max: 726,
      o:
        'm 111 972 l 713 972 l 713 806 l 292 806 l 292 601 l 629 601 l 629 435 l 292 435 l 292 167 l 726 167 l 726 0 l 111 0 l 111 972 z ',
    },
    Ж: {
      ha: 1372,
      x_min: 14,
      x_max: 1358,
      o:
        'm 436 538 l 42 972 l 264 972 l 596 611 l 596 972 l 776 972 l 776 611 l 1108 972 l 1331 972 l 936 538 l 1358 0 l 1129 0 l 776 464 l 776 0 l 596 0 l 596 464 l 243 0 l 14 0 l 436 538 z ',
    },
    З: {
      ha: 776,
      x_min: 58,
      x_max: 718,
      o:
        'm 393 -11 q 173 59 264 -11 q 58 250 82 129 l 228 310 q 283 192 239 235 q 390 150 326 150 q 497 190 454 150 q 540 294 540 231 q 486 406 540 369 q 354 442 432 442 l 307 442 l 307 592 l 346 592 q 468 625 424 592 q 513 721 513 658 q 475 800 513 769 q 382 831 438 831 q 291 797 326 831 q 244 711 256 764 l 92 742 q 185 917 107 851 q 382 983 263 983 q 599 915 521 983 q 676 735 676 846 q 645 613 676 663 q 558 528 614 564 q 674 436 629 497 q 718 293 718 375 q 678 138 718 207 q 564 28 638 68 q 393 -11 490 -11 z ',
    },
    И: {
      ha: 950,
      x_min: 111,
      x_max: 839,
      o:
        'm 111 972 l 292 972 l 292 331 l 649 972 l 839 972 l 839 0 l 658 0 l 658 642 l 301 0 l 111 0 l 111 972 z ',
    },
    Й: {
      ha: 950,
      x_min: 111,
      x_max: 839,
      o:
        'm 111 972 l 292 972 l 292 331 l 649 972 l 839 972 l 839 0 l 658 0 l 658 642 l 301 0 l 111 0 l 111 972 m 486 1093 q 367 1138 413 1093 q 322 1244 322 1182 l 449 1244 q 459 1217 449 1228 q 486 1206 469 1206 q 513 1217 503 1206 q 524 1244 524 1228 l 650 1244 q 605 1138 650 1182 q 486 1093 560 1093 z ',
    },
    К: {
      ha: 888,
      x_min: 111,
      x_max: 874,
      o:
        'm 111 972 l 292 972 l 292 611 l 624 972 l 846 972 l 451 538 l 874 0 l 644 0 l 292 464 l 292 0 l 111 0 l 111 972 z ',
    },
    Л: {
      ha: 919,
      x_min: 39,
      x_max: 808,
      o:
        'm 39 172 q 110 178 85 172 q 152 206 136 183 q 171 278 168 229 l 222 972 l 808 972 l 808 0 l 628 0 l 628 800 l 385 800 l 346 264 q 259 64 336 128 q 39 0 182 0 l 39 172 z ',
    },
    М: {
      ha: 1086,
      x_min: 111,
      x_max: 975,
      o:
        'm 111 972 l 314 972 l 543 365 l 772 972 l 975 972 l 975 0 l 794 0 l 794 600 l 608 89 l 478 89 l 292 600 l 292 0 l 111 0 l 111 972 z ',
    },
    Н: {
      ha: 972,
      x_min: 111,
      x_max: 861,
      o:
        'm 111 972 l 292 972 l 292 603 l 681 603 l 681 972 l 861 972 l 861 0 l 681 0 l 681 436 l 292 436 l 292 0 l 111 0 l 111 972 z ',
    },
    О: {
      ha: 1044,
      x_min: 64,
      x_max: 981,
      o:
        'm 522 -11 q 292 44 396 -11 q 126 212 188 100 q 64 486 64 324 q 126 760 64 649 q 292 928 188 872 q 522 983 396 983 q 753 928 649 983 q 919 760 857 872 q 981 486 981 649 q 919 212 981 324 q 753 44 857 100 q 522 -11 649 -11 m 522 156 q 660 191 599 156 q 760 301 722 226 q 797 486 797 375 q 760 672 797 597 q 660 781 722 746 q 522 817 599 817 q 384 781 446 817 q 285 672 322 746 q 247 486 247 597 q 285 301 247 375 q 384 191 322 226 q 522 156 446 156 z ',
    },
    П: {
      ha: 933,
      x_min: 111,
      x_max: 822,
      o:
        'm 111 972 l 822 972 l 822 0 l 642 0 l 642 800 l 292 800 l 292 0 l 111 0 l 111 972 z ',
    },
    Р: {
      ha: 829,
      x_min: 111,
      x_max: 782,
      o:
        'm 111 972 l 478 972 q 704 891 626 972 q 782 676 782 810 q 704 462 782 543 q 478 381 626 381 l 292 381 l 292 0 l 111 0 l 111 972 m 471 547 q 565 579 532 547 q 599 676 599 611 q 565 774 599 742 q 471 806 532 806 l 292 806 l 292 547 l 471 547 z ',
    },
    С: {
      ha: 985,
      x_min: 64,
      x_max: 926,
      o:
        'm 524 -11 q 294 47 399 -11 q 126 217 189 104 q 64 486 64 329 q 126 756 64 643 q 294 926 189 868 q 524 983 399 983 q 787 906 682 983 q 926 689 892 829 l 764 647 q 676 772 733 728 q 524 817 619 817 q 383 780 446 817 q 284 669 321 743 q 247 486 247 594 q 284 303 247 378 q 383 192 321 229 q 524 156 446 156 q 676 200 619 156 q 764 325 733 244 l 926 283 q 787 66 892 143 q 524 -11 682 -11 z ',
    },
    Т: {
      ha: 789,
      x_min: 33,
      x_max: 756,
      o:
        'm 304 806 l 33 806 l 33 972 l 756 972 l 756 806 l 485 806 l 485 0 l 304 0 l 304 806 z ',
    },
    У: {
      ha: 753,
      x_min: 13,
      x_max: 740,
      o:
        'm 288 299 l 13 972 l 201 972 l 381 521 l 558 972 l 740 972 l 342 0 l 165 0 l 288 299 z ',
    },
    Ф: {
      ha: 1092,
      x_min: 64,
      x_max: 1028,
      o:
        'm 460 100 l 447 100 q 249 153 336 100 q 113 294 161 206 q 64 486 64 382 q 113 678 64 590 q 249 819 161 767 q 447 872 336 872 l 460 872 l 460 972 l 632 972 l 632 872 l 644 872 q 843 819 756 872 q 979 678 931 767 q 1028 486 1028 590 q 979 294 1028 382 q 843 153 931 206 q 644 100 756 100 l 632 100 l 632 0 l 460 0 l 460 100 m 460 247 l 460 725 l 447 725 q 339 692 385 725 q 269 606 293 660 q 244 486 244 551 q 269 367 244 421 q 339 280 293 313 q 447 247 385 247 l 460 247 m 644 247 q 753 280 707 247 q 823 367 799 313 q 847 486 847 421 q 823 606 847 551 q 753 692 799 660 q 644 725 707 725 l 632 725 l 632 247 l 644 247 z ',
    },
    Х: {
      ha: 839,
      x_min: 18,
      x_max: 821,
      o:
        'm 321 525 l 64 972 l 261 972 l 419 697 l 578 972 l 775 972 l 518 525 l 821 0 l 621 0 l 419 351 l 218 0 l 18 0 l 321 525 z ',
    },
    Ц: {
      ha: 968,
      x_min: 111,
      x_max: 924,
      o:
        'm 743 0 l 111 0 l 111 972 l 292 972 l 292 172 l 642 172 l 642 972 l 822 972 l 822 172 l 924 172 l 899 -172 l 743 -172 l 743 0 z ',
    },
    Ч: {
      ha: 917,
      x_min: 100,
      x_max: 806,
      o:
        'm 625 429 q 521 384 582 399 q 397 369 460 369 q 180 460 260 369 q 100 736 100 550 l 100 972 l 281 972 l 281 736 q 320 591 281 640 q 429 542 360 542 q 541 562 501 542 q 625 626 581 582 l 625 972 l 806 972 l 806 0 l 625 0 l 625 429 z ',
    },
    Ш: {
      ha: 1350,
      x_min: 111,
      x_max: 1239,
      o:
        'm 111 972 l 292 972 l 292 172 l 585 172 l 585 972 l 765 972 l 765 172 l 1058 172 l 1058 972 l 1239 972 l 1239 0 l 111 0 l 111 972 z ',
    },
    Щ: {
      ha: 1385,
      x_min: 111,
      x_max: 1340,
      o:
        'm 1160 0 l 111 0 l 111 972 l 292 972 l 292 172 l 585 172 l 585 972 l 765 972 l 765 172 l 1058 172 l 1058 972 l 1239 972 l 1239 172 l 1340 172 l 1315 -172 l 1160 -172 l 1160 0 z ',
    },
    Ъ: {
      ha: 951,
      x_min: 28,
      x_max: 888,
      o:
        'm 204 806 l 28 806 l 28 972 l 385 972 l 385 594 l 567 594 q 803 517 718 594 q 888 297 888 440 q 803 77 888 154 q 567 0 718 0 l 204 0 l 204 806 m 550 167 q 669 200 632 167 q 707 297 707 233 q 669 394 707 361 q 550 428 632 428 l 385 428 l 385 167 l 550 167 z ',
    },
    Ы: {
      ha: 1261,
      x_min: 111,
      x_max: 1150,
      o:
        'm 111 972 l 292 972 l 292 594 l 474 594 q 710 517 625 594 q 794 297 794 440 q 710 77 794 154 q 474 0 625 0 l 111 0 l 111 972 m 457 167 q 576 200 539 167 q 614 297 614 233 q 576 394 614 361 q 457 428 539 428 l 292 428 l 292 167 l 457 167 m 969 972 l 1150 972 l 1150 0 l 969 0 l 969 972 z ',
    },
    Ь: {
      ha: 858,
      x_min: 111,
      x_max: 794,
      o:
        'm 111 972 l 292 972 l 292 594 l 474 594 q 710 517 625 594 q 794 297 794 440 q 710 77 794 154 q 474 0 625 0 l 111 0 l 111 972 m 457 167 q 576 200 539 167 q 614 297 614 233 q 576 394 614 361 q 457 428 539 428 l 292 428 l 292 167 l 457 167 z ',
    },
    Э: {
      ha: 964,
      x_min: 58,
      x_max: 900,
      o:
        'm 463 -11 q 211 69 319 -11 q 58 283 103 150 l 221 328 q 314 203 254 250 q 463 156 374 156 q 628 218 563 156 q 711 403 693 281 l 272 403 l 272 569 l 711 569 q 628 754 693 692 q 463 817 563 817 q 313 769 372 817 q 221 644 254 722 l 58 689 q 211 903 103 822 q 463 983 319 983 q 689 926 590 983 q 844 756 788 868 q 900 486 900 644 q 844 216 900 328 q 689 47 788 104 q 463 -11 590 -11 z ',
    },
    Ю: {
      ha: 1417,
      x_min: 111,
      x_max: 1353,
      o:
        'm 894 -11 q 682 35 779 -11 q 520 174 585 81 q 439 403 456 267 l 292 403 l 292 0 l 111 0 l 111 972 l 292 972 l 292 569 l 439 569 q 520 799 456 706 q 682 938 585 892 q 894 983 779 983 q 1125 928 1021 983 q 1291 760 1229 872 q 1353 486 1353 649 q 1291 212 1353 324 q 1125 44 1229 100 q 894 -11 1021 -11 m 894 156 q 1033 191 971 156 q 1132 301 1094 226 q 1169 486 1169 375 q 1132 672 1169 597 q 1033 781 1094 746 q 894 817 971 817 q 756 781 818 817 q 657 672 694 746 q 619 486 619 597 q 657 301 619 375 q 756 191 694 226 q 894 156 818 156 z ',
    },
    Я: {
      ha: 879,
      x_min: 31,
      x_max: 768,
      o:
        'm 300 435 q 165 530 213 461 q 118 696 118 599 q 195 897 118 821 q 414 972 272 972 l 768 972 l 768 0 l 588 0 l 588 419 l 493 419 l 232 0 l 31 0 l 300 435 m 588 586 l 588 806 l 413 806 q 329 779 360 806 q 299 696 299 753 q 329 613 299 639 q 413 586 360 586 l 588 586 z ',
    },
    а: {
      ha: 732,
      x_min: 61,
      x_max: 649,
      o:
        'm 274 -11 q 121 44 181 -11 q 61 201 61 100 q 140 368 61 306 q 354 431 219 431 l 476 431 l 476 461 q 442 538 476 513 q 354 564 407 564 q 233 483 264 564 l 88 517 q 177 658 104 604 q 354 711 250 711 q 572 637 494 711 q 649 418 649 563 l 649 0 l 507 0 l 489 89 q 274 -11 407 -11 m 319 136 q 429 176 382 136 q 476 281 476 215 l 476 294 l 361 294 q 273 272 304 294 q 242 204 242 250 q 263 155 242 174 q 319 136 285 136 z ',
    },
    б: {
      ha: 828,
      x_min: 58,
      x_max: 769,
      o:
        'm 411 -11 q 224 43 304 -11 q 101 197 144 97 q 58 431 58 296 q 153 847 58 722 q 422 972 249 972 l 472 972 q 576 1038 550 972 l 683 1038 q 482 822 683 822 l 428 822 q 297 779 349 822 q 239 638 244 736 q 324 690 271 668 q 438 711 376 711 q 615 665 540 711 q 730 536 690 618 q 769 350 769 454 q 725 164 769 246 q 599 35 681 82 q 411 -11 518 -11 m 414 136 q 542 198 494 136 q 589 350 589 260 q 542 502 589 440 q 414 564 494 564 q 286 502 333 564 q 239 350 239 440 q 286 198 239 260 q 414 136 333 136 z ',
    },
    в: {
      ha: 708,
      x_min: 97,
      x_max: 647,
      o:
        'm 97 700 l 367 700 q 540 653 476 700 q 603 508 603 606 q 584 436 603 471 q 536 382 565 401 q 616 312 585 358 q 647 206 647 265 q 584 51 647 103 q 410 0 521 0 l 97 0 l 97 700 m 357 444 q 417 458 397 444 q 436 503 436 472 q 417 547 436 533 q 357 561 397 561 l 269 561 l 269 444 l 357 444 m 364 147 q 445 164 418 147 q 472 219 472 181 q 364 294 472 294 l 269 294 l 269 147 l 364 147 z ',
    },
    г: {
      ha: 599,
      x_min: 97,
      x_max: 571,
      o: 'm 97 700 l 571 700 l 571 553 l 269 553 l 269 0 l 97 0 l 97 700 z ',
    },
    д: {
      ha: 781,
      x_min: 38,
      x_max: 738,
      o:
        'm 38 147 l 96 147 l 185 700 l 686 700 l 686 147 l 738 147 l 717 -158 l 567 -158 l 567 0 l 208 0 l 208 -158 l 60 -158 l 38 147 m 514 147 l 514 553 l 326 553 l 264 147 l 514 147 z ',
    },
    е: {
      ha: 779,
      x_min: 58,
      x_max: 721,
      o:
        'm 394 -11 q 205 42 281 -11 q 94 178 129 96 q 58 350 58 261 q 94 522 58 439 q 205 658 129 604 q 394 711 281 711 q 578 659 504 711 q 686 528 651 607 q 721 365 721 449 l 721 294 l 239 294 q 285 183 242 231 q 404 136 329 136 q 502 163 463 136 q 574 244 542 189 l 713 193 q 592 42 669 94 q 394 -11 515 -11 m 544 431 q 495 526 532 489 q 394 564 458 564 q 293 525 333 564 q 243 431 253 486 l 544 431 z ',
    },
    ж: {
      ha: 1106,
      x_min: 8,
      x_max: 1097,
      o:
        'm 307 378 l 26 700 l 239 700 l 467 425 l 467 700 l 639 700 l 639 425 l 867 700 l 1079 700 l 799 378 l 1097 0 l 886 0 l 639 331 l 639 0 l 467 0 l 467 331 l 219 0 l 8 0 l 307 378 z ',
    },
    з: {
      ha: 611,
      x_min: 47,
      x_max: 556,
      o:
        'm 303 -11 q 128 49 199 -11 q 47 203 57 110 l 201 224 q 235 158 207 182 q 303 133 264 133 q 367 157 342 133 q 392 219 392 181 q 357 282 392 258 q 272 306 322 306 l 239 306 l 239 422 l 272 422 q 349 444 321 422 q 376 503 376 465 q 356 557 376 536 q 297 578 335 578 q 240 558 263 578 q 208 501 217 538 l 65 539 q 143 663 83 614 q 300 711 203 711 q 466 659 408 711 q 524 529 524 607 q 506 439 524 475 q 447 376 488 403 q 526 315 497 357 q 556 210 556 272 q 487 49 556 110 q 303 -11 418 -11 z ',
    },
    и: {
      ha: 794,
      x_min: 97,
      x_max: 697,
      o:
        'm 97 700 l 269 700 l 269 268 l 510 700 l 697 700 l 697 0 l 525 0 l 525 432 l 285 0 l 97 0 l 97 700 z ',
    },
    й: {
      ha: 794,
      x_min: 97,
      x_max: 697,
      o:
        'm 97 700 l 269 700 l 269 268 l 510 700 l 697 700 l 697 0 l 525 0 l 525 432 l 285 0 l 97 0 l 97 700 m 388 821 q 269 865 314 821 q 224 972 224 910 l 350 972 q 360 944 350 956 q 388 933 371 933 q 415 944 404 933 q 425 972 425 956 l 551 972 q 506 865 551 910 q 388 821 461 821 z ',
    },
    к: {
      ha: 736,
      x_min: 97,
      x_max: 728,
      o:
        'm 97 700 l 269 700 l 269 425 l 497 700 l 710 700 l 429 378 l 728 0 l 517 0 l 269 331 l 269 0 l 97 0 l 97 700 z ',
    },
    л: {
      ha: 813,
      x_min: 35,
      x_max: 715,
      o:
        'm 35 147 q 125 169 96 147 q 160 246 154 192 l 206 700 l 715 700 l 715 0 l 543 0 l 543 553 l 365 553 l 324 183 q 277 63 314 103 q 183 12 240 24 q 35 0 126 0 l 35 147 z ',
    },
    м: {
      ha: 872,
      x_min: 97,
      x_max: 775,
      o:
        'm 97 700 l 278 700 l 436 297 l 594 700 l 775 700 l 775 0 l 603 0 l 603 350 l 496 64 l 376 64 l 269 350 l 269 0 l 97 0 l 97 700 z ',
    },
    н: {
      ha: 772,
      x_min: 97,
      x_max: 675,
      o:
        'm 97 700 l 269 700 l 269 446 l 503 446 l 503 700 l 675 700 l 675 0 l 503 0 l 503 299 l 269 299 l 269 0 l 97 0 l 97 700 z ',
    },
    о: {
      ha: 828,
      x_min: 58,
      x_max: 769,
      o:
        'm 414 -11 q 224 36 304 -11 q 101 165 143 83 q 58 350 58 247 q 101 535 58 453 q 224 664 143 617 q 414 711 304 711 q 604 664 524 711 q 727 535 685 617 q 769 350 769 453 q 727 165 769 247 q 604 36 685 83 q 414 -11 524 -11 m 414 136 q 542 198 494 136 q 589 350 589 260 q 542 502 589 440 q 414 564 494 564 q 286 502 333 564 q 239 350 239 440 q 286 198 239 260 q 414 136 333 136 z ',
    },
    п: {
      ha: 768,
      x_min: 97,
      x_max: 671,
      o:
        'm 97 700 l 671 700 l 671 0 l 499 0 l 499 553 l 269 553 l 269 0 l 97 0 l 97 700 z ',
    },
    р: {
      ha: 817,
      x_min: 97,
      x_max: 758,
      o:
        'm 97 700 l 269 700 l 269 628 q 333 685 286 658 q 439 711 379 711 q 676 613 593 711 q 758 350 758 515 q 676 87 758 185 q 439 -11 593 -11 q 340 11 388 -11 q 269 64 293 33 l 269 -283 l 97 -283 l 97 700 m 415 136 q 532 193 486 136 q 578 350 578 250 q 532 508 578 451 q 415 564 486 564 q 299 508 344 564 q 254 350 254 451 q 299 192 254 249 q 415 136 344 136 z ',
    },
    с: {
      ha: 768,
      x_min: 58,
      x_max: 718,
      o:
        'm 400 -11 q 213 37 290 -11 q 97 167 136 85 q 58 350 58 249 q 97 533 58 451 q 213 663 136 615 q 400 711 290 711 q 598 660 517 711 q 718 511 679 610 l 564 449 q 497 535 536 506 q 400 564 457 564 q 280 505 321 564 q 239 350 239 446 q 280 195 239 254 q 400 136 321 136 q 497 165 457 136 q 564 251 536 194 l 718 189 q 598 40 679 90 q 400 -11 517 -11 z ',
    },
    т: {
      ha: 614,
      x_min: 33,
      x_max: 581,
      o:
        'm 221 553 l 33 553 l 33 700 l 581 700 l 581 553 l 393 553 l 393 0 l 221 0 l 221 553 z ',
    },
    у: {
      ha: 689,
      x_min: 14,
      x_max: 675,
      o:
        'm 268 44 l 14 700 l 188 700 l 350 261 l 503 700 l 675 700 l 314 -283 l 147 -283 l 268 44 z ',
    },
    ф: {
      ha: 1000,
      x_min: 58,
      x_max: 942,
      o:
        'm 414 -11 q 228 37 308 -11 q 103 167 147 85 q 58 350 58 250 q 103 533 58 450 q 228 663 147 615 q 414 711 308 711 l 414 983 l 586 983 l 586 711 q 772 663 692 711 q 897 533 853 615 q 942 350 942 450 q 897 167 942 250 q 772 37 853 85 q 586 -11 692 -11 l 586 -283 l 414 -283 l 414 -11 m 414 136 l 414 564 l 407 564 q 285 502 332 564 q 239 350 239 440 q 285 198 239 260 q 407 136 332 136 l 414 136 m 593 136 q 715 198 668 136 q 761 350 761 260 q 715 502 761 440 q 593 564 668 564 l 586 564 l 586 136 l 593 136 z ',
    },
    х: {
      ha: 667,
      x_min: 10,
      x_max: 657,
      o:
        'm 242 374 l 39 700 l 219 700 l 333 518 l 447 700 l 628 700 l 425 374 l 657 0 l 476 0 l 333 228 l 190 0 l 10 0 l 242 374 z ',
    },
    ц: {
      ha: 765,
      x_min: 97,
      x_max: 722,
      o:
        'm 551 0 l 97 0 l 97 700 l 269 700 l 269 147 l 499 147 l 499 700 l 671 700 l 671 147 l 722 147 l 701 -158 l 551 -158 l 551 0 z ',
    },
    ч: {
      ha: 775,
      x_min: 86,
      x_max: 678,
      o:
        'm 506 290 q 411 231 457 247 q 300 214 365 214 q 144 269 203 214 q 86 424 86 324 l 86 700 l 258 700 l 258 486 q 358 369 258 369 q 438 402 400 369 q 506 496 475 435 l 506 700 l 678 700 l 678 0 l 506 0 l 506 290 z ',
    },
    ш: {
      ha: 1125,
      x_min: 97,
      x_max: 1028,
      o:
        'm 97 700 l 269 700 l 269 147 l 476 147 l 476 700 l 649 700 l 649 147 l 856 147 l 856 700 l 1028 700 l 1028 0 l 97 0 l 97 700 z ',
    },
    щ: {
      ha: 1122,
      x_min: 97,
      x_max: 1079,
      o:
        'm 908 0 l 97 0 l 97 700 l 269 700 l 269 147 l 476 147 l 476 700 l 649 700 l 649 147 l 856 147 l 856 700 l 1028 700 l 1028 147 l 1079 147 l 1058 -158 l 908 -158 l 908 0 z ',
    },
    ъ: {
      ha: 744,
      x_min: 25,
      x_max: 688,
      o:
        'm 146 553 l 25 553 l 25 700 l 318 700 l 318 433 l 446 433 q 622 374 557 433 q 688 217 688 315 q 622 59 688 118 q 446 0 557 0 l 146 0 l 146 553 m 415 147 q 488 164 464 147 q 513 217 513 181 q 488 269 513 253 q 415 286 464 286 l 318 286 l 318 147 l 415 147 z ',
    },
    ы: {
      ha: 1063,
      x_min: 97,
      x_max: 965,
      o:
        'm 97 700 l 269 700 l 269 433 l 397 433 q 574 374 508 433 q 639 217 639 315 q 574 59 639 118 q 397 0 508 0 l 97 0 l 97 700 m 367 147 q 440 164 415 147 q 464 217 464 181 q 440 269 464 253 q 367 286 415 286 l 269 286 l 269 147 l 367 147 m 793 700 l 965 700 l 965 0 l 793 0 l 793 700 z ',
    },
    ь: {
      ha: 696,
      x_min: 97,
      x_max: 639,
      o:
        'm 97 700 l 269 700 l 269 433 l 397 433 q 574 374 508 433 q 639 217 639 315 q 574 59 639 118 q 397 0 508 0 l 97 0 l 97 700 m 367 147 q 440 164 415 147 q 464 217 464 181 q 440 269 464 253 q 367 286 415 286 l 269 286 l 269 147 l 367 147 z ',
    },
    э: {
      ha: 771,
      x_min: 50,
      x_max: 713,
      o:
        'm 357 -11 q 50 171 156 -11 l 192 243 q 363 136 251 136 q 469 176 425 136 q 524 282 513 217 l 224 282 l 224 418 l 524 418 q 469 524 513 483 q 363 564 425 564 q 192 457 251 564 l 50 529 q 357 711 156 711 q 550 663 469 711 q 672 533 631 615 q 713 350 713 450 q 672 167 713 250 q 550 37 631 85 q 357 -11 469 -11 z ',
    },
    ю: {
      ha: 1128,
      x_min: 97,
      x_max: 1069,
      o:
        'm 714 -11 q 477 68 569 -11 q 364 276 385 147 l 269 276 l 269 0 l 97 0 l 97 700 l 269 700 l 269 424 l 364 424 q 478 631 386 551 q 714 711 571 711 q 904 664 824 711 q 1027 535 985 617 q 1069 350 1069 453 q 1027 165 1069 247 q 904 36 985 83 q 714 -11 824 -11 m 714 136 q 842 198 794 136 q 889 350 889 260 q 842 502 889 440 q 714 564 794 564 q 586 502 633 564 q 539 350 539 440 q 586 198 539 260 q 714 136 633 136 z ',
    },
    я: {
      ha: 671,
      x_min: 29,
      x_max: 574,
      o:
        'm 213 311 q 112 381 149 331 q 75 501 75 431 q 141 644 75 589 q 307 700 207 700 l 574 700 l 574 0 l 401 0 l 401 303 l 382 303 l 213 0 l 29 0 l 213 311 m 401 450 l 401 553 l 297 553 q 256 539 271 553 q 242 501 242 525 q 256 464 242 478 q 297 450 271 450 l 401 450 z ',
    },
    ѐ: {
      ha: 779,
      x_min: 58,
      x_max: 721,
      o:
        'm 394 -11 q 205 42 281 -11 q 94 178 129 96 q 58 350 58 261 q 94 522 58 439 q 205 658 129 604 q 394 711 281 711 q 578 659 504 711 q 686 528 651 607 q 721 365 721 449 l 721 294 l 239 294 q 285 183 242 231 q 404 136 329 136 q 502 163 463 136 q 574 244 542 189 l 713 193 q 592 42 669 94 q 394 -11 515 -11 m 544 431 q 495 526 532 489 q 394 564 458 564 q 293 525 333 564 q 243 431 253 486 l 544 431 m 139 983 l 372 983 l 465 767 l 340 767 l 139 983 z ',
    },
    ё: {
      ha: 779,
      x_min: 58,
      x_max: 721,
      o:
        'm 394 -11 q 205 42 281 -11 q 94 178 129 96 q 58 350 58 261 q 94 522 58 439 q 205 658 129 604 q 394 711 281 711 q 578 659 504 711 q 686 528 651 607 q 721 365 721 449 l 721 294 l 239 294 q 285 183 242 231 q 404 136 329 136 q 502 163 463 136 q 574 244 542 189 l 713 193 q 592 42 669 94 q 394 -11 515 -11 m 544 431 q 495 526 532 489 q 394 564 458 564 q 293 525 333 564 q 243 431 253 486 l 544 431 m 251 800 q 181 828 208 800 q 153 899 153 856 q 181 969 153 942 q 251 997 208 997 q 322 969 294 997 q 350 899 350 942 q 322 828 350 856 q 251 800 294 800 m 539 800 q 468 828 496 800 q 440 899 440 856 q 468 969 440 942 q 539 997 496 997 q 610 969 582 997 q 638 899 638 942 q 610 828 638 856 q 539 800 582 800 z ',
    },
    ђ: {
      ha: 828,
      x_min: 18,
      x_max: 731,
      o:
        'm 396 -143 q 518 -78 478 -122 q 558 60 558 -33 l 558 439 q 533 533 558 503 q 454 564 507 564 q 375 535 413 564 q 314 446 338 506 q 290 296 290 386 l 290 0 l 118 0 l 118 776 l 18 776 l 18 904 l 118 904 l 118 983 l 290 983 l 290 904 l 444 904 l 444 776 l 290 776 l 290 588 q 383 677 325 643 q 513 711 440 711 q 672 658 614 711 q 731 500 731 604 l 731 81 q 659 -172 731 -83 q 438 -294 588 -260 l 396 -143 z ',
    },
    ѓ: {
      ha: 599,
      x_min: 97,
      x_max: 574,
      o:
        'm 97 700 l 571 700 l 571 553 l 269 553 l 269 0 l 97 0 l 97 700 m 340 983 l 574 983 l 372 767 l 247 767 l 340 983 z ',
    },
    є: {
      ha: 771,
      x_min: 58,
      x_max: 721,
      o:
        'm 414 -11 q 221 37 301 -11 q 99 167 140 85 q 58 350 58 250 q 99 533 58 450 q 221 663 140 615 q 414 711 301 711 q 721 529 615 711 l 579 457 q 408 564 519 564 q 302 524 346 564 q 247 418 258 483 l 547 418 l 547 282 l 247 282 q 302 176 258 217 q 408 136 346 136 q 579 243 519 136 l 721 171 q 414 -11 615 -11 z ',
    },
    ѕ: {
      ha: 619,
      x_min: 47,
      x_max: 561,
      o:
        'm 325 -11 q 144 44 217 -11 q 47 178 71 100 l 185 251 q 240 167 204 197 q 324 136 275 136 q 386 152 361 136 q 411 204 411 168 q 381 256 411 236 q 289 299 351 276 q 260 310 279 301 q 135 390 179 342 q 90 515 90 439 q 119 614 90 569 q 199 685 149 658 q 314 711 250 711 q 443 681 385 711 q 533 597 501 651 l 431 503 q 318 564 389 564 q 270 549 290 564 q 250 511 250 535 q 279 465 250 486 q 393 413 308 443 q 517 336 474 383 q 561 215 561 289 q 496 51 561 113 q 325 -11 431 -11 z ',
    },
    і: {
      ha: 367,
      x_min: 72,
      x_max: 294,
      o:
        'm 183 790 q 104 822 136 790 q 72 901 72 854 q 104 981 72 949 q 183 1013 136 1013 q 263 981 231 1013 q 294 901 294 949 q 263 822 294 854 q 183 790 231 790 m 97 700 l 269 700 l 269 0 l 97 0 l 97 700 z ',
    },
    ї: {
      ha: 367,
      x_min: -60,
      x_max: 425,
      o:
        'm 97 700 l 269 700 l 269 0 l 97 0 l 97 700 m 39 800 q -32 828 -4 800 q -60 899 -60 856 q -32 969 -60 942 q 39 997 -4 997 q 110 969 82 997 q 138 899 138 942 q 110 828 138 856 q 39 800 82 800 m 326 800 q 256 828 283 800 q 228 899 228 856 q 256 969 228 942 q 326 997 283 997 q 397 969 369 997 q 425 899 425 942 q 397 828 425 856 q 326 800 369 800 z ',
    },
    ј: {
      ha: 367,
      x_min: -65,
      x_max: 294,
      o:
        'm 183 790 q 104 822 136 790 q 72 901 72 854 q 104 981 72 949 q 183 1013 136 1013 q 263 981 231 1013 q 294 901 294 949 q 263 822 294 854 q 183 790 231 790 m -65 -143 q 57 -78 17 -122 q 97 60 97 -33 l 97 700 l 269 700 l 269 81 q 198 -172 269 -83 q -24 -294 126 -260 l -65 -143 z ',
    },
    љ: {
      ha: 1092,
      x_min: 35,
      x_max: 1035,
      o:
        'm 35 147 q 125 169 96 147 q 160 246 154 192 l 206 700 l 665 700 l 665 433 l 793 433 q 969 374 904 433 q 1035 217 1035 315 q 969 59 1035 118 q 793 0 904 0 l 493 0 l 493 553 l 365 553 l 324 183 q 277 63 314 103 q 183 12 240 24 q 35 0 126 0 l 35 147 m 763 147 q 835 164 811 147 q 860 217 860 181 q 835 269 860 253 q 763 286 811 286 l 665 286 l 665 147 l 763 147 z ',
    },
    њ: {
      ha: 1115,
      x_min: 97,
      x_max: 1058,
      o:
        'm 97 700 l 269 700 l 269 433 l 517 433 l 517 700 l 689 700 l 689 433 l 817 433 q 993 374 928 433 q 1058 217 1058 315 q 993 59 1058 118 q 817 0 928 0 l 517 0 l 517 286 l 269 286 l 269 0 l 97 0 l 97 700 m 786 147 q 859 164 835 147 q 883 217 883 181 q 859 269 883 253 q 786 286 835 286 l 689 286 l 689 147 l 786 147 z ',
    },
    ћ: {
      ha: 807,
      x_min: 18,
      x_max: 710,
      o:
        'm 97 983 l 269 983 l 269 588 q 362 677 304 643 q 492 711 419 711 q 651 658 593 711 q 710 500 710 604 l 710 0 l 538 0 l 538 439 q 512 533 538 503 q 433 564 486 564 q 354 535 392 564 q 293 446 317 506 q 269 296 269 386 l 269 0 l 97 0 l 97 983 m 18 906 l 444 906 l 444 778 l 18 778 l 18 906 z ',
    },
    ќ: {
      ha: 736,
      x_min: 97,
      x_max: 728,
      o:
        'm 97 700 l 269 700 l 269 425 l 497 700 l 710 700 l 429 378 l 728 0 l 517 0 l 269 331 l 269 0 l 97 0 l 97 700 m 383 983 l 617 983 l 415 767 l 290 767 l 383 983 z ',
    },
    ѝ: {
      ha: 794,
      x_min: 97,
      x_max: 697,
      o:
        'm 97 700 l 269 700 l 269 268 l 510 700 l 697 700 l 697 0 l 525 0 l 525 432 l 285 0 l 97 0 l 97 700 m 119 983 l 353 983 l 446 767 l 321 767 l 119 983 z ',
    },
    ў: {
      ha: 689,
      x_min: 14,
      x_max: 675,
      o:
        'm 268 44 l 14 700 l 188 700 l 350 261 l 503 700 l 675 700 l 314 -283 l 147 -283 l 268 44 m 356 821 q 237 865 282 821 q 192 972 192 910 l 318 972 q 328 944 318 956 q 356 933 339 933 q 383 944 372 933 q 393 972 393 956 l 519 972 q 474 865 519 910 q 356 821 429 821 z ',
    },
    џ: {
      ha: 769,
      x_min: 97,
      x_max: 672,
      o:
        'm 299 0 l 97 0 l 97 700 l 269 700 l 269 147 l 500 147 l 500 700 l 672 700 l 672 0 l 471 0 l 471 -158 l 299 -158 l 299 0 z ',
    },
    Ѣ: {
      ha: 939,
      x_min: 10,
      x_max: 875,
      o:
        'm 554 594 q 790 517 706 594 q 875 297 875 440 q 790 77 875 154 q 554 0 706 0 l 192 0 l 192 688 l 10 688 l 10 854 l 192 854 l 192 972 l 372 972 l 372 854 l 565 854 l 565 688 l 372 688 l 372 594 l 554 594 m 538 167 q 657 200 619 167 q 694 297 694 233 q 657 394 694 361 q 538 428 619 428 l 372 428 l 372 167 l 538 167 z ',
    },
    ѣ: {
      ha: 790,
      x_min: 18,
      x_max: 733,
      o:
        'm 492 433 q 668 374 603 433 q 733 217 733 315 q 668 59 733 118 q 492 0 603 0 l 192 0 l 192 629 l 18 629 l 18 779 l 192 779 l 192 972 l 364 972 l 364 779 l 536 779 l 536 629 l 364 629 l 364 433 l 492 433 m 461 147 q 534 164 510 147 q 558 217 558 181 q 534 269 558 253 q 461 286 510 286 l 364 286 l 364 147 l 461 147 z ',
    },
    Ѳ: {
      ha: 1044,
      x_min: 64,
      x_max: 981,
      o:
        'm 522 983 q 753 928 649 983 q 919 760 857 872 q 981 486 981 649 q 919 212 981 324 q 753 44 857 100 q 522 -11 649 -11 q 292 44 396 -11 q 126 212 188 100 q 64 486 64 324 q 126 760 64 649 q 292 928 188 872 q 522 983 396 983 m 522 817 q 345 752 419 817 q 253 561 271 688 l 792 561 q 699 752 774 688 q 522 817 625 817 m 522 156 q 699 220 625 156 q 792 411 774 285 l 253 411 q 345 220 271 285 q 522 156 419 156 z ',
    },
    ѳ: {
      ha: 828,
      x_min: 58,
      x_max: 769,
      o:
        'm 414 711 q 604 664 524 711 q 727 535 685 617 q 769 350 769 453 q 727 165 769 247 q 604 36 685 83 q 414 -11 524 -11 q 224 36 304 -11 q 101 165 143 83 q 58 350 58 247 q 101 535 58 453 q 224 664 143 617 q 414 711 304 711 m 414 564 q 309 526 351 564 q 249 425 267 488 l 579 425 q 519 526 561 488 q 414 564 476 564 m 414 136 q 519 174 476 136 q 579 275 561 213 l 249 275 q 309 174 267 213 q 414 136 351 136 z ',
    },
    Ѵ: {
      ha: 892,
      x_min: 14,
      x_max: 892,
      o:
        'm 574 719 q 687 919 615 854 q 892 983 758 983 l 892 811 q 829 804 850 811 q 793 776 808 797 q 761 706 778 754 l 524 0 l 340 0 l 14 972 l 214 972 l 432 253 l 574 719 z ',
    },
    ѵ: {
      ha: 724,
      x_min: 18,
      x_max: 714,
      o:
        'm 18 700 l 192 700 l 333 213 l 413 489 q 482 636 442 589 q 574 697 522 683 q 714 711 626 711 l 714 564 q 619 542 653 564 q 569 465 586 519 l 411 0 l 256 0 l 18 700 z ',
    },
    Ґ: {
      ha: 747,
      x_min: 111,
      x_max: 714,
      o:
        'm 714 1082 l 714 806 l 292 806 l 292 0 l 111 0 l 111 972 l 533 972 l 533 1082 l 714 1082 z ',
    },
    ґ: {
      ha: 599,
      x_min: 97,
      x_max: 571,
      o:
        'm 571 814 l 571 553 l 269 553 l 269 0 l 97 0 l 97 700 l 399 700 l 399 814 l 571 814 z ',
    },
    Ẁ: {
      ha: 1256,
      x_min: 14,
      x_max: 1242,
      o:
        'm 14 972 l 206 972 l 368 257 l 550 869 l 706 869 l 888 257 l 1050 972 l 1242 972 l 988 0 l 804 0 l 628 572 l 451 0 l 268 0 l 14 972 m 371 1256 l 604 1256 l 697 1039 l 572 1039 l 371 1256 z ',
    },
    ẁ: {
      ha: 1025,
      x_min: 15,
      x_max: 1010,
      o:
        'm 15 700 l 189 700 l 314 219 l 432 700 l 593 700 l 711 219 l 836 700 l 1010 700 l 786 0 l 633 0 l 513 453 l 392 0 l 239 0 l 15 700 m 256 983 l 489 983 l 582 767 l 457 767 l 256 983 z ',
    },
    Ẃ: {
      ha: 1256,
      x_min: 14,
      x_max: 1242,
      o:
        'm 14 972 l 206 972 l 368 257 l 550 869 l 706 869 l 888 257 l 1050 972 l 1242 972 l 988 0 l 804 0 l 628 572 l 451 0 l 268 0 l 14 972 m 651 1256 l 885 1256 l 683 1039 l 558 1039 l 651 1256 z ',
    },
    ẃ: {
      ha: 1025,
      x_min: 15,
      x_max: 1010,
      o:
        'm 15 700 l 189 700 l 314 219 l 432 700 l 593 700 l 711 219 l 836 700 l 1010 700 l 786 0 l 633 0 l 513 453 l 392 0 l 239 0 l 15 700 m 536 983 l 769 983 l 568 767 l 443 767 l 536 983 z ',
    },
    Ẅ: {
      ha: 1256,
      x_min: 14,
      x_max: 1242,
      o:
        'm 14 972 l 206 972 l 368 257 l 550 869 l 706 869 l 888 257 l 1050 972 l 1242 972 l 988 0 l 804 0 l 628 572 l 451 0 l 268 0 l 14 972 m 483 1072 q 413 1100 440 1072 q 385 1171 385 1128 q 413 1242 385 1214 q 483 1269 440 1269 q 554 1242 526 1269 q 582 1171 582 1214 q 554 1100 582 1128 q 483 1072 526 1072 m 771 1072 q 700 1100 728 1072 q 672 1171 672 1128 q 700 1242 672 1214 q 771 1269 728 1269 q 842 1242 814 1269 q 869 1171 869 1214 q 842 1100 869 1128 q 771 1072 814 1072 z ',
    },
    ẅ: {
      ha: 1025,
      x_min: 15,
      x_max: 1010,
      o:
        'm 15 700 l 189 700 l 314 219 l 432 700 l 593 700 l 711 219 l 836 700 l 1010 700 l 786 0 l 633 0 l 513 453 l 392 0 l 239 0 l 15 700 m 368 800 q 297 828 325 800 q 269 899 269 856 q 297 969 269 942 q 368 997 325 997 q 439 969 411 997 q 467 899 467 942 q 439 828 467 856 q 368 800 411 800 m 656 800 q 585 828 613 800 q 557 899 557 856 q 585 969 557 942 q 656 997 613 997 q 726 969 699 997 q 754 899 754 942 q 726 828 754 856 q 656 800 699 800 z ',
    },
    ẞ: {
      ha: 933,
      x_min: 111,
      x_max: 869,
      o:
        'm 546 -11 q 388 13 481 -11 l 388 179 q 525 156 472 156 q 642 194 600 156 q 683 314 683 233 q 634 440 683 393 q 474 486 585 486 l 447 486 l 447 533 l 571 806 l 404 806 q 322 770 353 806 q 292 668 292 735 l 292 0 l 111 0 l 111 683 q 149 840 111 775 q 254 939 188 906 q 404 972 321 972 l 789 972 l 789 896 l 649 578 q 810 494 751 565 q 869 321 869 422 q 830 146 869 221 q 717 30 790 71 q 546 -11 644 -11 z ',
    },
    Ỳ: {
      ha: 767,
      x_min: 13,
      x_max: 754,
      o:
        'm 293 414 l 13 972 l 207 972 l 383 594 l 560 972 l 754 972 l 474 414 l 474 0 l 293 0 l 293 414 m 126 1256 l 360 1256 l 453 1039 l 328 1039 l 126 1256 z ',
    },
    ỳ: {
      ha: 689,
      x_min: 14,
      x_max: 675,
      o:
        'm 268 44 l 14 700 l 188 700 l 350 261 l 503 700 l 675 700 l 314 -283 l 147 -283 l 268 44 m 88 983 l 321 983 l 414 767 l 289 767 l 88 983 z ',
    },
    '–': {
      ha: 813,
      x_min: 90,
      x_max: 722,
      o: 'm 90 515 l 722 515 l 722 365 l 90 365 l 90 515 z ',
    },
    '—': {
      ha: 1071,
      x_min: 90,
      x_max: 981,
      o: 'm 90 515 l 981 515 l 981 365 l 90 365 l 90 515 z ',
    },
    '‘': {
      ha: 439,
      x_min: 61,
      x_max: 396,
      o: 'm 268 983 l 396 983 l 288 644 l 61 644 l 268 983 z ',
    },
    '’': {
      ha: 439,
      x_min: 43,
      x_max: 378,
      o: 'm 151 983 l 378 983 l 171 644 l 43 644 l 151 983 z ',
    },
    '‚': {
      ha: 439,
      x_min: 43,
      x_max: 378,
      o: 'm 151 189 l 378 189 l 171 -150 l 43 -150 l 151 189 z ',
    },
    '“': {
      ha: 744,
      x_min: 61,
      x_max: 701,
      o:
        'm 593 644 l 367 644 l 574 983 l 701 983 l 593 644 m 288 644 l 61 644 l 268 983 l 396 983 l 288 644 z ',
    },
    '”': {
      ha: 744,
      x_min: 43,
      x_max: 683,
      o:
        'm 151 983 l 378 983 l 171 644 l 43 644 l 151 983 m 457 983 l 683 983 l 476 644 l 349 644 l 457 983 z ',
    },
    '„': {
      ha: 699,
      x_min: 32,
      x_max: 672,
      o:
        'm 140 189 l 367 189 l 160 -150 l 32 -150 l 140 189 m 446 189 l 672 189 l 465 -150 l 338 -150 l 446 189 z ',
    },
    '†': {
      ha: 672,
      x_min: 44,
      x_max: 628,
      o:
        'm 251 550 l 44 550 l 44 700 l 251 700 l 251 1042 l 421 1042 l 421 700 l 628 700 l 628 550 l 421 550 l 421 -69 l 251 -69 l 251 550 z ',
    },
    '‡': {
      ha: 672,
      x_min: 44,
      x_max: 628,
      o:
        'm 251 272 l 44 272 l 44 422 l 251 422 l 251 550 l 44 550 l 44 700 l 251 700 l 251 1042 l 421 1042 l 421 700 l 628 700 l 628 550 l 421 550 l 421 422 l 628 422 l 628 272 l 421 272 l 421 -69 l 251 -69 l 251 272 z ',
    },
    '•': {
      ha: 550,
      x_min: 111,
      x_max: 439,
      o:
        'm 275 294 q 159 342 207 294 q 111 458 111 390 q 159 574 111 526 q 275 622 207 622 q 391 574 343 622 q 439 458 439 526 q 391 342 439 390 q 275 294 343 294 z ',
    },
    '…': {
      ha: 1222,
      x_min: 75,
      x_max: 1147,
      o:
        'm 192 -8 q 108 25 142 -8 q 75 108 75 58 q 108 192 75 158 q 192 225 142 225 q 275 192 242 225 q 308 108 308 158 q 275 25 308 58 q 192 -8 242 -8 m 611 -8 q 528 25 561 -8 q 494 108 494 58 q 528 192 494 158 q 611 225 561 225 q 694 192 661 225 q 728 108 728 158 q 694 25 728 58 q 611 -8 661 -8 m 1031 -8 q 947 25 981 -8 q 914 108 914 58 q 947 192 914 158 q 1031 225 981 225 q 1114 192 1081 225 q 1147 108 1147 158 q 1114 25 1147 58 q 1031 -8 1081 -8 z ',
    },
    '‰': {
      ha: 1699,
      x_min: 76,
      x_max: 1622,
      o:
        'm 163 28 l 910 1025 l 1010 946 l 263 -53 l 163 28 m 304 539 q 187 568 239 539 q 106 648 135 597 q 76 761 76 699 q 106 874 76 824 q 187 954 135 925 q 304 983 239 983 q 422 954 369 983 q 503 874 474 925 q 532 761 532 824 q 503 648 532 699 q 422 568 474 597 q 304 539 369 539 m 304 671 q 367 697 344 671 q 390 761 390 722 q 367 826 390 800 q 304 851 344 851 q 241 826 264 851 q 218 761 218 800 q 241 697 218 722 q 304 671 264 671 m 868 -11 q 751 18 803 -11 q 669 98 699 47 q 640 211 640 149 q 669 324 640 274 q 751 404 699 375 q 868 433 803 433 q 985 404 933 433 q 1067 324 1038 375 q 1096 211 1096 274 q 1067 98 1096 149 q 985 18 1038 47 q 868 -11 933 -11 m 1394 -11 q 1277 18 1329 -11 q 1196 98 1225 47 q 1167 211 1167 149 q 1196 324 1167 274 q 1277 404 1225 375 q 1394 433 1329 433 q 1512 404 1460 433 q 1593 324 1564 375 q 1622 211 1622 274 q 1593 98 1622 149 q 1512 18 1564 47 q 1394 -11 1460 -11 m 868 121 q 931 147 908 121 q 954 211 954 172 q 931 276 954 250 q 868 301 908 301 q 805 276 828 301 q 782 211 782 250 q 805 147 782 172 q 868 121 828 121 m 1394 121 q 1458 147 1435 121 q 1481 211 1481 172 q 1458 276 1481 250 q 1394 301 1435 301 q 1331 276 1354 301 q 1308 211 1308 250 q 1331 147 1308 172 q 1394 121 1354 121 z ',
    },
    '‹': {
      ha: 560,
      x_min: 61,
      x_max: 490,
      o:
        'm 61 374 l 61 488 l 490 790 l 490 613 l 233 431 l 490 249 l 490 71 l 61 374 z ',
    },
    '›': {
      ha: 560,
      x_min: 69,
      x_max: 499,
      o:
        'm 69 249 l 326 431 l 69 613 l 69 790 l 499 488 l 499 374 l 69 71 l 69 249 z ',
    },
    '⁄': {
      ha: 856,
      x_min: 4,
      x_max: 851,
      o: 'm 4 28 l 751 1025 l 851 946 l 104 -53 l 4 28 z ',
    },
    '⁈': {
      ha: 1008,
      x_min: 58,
      x_max: 897,
      o:
        'm 668 972 l 896 972 l 857 336 l 707 336 l 668 972 m 782 -8 q 700 25 733 -8 q 667 106 667 58 q 701 188 667 154 q 782 222 735 222 q 863 188 829 222 q 897 106 897 154 q 864 25 897 58 q 782 -8 831 -8 m 321 296 q 183 345 236 296 q 129 474 129 394 q 169 583 129 540 q 279 654 208 626 q 389 710 360 685 q 418 769 418 735 q 393 822 418 804 q 328 839 368 839 q 254 815 285 839 q 210 746 224 790 l 58 771 q 145 923 75 863 q 324 983 215 983 q 510 924 440 983 q 581 764 581 864 q 535 643 581 686 q 389 561 490 600 q 295 515 319 533 q 271 469 271 497 q 285 434 271 447 q 321 421 300 421 q 400 485 378 421 l 522 439 q 447 334 499 372 q 321 296 394 296 m 321 -8 q 239 25 272 -8 q 206 106 206 58 q 240 188 206 154 q 321 222 274 222 q 402 188 368 222 q 436 106 436 154 q 403 25 436 58 q 321 -8 369 -8 z ',
    },
    '⁉': {
      ha: 996,
      x_min: 111,
      x_max: 938,
      o:
        'm 340 972 l 113 972 l 151 336 l 301 336 l 340 972 m 226 -8 q 308 25 275 -8 q 342 106 342 58 q 308 188 342 154 q 226 222 274 222 q 145 188 179 222 q 111 106 111 154 q 144 25 111 58 q 226 -8 178 -8 m 678 296 q 540 345 593 296 q 486 474 486 394 q 526 583 486 540 q 636 654 565 626 q 746 710 717 685 q 775 769 775 735 q 750 822 775 804 q 685 839 725 839 q 611 815 642 839 q 567 746 581 790 l 415 771 q 502 923 432 863 q 681 983 572 983 q 867 924 797 983 q 938 764 938 864 q 892 643 938 686 q 746 561 847 600 q 652 515 676 533 q 628 469 628 497 q 642 434 628 447 q 678 421 657 421 q 757 485 735 421 l 879 439 q 803 334 856 372 q 678 296 751 296 m 678 -8 q 596 25 629 -8 q 563 106 563 58 q 597 188 563 154 q 678 222 631 222 q 759 188 725 222 q 793 106 793 154 q 760 25 793 58 q 678 -8 726 -8 z ',
    },
    '⁰': {
      ha: 575,
      x_min: 57,
      x_max: 518,
      o:
        'm 288 411 q 119 485 181 411 q 57 694 57 560 q 119 903 57 829 q 288 978 181 978 q 456 903 394 978 q 518 694 518 829 q 456 485 518 560 q 288 411 394 411 m 288 526 q 361 567 332 526 q 390 694 390 608 q 361 822 390 781 q 288 863 332 863 q 214 822 243 863 q 185 694 185 781 q 214 567 185 608 q 288 526 243 526 z ',
    },
    '⁴': {
      ha: 483,
      x_min: 39,
      x_max: 454,
      o:
        'm 271 507 l 39 507 l 39 569 l 263 972 l 394 972 l 394 622 l 454 622 l 454 507 l 394 507 l 394 417 l 271 417 l 271 507 m 271 622 l 271 792 l 183 622 l 271 622 z ',
    },
    '⁵': {
      ha: 485,
      x_min: 49,
      x_max: 444,
      o:
        'm 240 411 q 110 458 165 411 q 49 575 56 504 l 169 589 q 194 543 175 560 q 240 526 214 526 q 296 548 276 526 q 315 608 315 569 q 240 685 315 685 q 160 653 196 685 l 61 674 l 90 972 l 410 972 l 410 857 l 194 857 l 181 764 q 268 785 218 785 q 399 735 353 785 q 444 608 444 686 q 389 464 444 517 q 240 411 333 411 z ',
    },
    '⁶': {
      ha: 504,
      x_min: 57,
      x_max: 447,
      o:
        'm 251 411 q 111 462 165 411 q 57 594 57 513 q 82 699 57 656 l 239 978 l 378 978 l 254 772 q 279 776 264 776 q 399 731 350 776 q 447 594 447 685 q 392 463 447 514 q 251 411 338 411 m 251 526 q 298 545 279 526 q 317 594 317 564 q 299 643 317 625 q 251 661 281 661 q 205 643 224 661 q 186 594 186 625 q 205 546 186 565 q 251 526 224 526 z ',
    },
    '⁷': {
      ha: 429,
      x_min: 40,
      x_max: 403,
      o:
        'm 246 857 l 40 857 l 40 972 l 403 972 l 403 924 l 194 417 l 63 417 l 246 857 z ',
    },
    '⁸': {
      ha: 497,
      x_min: 57,
      x_max: 440,
      o:
        'm 249 411 q 110 460 163 411 q 57 592 57 510 q 80 670 57 639 q 138 717 103 701 q 91 763 107 733 q 75 828 75 792 q 122 933 75 889 q 249 978 169 978 q 375 933 328 978 q 422 828 422 889 q 406 763 422 792 q 360 717 390 733 q 417 670 394 701 q 440 592 440 639 q 388 460 440 510 q 249 411 335 411 m 249 763 q 290 779 275 763 q 306 824 306 796 q 290 868 306 851 q 249 885 275 885 q 207 868 222 885 q 192 824 192 851 q 207 779 192 796 q 249 763 222 763 m 249 526 q 294 544 278 526 q 311 592 311 563 q 294 639 311 621 q 249 657 278 657 q 203 639 219 657 q 186 592 186 621 q 203 544 186 563 q 249 526 219 526 z ',
    },
    '⁹': {
      ha: 504,
      x_min: 57,
      x_max: 447,
      o:
        'm 250 617 q 225 613 240 613 q 106 658 154 613 q 57 794 57 704 q 112 926 57 875 q 253 978 167 978 q 393 927 339 978 q 447 794 447 876 q 422 690 447 735 l 265 411 l 126 411 l 250 617 m 253 728 q 299 746 281 728 q 318 794 318 764 q 299 843 318 824 q 253 863 281 863 q 206 844 225 863 q 188 794 188 825 q 206 746 188 764 q 253 728 224 728 z ',
    },
    '₀': {
      ha: 575,
      x_min: 57,
      x_max: 518,
      o:
        'm 288 -289 q 119 -215 181 -289 q 57 -6 57 -140 q 119 203 57 129 q 288 278 181 278 q 456 203 394 278 q 518 -6 518 129 q 456 -215 518 -140 q 288 -289 394 -289 m 288 -174 q 361 -133 332 -174 q 390 -6 390 -92 q 361 122 390 81 q 288 163 332 163 q 214 122 243 163 q 185 -6 185 81 q 214 -133 185 -92 q 288 -174 243 -174 z ',
    },
    '₁': {
      ha: 340,
      x_min: 35,
      x_max: 276,
      o:
        'm 153 103 l 35 50 l 35 182 l 225 272 l 276 272 l 276 -283 l 153 -283 l 153 103 z ',
    },
    '₂': {
      ha: 463,
      x_min: 43,
      x_max: 419,
      o:
        'm 43 -235 l 244 11 q 282 106 282 56 q 267 148 282 133 q 229 163 253 163 q 158 89 172 163 l 47 121 q 106 234 56 190 q 229 278 157 278 q 361 232 311 278 q 411 108 411 186 q 356 -29 411 39 l 242 -168 l 419 -168 l 419 -283 l 43 -283 l 43 -235 z ',
    },
    '₃': {
      ha: 469,
      x_min: 46,
      x_max: 435,
      o:
        'm 240 -289 q 103 -239 157 -289 q 46 -114 50 -189 l 157 -100 q 186 -155 164 -136 q 238 -174 208 -174 q 288 -153 271 -174 q 306 -92 306 -132 q 288 -36 306 -54 q 239 -18 269 -18 q 213 -21 224 -18 q 188 -32 201 -24 l 132 38 l 224 157 l 71 157 l 71 272 l 400 272 l 400 224 l 276 65 q 390 18 344 65 q 435 -96 435 -29 q 385 -237 435 -185 q 240 -289 336 -289 z ',
    },
    '₄': {
      ha: 483,
      x_min: 39,
      x_max: 454,
      o:
        'm 271 -193 l 39 -193 l 39 -131 l 263 272 l 394 272 l 394 -78 l 454 -78 l 454 -193 l 394 -193 l 394 -283 l 271 -283 l 271 -193 m 271 -78 l 271 92 l 183 -78 l 271 -78 z ',
    },
    '₅': {
      ha: 485,
      x_min: 49,
      x_max: 444,
      o:
        'm 240 -289 q 110 -242 165 -289 q 49 -125 56 -196 l 169 -111 q 194 -157 175 -140 q 240 -174 214 -174 q 296 -152 276 -174 q 315 -92 315 -131 q 240 -15 315 -15 q 160 -47 196 -15 l 61 -26 l 90 272 l 410 272 l 410 157 l 194 157 l 181 64 q 268 85 218 85 q 399 35 353 85 q 444 -92 444 -14 q 389 -236 444 -183 q 240 -289 333 -289 z ',
    },
    '₆': {
      ha: 504,
      x_min: 57,
      x_max: 447,
      o:
        'm 251 -289 q 111 -238 165 -289 q 57 -106 57 -187 q 82 -1 57 -44 l 239 278 l 378 278 l 254 72 q 279 76 264 76 q 399 31 350 76 q 447 -106 447 -15 q 392 -237 447 -186 q 251 -289 338 -289 m 251 -174 q 298 -155 279 -174 q 317 -106 317 -136 q 299 -57 317 -75 q 251 -39 281 -39 q 205 -57 224 -39 q 186 -106 186 -75 q 205 -154 186 -135 q 251 -174 224 -174 z ',
    },
    '₇': {
      ha: 429,
      x_min: 40,
      x_max: 403,
      o:
        'm 246 157 l 40 157 l 40 272 l 403 272 l 403 224 l 194 -283 l 63 -283 l 246 157 z ',
    },
    '₈': {
      ha: 497,
      x_min: 57,
      x_max: 440,
      o:
        'm 249 -289 q 110 -240 163 -289 q 57 -108 57 -190 q 80 -30 57 -61 q 138 17 103 1 q 91 63 107 33 q 75 128 75 92 q 122 233 75 189 q 249 278 169 278 q 375 233 328 278 q 422 128 422 189 q 406 63 422 92 q 360 17 390 33 q 417 -30 394 1 q 440 -108 440 -61 q 388 -240 440 -190 q 249 -289 335 -289 m 249 63 q 290 79 275 63 q 306 124 306 96 q 290 168 306 151 q 249 185 275 185 q 207 168 222 185 q 192 124 192 151 q 207 79 192 96 q 249 63 222 63 m 249 -174 q 294 -156 278 -174 q 311 -108 311 -137 q 294 -61 311 -79 q 249 -43 278 -43 q 203 -61 219 -43 q 186 -108 186 -79 q 203 -156 186 -137 q 249 -174 219 -174 z ',
    },
    '₉': {
      ha: 504,
      x_min: 57,
      x_max: 447,
      o:
        'm 250 -83 q 225 -87 240 -87 q 106 -42 154 -87 q 57 94 57 4 q 112 226 57 175 q 253 278 167 278 q 393 227 339 278 q 447 94 447 176 q 422 -10 447 35 l 265 -289 l 126 -289 l 250 -83 m 253 28 q 299 46 281 28 q 318 94 318 64 q 299 143 318 124 q 253 163 281 163 q 206 144 225 163 q 188 94 188 125 q 206 46 188 64 q 253 28 224 28 z ',
    },
    '₣': {
      ha: 768,
      x_min: 44,
      x_max: 726,
      o:
        'm 292 806 l 292 583 l 642 583 l 642 417 l 292 417 l 292 292 l 476 292 l 476 125 l 292 125 l 292 0 l 111 0 l 111 125 l 44 125 l 44 292 l 111 292 l 111 972 l 726 972 l 726 806 l 292 806 z ',
    },
    '₨': {
      ha: 1454,
      x_min: 42,
      x_max: 1396,
      o:
        'm 771 636 q 713 509 758 561 q 594 435 668 457 l 864 0 l 663 0 l 401 419 l 307 419 l 307 0 l 126 0 l 126 636 l 42 636 l 42 756 l 126 756 l 126 972 l 481 972 q 679 914 604 972 q 771 756 754 856 l 856 756 l 856 636 l 771 636 m 307 756 l 583 756 q 482 806 556 806 l 307 806 l 307 756 m 1228 413 q 1352 336 1308 383 q 1396 215 1396 289 q 1331 51 1396 113 q 1160 -11 1265 -11 q 978 44 1051 -11 q 882 178 906 100 l 1019 251 q 1074 167 1039 197 q 1158 136 1110 136 q 1221 152 1196 136 q 1246 204 1246 168 q 1216 256 1246 236 q 1124 299 1186 276 q 1094 310 1114 301 q 969 390 1014 342 q 925 515 925 439 q 954 614 925 569 q 1034 685 983 658 q 1149 711 1085 711 q 1278 681 1219 711 q 1368 597 1336 651 l 1265 503 q 1153 564 1224 564 q 1105 549 1125 564 q 1085 511 1085 535 q 1114 465 1085 486 q 1228 413 1143 443 m 482 586 q 583 636 556 586 l 307 636 l 307 586 l 482 586 z ',
    },
    '₫': {
      ha: 672,
      x_min: 58,
      x_max: 629,
      o:
        'm 629 817 l 581 817 l 581 251 l 414 251 l 414 296 q 294 242 372 242 q 126 314 188 242 q 64 510 64 386 q 126 705 64 633 q 292 776 188 776 q 414 726 371 776 l 414 817 l 294 817 l 294 924 l 414 924 l 414 972 l 581 972 l 581 924 l 629 924 l 629 817 m 325 385 q 396 416 369 385 q 422 510 422 447 q 395 603 422 571 q 325 635 368 635 q 253 603 281 635 q 226 510 226 571 q 253 416 226 447 q 325 385 281 385 m 629 81 l 58 81 l 58 188 l 629 188 l 629 81 z ',
    },
    '€': {
      ha: 899,
      x_min: 39,
      x_max: 849,
      o:
        'm 549 -11 q 311 69 410 -11 q 178 300 213 149 l 39 300 l 108 450 l 163 450 l 163 522 l 39 522 l 108 672 l 178 672 q 311 903 213 824 q 549 983 410 983 q 731 942 656 983 q 849 821 806 900 l 699 732 q 637 799 676 775 q 549 822 597 822 q 354 672 399 822 l 646 672 l 576 522 l 335 522 l 335 450 l 646 450 l 576 300 l 354 300 q 549 150 399 150 q 637 174 597 150 q 699 240 676 197 l 849 151 q 731 31 806 72 q 549 -11 656 -11 z ',
    },
    '₭': {
      ha: 897,
      x_min: 22,
      x_max: 883,
      o:
        'm 883 0 l 654 0 l 301 464 l 301 0 l 121 0 l 121 464 l 22 464 l 22 611 l 121 611 l 121 972 l 301 972 l 301 611 l 633 972 l 856 972 l 528 611 l 838 611 l 838 464 l 519 464 l 883 0 z ',
    },
    '₱': {
      ha: 943,
      x_min: 42,
      x_max: 901,
      o:
        'm 901 703 l 806 703 q 807 676 807 694 q 806 650 807 658 l 901 650 l 901 583 l 796 583 q 698 435 772 489 q 503 381 624 381 l 317 381 l 317 0 l 136 0 l 136 583 l 42 583 l 42 650 l 136 650 l 136 703 l 42 703 l 42 769 l 136 769 l 136 972 l 503 972 q 698 918 624 972 q 796 769 772 864 l 901 769 l 901 703 m 317 769 l 594 769 q 496 806 563 806 l 317 806 l 317 769 m 624 676 q 622 703 624 694 l 317 703 l 317 650 l 622 650 q 624 676 624 658 m 496 547 q 594 583 563 547 l 317 583 l 317 547 l 496 547 z ',
    },
    '₴': {
      ha: 724,
      x_min: 44,
      x_max: 676,
      o:
        'm 676 660 l 676 510 l 44 510 l 44 660 l 432 660 q 460 728 460 690 q 431 791 460 765 q 361 817 401 817 q 232 714 268 817 l 86 807 q 361 983 160 983 q 502 955 440 983 q 598 876 564 926 q 632 763 632 826 q 603 660 632 707 l 676 660 m 44 463 l 676 463 l 676 313 l 289 313 q 261 244 261 282 q 290 181 261 207 q 360 156 319 156 q 489 258 453 156 l 635 165 q 360 -11 561 -11 q 219 17 281 -11 q 123 96 157 46 q 89 210 89 146 q 118 313 89 265 l 44 313 l 44 463 z ',
    },
    '₸': {
      ha: 731,
      x_min: 33,
      x_max: 697,
      o:
        'm 33 944 l 697 944 l 697 778 l 33 778 l 33 944 m 275 533 l 33 533 l 33 700 l 697 700 l 697 533 l 456 533 l 456 0 l 275 0 l 275 533 z ',
    },
    '₺': {
      ha: 935,
      x_min: 22,
      x_max: 908,
      o:
        'm 908 364 l 908 296 q 831 81 908 163 q 604 0 753 0 l 238 0 l 238 311 l 22 254 l 22 404 l 238 461 l 238 547 l 22 490 l 22 640 l 238 697 l 238 972 l 418 972 l 418 744 l 654 807 l 654 657 l 418 594 l 418 508 l 654 571 l 654 421 l 418 358 l 418 167 l 597 167 q 692 199 658 167 q 725 296 725 231 l 725 364 l 908 364 z ',
    },
    '₽': {
      ha: 882,
      x_min: 42,
      x_max: 835,
      o:
        'm 344 381 l 344 301 l 561 301 l 561 135 l 344 135 l 344 0 l 164 0 l 164 135 l 42 135 l 42 301 l 164 301 l 164 381 l 42 381 l 42 547 l 164 547 l 164 972 l 531 972 q 757 891 679 972 q 835 676 835 810 q 757 462 835 543 q 531 381 679 381 l 344 381 m 344 547 l 524 547 q 618 579 585 547 q 651 676 651 611 q 618 774 651 742 q 524 806 585 806 l 344 806 l 344 547 z ',
    },
    '₿': {
      ha: 858,
      x_min: 111,
      x_max: 794,
      o:
        'm 794 293 q 724 92 794 167 q 528 3 654 17 l 528 -97 l 408 -97 l 408 0 l 340 0 l 340 -97 l 221 -97 l 221 0 l 111 0 l 111 972 l 221 972 l 221 1069 l 340 1069 l 340 972 l 408 972 l 408 1069 l 528 1069 l 528 968 q 687 888 629 953 q 744 710 744 822 q 719 602 744 650 q 649 531 694 554 q 794 293 794 471 m 571 700 q 542 781 571 757 q 453 806 513 806 l 292 806 l 292 594 l 457 594 q 542 619 514 594 q 571 700 571 643 m 457 167 q 576 200 539 167 q 614 297 614 233 q 576 394 614 361 q 457 428 539 428 l 292 428 l 292 167 l 457 167 z ',
    },
    ℓ: {
      ha: 713,
      x_min: 8,
      x_max: 682,
      o:
        'm 682 200 q 594 41 656 93 q 424 -11 533 -11 q 226 57 288 -11 q 164 257 164 125 l 164 333 l 88 289 l 8 428 q 164 521 97 478 l 164 739 q 223 917 164 851 q 396 983 282 983 q 553 927 503 983 q 604 794 604 871 q 367 461 604 633 l 344 446 l 344 232 q 368 160 344 185 q 433 136 392 136 q 497 165 472 136 q 536 253 522 193 l 682 200 m 386 836 q 355 822 365 836 q 344 781 344 807 l 344 651 q 424 790 424 724 q 386 836 424 836 z ',
    },
    '№': {
      ha: 1761,
      x_min: 111,
      x_max: 1703,
      o:
        'm 111 972 l 301 972 l 658 331 l 658 972 l 839 972 l 839 0 l 649 0 l 292 642 l 292 0 l 111 0 l 111 972 m 1032 150 l 1664 150 l 1664 0 l 1032 0 l 1032 150 m 1347 261 q 1157 308 1238 261 q 1034 438 1076 356 q 992 622 992 519 q 1034 807 992 725 q 1157 936 1076 889 q 1347 983 1238 983 q 1538 936 1457 983 q 1660 807 1618 889 q 1703 622 1703 725 q 1660 438 1703 519 q 1538 308 1618 356 q 1347 261 1457 261 m 1347 408 q 1475 470 1428 408 q 1522 622 1522 532 q 1475 774 1522 713 q 1347 836 1428 836 q 1219 774 1267 836 q 1172 622 1172 713 q 1219 470 1172 532 q 1347 408 1267 408 z ',
    },
    '℗': {
      ha: 1236,
      x_min: 83,
      x_max: 1153,
      o:
        'm 618 -56 q 346 15 468 -56 q 153 210 224 86 q 83 486 83 335 q 153 762 83 638 q 346 957 224 886 q 618 1028 468 1028 q 890 957 768 1028 q 1083 762 1013 886 q 1153 486 1153 638 q 1083 210 1153 335 q 890 15 1013 86 q 618 -56 768 -56 m 618 92 q 815 142 728 92 q 951 283 903 193 q 1000 486 1000 372 q 951 690 1000 600 q 815 830 903 779 q 618 881 728 881 q 421 830 508 881 q 285 690 333 779 q 236 486 236 600 q 285 283 236 372 q 421 142 333 193 q 618 92 508 92 m 415 782 l 650 782 q 796 738 747 782 q 844 613 844 694 q 799 482 844 521 q 650 443 754 443 l 561 443 l 561 190 l 415 190 l 415 782 m 636 558 q 688 572 672 558 q 703 613 703 586 q 688 653 703 639 q 636 667 672 667 l 561 667 l 561 558 l 636 558 z ',
    },
    '℠': {
      ha: 1147,
      x_min: 35,
      x_max: 1042,
      o:
        'm 228 406 q 101 450 154 406 q 35 561 49 494 l 135 617 q 172 549 144 574 q 233 524 199 524 q 277 539 261 524 q 293 582 293 554 q 272 630 293 613 q 189 672 250 647 q 69 829 69 721 q 115 940 69 896 q 236 983 161 983 q 339 958 301 983 q 400 879 376 933 l 303 821 q 278 859 293 847 q 240 871 264 871 q 208 860 221 871 q 194 832 194 849 q 217 791 194 807 q 308 744 239 775 q 428 588 428 693 q 371 454 428 503 q 228 406 314 406 m 503 972 l 638 972 l 772 649 l 907 972 l 1042 972 l 1042 417 l 907 417 l 907 685 l 817 468 l 728 468 l 638 685 l 638 417 l 503 417 l 503 972 z ',
    },
    '™': {
      ha: 1183,
      x_min: 32,
      x_max: 1078,
      o:
        'm 176 847 l 32 847 l 32 972 l 456 972 l 456 847 l 311 847 l 311 417 l 176 417 l 176 847 m 539 972 l 674 972 l 808 649 l 943 972 l 1078 972 l 1078 417 l 943 417 l 943 685 l 853 468 l 764 468 l 674 685 l 674 417 l 539 417 l 539 972 z ',
    },
    Ω: {
      ha: 967,
      x_min: 39,
      x_max: 928,
      o:
        'm 39 153 l 238 153 q 94 331 149 238 q 39 560 39 425 q 93 778 39 682 q 248 928 147 874 q 483 983 349 983 q 719 928 618 983 q 874 778 819 874 q 928 560 928 682 q 873 331 928 425 q 729 153 818 238 l 928 153 l 928 0 l 543 0 l 543 153 q 690 326 636 224 q 744 543 744 428 q 672 744 744 671 q 483 817 599 817 q 295 744 368 817 q 222 543 222 671 q 276 326 222 428 q 424 153 331 224 l 424 0 l 39 0 l 39 153 z ',
    },
    '℮': {
      ha: 1058,
      x_min: 42,
      x_max: 1017,
      o:
        'm 218 213 q 349 99 264 142 q 529 56 433 56 q 747 110 649 56 q 889 263 844 165 l 967 263 q 788 65 907 140 q 529 -10 669 -10 q 274 57 385 -10 q 102 237 163 124 q 42 486 42 350 q 102 738 42 624 q 274 917 163 851 q 529 983 385 983 q 781 920 669 983 q 954 744 892 857 q 1017 486 1017 631 l 218 486 l 218 213 m 529 921 q 352 881 435 921 q 218 772 269 840 l 218 551 l 847 551 l 847 768 q 717 876 803 832 q 529 921 632 921 z ',
    },
    '⅓': {
      ha: 1204,
      x_min: 35,
      x_max: 1169,
      o:
        'm 153 803 l 35 750 l 35 882 l 225 972 l 276 972 l 276 417 l 153 417 l 153 803 m 149 28 l 896 1025 l 996 946 l 249 -53 l 149 28 m 975 -11 q 838 39 892 -11 q 781 164 785 89 l 892 178 q 921 123 899 142 q 972 104 943 104 q 1023 125 1006 104 q 1040 186 1040 146 q 1022 242 1040 224 q 974 260 1004 260 q 947 257 958 260 q 922 246 936 254 l 867 315 l 958 435 l 806 435 l 806 550 l 1135 550 l 1135 501 l 1011 343 q 1124 296 1079 343 q 1169 182 1169 249 q 1120 41 1169 93 q 975 -11 1071 -11 z ',
    },
    '⅔': {
      ha: 1328,
      x_min: 43,
      x_max: 1293,
      o:
        'm 43 465 l 244 711 q 282 806 282 756 q 267 848 282 833 q 229 863 253 863 q 158 789 172 863 l 47 821 q 106 934 56 890 q 229 978 157 978 q 361 932 311 978 q 411 808 411 886 q 356 671 411 739 l 242 532 l 419 532 l 419 417 l 43 417 l 43 465 m 272 28 l 1019 1025 l 1119 946 l 372 -53 l 272 28 m 1099 -11 q 962 39 1015 -11 q 904 164 908 89 l 1015 178 q 1044 123 1022 142 q 1096 104 1067 104 q 1147 125 1129 104 q 1164 186 1164 146 q 1146 242 1164 224 q 1097 260 1128 260 q 1071 257 1082 260 q 1046 246 1060 254 l 990 315 l 1082 435 l 929 435 l 929 550 l 1258 550 l 1258 501 l 1135 343 q 1248 296 1203 343 q 1293 182 1293 249 q 1244 41 1293 93 q 1099 -11 1194 -11 z ',
    },
    '⅛': {
      ha: 1182,
      x_min: 35,
      x_max: 1125,
      o:
        'm 153 803 l 35 750 l 35 882 l 225 972 l 276 972 l 276 417 l 153 417 l 153 803 m 149 28 l 896 1025 l 996 946 l 249 -53 l 149 28 m 933 -11 q 794 38 847 -11 q 742 169 742 88 q 765 248 742 217 q 822 294 788 279 q 776 340 792 311 q 760 406 760 369 q 807 511 760 467 q 933 556 854 556 q 1060 511 1013 556 q 1107 406 1107 467 q 1091 340 1107 369 q 1044 294 1075 311 q 1102 248 1079 279 q 1125 169 1125 217 q 1072 38 1125 88 q 933 -11 1019 -11 m 933 340 q 975 357 960 340 q 990 401 990 374 q 975 446 990 429 q 933 463 960 463 q 892 446 907 463 q 876 401 876 429 q 892 357 876 374 q 933 340 907 340 m 933 104 q 979 122 963 104 q 996 169 996 140 q 979 217 996 199 q 933 235 963 235 q 888 217 904 235 q 871 169 871 199 q 888 122 871 140 q 933 104 904 104 z ',
    },
    '⅜': {
      ha: 1243,
      x_min: 46,
      x_max: 1186,
      o:
        'm 240 411 q 103 461 157 411 q 46 586 50 511 l 157 600 q 186 545 164 564 q 238 526 208 526 q 288 547 271 526 q 306 608 306 568 q 288 664 306 646 q 239 682 269 682 q 213 679 224 682 q 188 668 201 676 l 132 738 l 224 857 l 71 857 l 71 972 l 400 972 l 400 924 l 276 765 q 390 718 344 765 q 435 604 435 671 q 385 463 435 515 q 240 411 336 411 m 210 28 l 957 1025 l 1057 946 l 310 -53 l 210 28 m 994 -11 q 856 38 908 -11 q 803 169 803 88 q 826 248 803 217 q 883 294 849 279 q 837 340 853 311 q 821 406 821 369 q 868 511 821 467 q 994 556 915 556 q 1121 511 1074 556 q 1168 406 1168 467 q 1152 340 1168 369 q 1106 294 1136 311 q 1163 248 1140 279 q 1186 169 1186 217 q 1133 38 1186 88 q 994 -11 1081 -11 m 994 340 q 1036 357 1021 340 q 1051 401 1051 374 q 1036 446 1051 429 q 994 463 1021 463 q 953 446 968 463 q 938 401 938 429 q 953 357 938 374 q 994 340 968 340 m 994 104 q 1040 122 1024 104 q 1057 169 1057 140 q 1040 217 1057 199 q 994 235 1024 235 q 949 217 965 235 q 932 169 932 199 q 949 122 932 140 q 994 104 965 104 z ',
    },
    '⅝': {
      ha: 1243,
      x_min: 49,
      x_max: 1186,
      o:
        'm 240 411 q 110 458 165 411 q 49 575 56 504 l 169 589 q 194 543 175 560 q 240 526 214 526 q 296 548 276 526 q 315 608 315 569 q 240 685 315 685 q 160 653 196 685 l 61 674 l 90 972 l 410 972 l 410 857 l 194 857 l 181 764 q 268 785 218 785 q 399 735 353 785 q 444 608 444 686 q 389 464 444 517 q 240 411 333 411 m 210 28 l 957 1025 l 1057 946 l 310 -53 l 210 28 m 994 -11 q 856 38 908 -11 q 803 169 803 88 q 826 248 803 217 q 883 294 849 279 q 837 340 853 311 q 821 406 821 369 q 868 511 821 467 q 994 556 915 556 q 1121 511 1074 556 q 1168 406 1168 467 q 1152 340 1168 369 q 1106 294 1136 311 q 1163 248 1140 279 q 1186 169 1186 217 q 1133 38 1186 88 q 994 -11 1081 -11 m 994 340 q 1036 357 1021 340 q 1051 401 1051 374 q 1036 446 1051 429 q 994 463 1021 463 q 953 446 968 463 q 938 401 938 429 q 953 357 938 374 q 994 340 968 340 m 994 104 q 1040 122 1024 104 q 1057 169 1057 140 q 1040 217 1057 199 q 994 235 1024 235 q 949 217 965 235 q 932 169 932 199 q 949 122 932 140 q 994 104 965 104 z ',
    },
    '⅞': {
      ha: 1115,
      x_min: 40,
      x_max: 1058,
      o:
        'm 246 857 l 40 857 l 40 972 l 403 972 l 403 924 l 194 417 l 63 417 l 246 857 m 82 28 l 829 1025 l 929 946 l 182 -53 l 82 28 m 867 -11 q 728 38 781 -11 q 675 169 675 88 q 698 248 675 217 q 756 294 721 279 q 709 340 725 311 q 693 406 693 369 q 740 511 693 467 q 867 556 788 556 q 993 511 946 556 q 1040 406 1040 467 q 1024 340 1040 369 q 978 294 1008 311 q 1035 248 1013 279 q 1058 169 1058 217 q 1006 38 1058 88 q 867 -11 953 -11 m 867 340 q 908 357 893 340 q 924 401 924 374 q 908 446 924 429 q 867 463 893 463 q 825 446 840 463 q 810 401 810 429 q 825 357 810 374 q 867 340 840 340 m 867 104 q 913 122 896 104 q 929 169 929 140 q 913 217 929 199 q 867 235 896 235 q 821 217 838 235 q 804 169 804 199 q 821 122 804 140 q 867 104 838 104 z ',
    },
    '←': {
      ha: 918,
      x_min: 50,
      x_max: 854,
      o:
        'm 50 486 l 404 840 l 503 739 l 326 560 l 854 560 l 854 413 l 326 413 l 503 233 l 404 132 l 50 486 z ',
    },
    '↑': {
      ha: 903,
      x_min: 97,
      x_max: 806,
      o:
        'm 378 613 l 199 436 l 97 535 l 451 889 l 806 535 l 704 436 l 525 613 l 525 83 l 378 83 l 378 613 z ',
    },
    '→': {
      ha: 918,
      x_min: 50,
      x_max: 854,
      o:
        'm 401 233 l 578 413 l 50 413 l 50 560 l 578 560 l 401 739 l 500 840 l 854 486 l 500 132 l 401 233 z ',
    },
    '↓': {
      ha: 903,
      x_min: 97,
      x_max: 806,
      o:
        'm 97 438 l 199 536 l 378 360 l 378 889 l 525 889 l 525 360 l 704 536 l 806 438 l 451 83 l 97 438 z ',
    },
    '↔': {
      ha: 1196,
      x_min: 50,
      x_max: 1132,
      o:
        'm 50 486 l 404 840 l 503 739 l 326 560 l 854 560 l 854 413 l 326 413 l 503 233 l 404 132 l 50 486 m 679 233 l 856 413 l 328 413 l 328 560 l 856 560 l 679 739 l 778 840 l 1132 486 l 778 132 l 679 233 z ',
    },
    '↕': {
      ha: 903,
      x_min: 97,
      x_max: 806,
      o:
        'm 378 753 l 199 576 l 97 675 l 451 1029 l 806 675 l 704 576 l 525 753 l 525 224 l 378 224 l 378 753 m 97 301 l 199 400 l 378 224 l 378 753 l 525 753 l 525 224 l 704 400 l 806 301 l 451 -53 l 97 301 z ',
    },
    '↖': {
      ha: 901,
      x_min: 136,
      x_max: 758,
      o:
        'm 283 547 l 283 296 l 136 296 l 136 797 l 638 797 l 638 650 l 386 650 l 758 279 l 654 175 l 283 547 z ',
    },
    '↗': {
      ha: 901,
      x_min: 143,
      x_max: 765,
      o:
        'm 143 279 l 515 650 l 264 650 l 264 797 l 765 797 l 765 296 l 618 296 l 618 547 l 247 175 l 143 279 z ',
    },
    '↘': {
      ha: 901,
      x_min: 143,
      x_max: 765,
      o:
        'm 264 322 l 515 322 l 143 693 l 247 797 l 618 425 l 618 676 l 765 676 l 765 175 l 264 175 l 264 322 z ',
    },
    '↙': {
      ha: 901,
      x_min: 136,
      x_max: 758,
      o:
        'm 136 676 l 283 676 l 283 425 l 654 797 l 758 693 l 386 322 l 638 322 l 638 175 l 136 175 l 136 676 z ',
    },
    '∂': {
      ha: 851,
      x_min: 58,
      x_max: 793,
      o:
        'm 361 -11 q 205 26 274 -11 q 97 133 136 64 q 58 290 58 201 q 114 506 58 410 q 268 657 169 603 q 490 711 367 711 q 553 703 521 711 q 611 681 585 694 q 561 798 599 760 q 456 836 524 836 q 363 811 406 836 q 296 733 321 786 l 139 782 q 201 884 156 838 q 310 957 247 931 q 439 983 372 983 q 709 866 625 983 q 793 511 793 749 q 690 134 793 279 q 361 -11 588 -11 m 389 136 q 502 172 454 136 q 574 269 550 208 q 599 399 599 329 q 569 523 599 482 q 475 564 540 564 q 358 526 410 564 q 278 427 307 488 q 249 301 249 367 q 283 183 249 231 q 389 136 318 136 z ',
    },
    '∆': {
      ha: 858,
      x_min: 14,
      x_max: 844,
      o:
        'm 14 44 l 358 972 l 500 972 l 844 44 l 844 0 l 14 0 l 14 44 m 642 150 l 429 761 l 217 150 l 642 150 z ',
    },
    '∏': {
      ha: 790,
      x_min: 111,
      x_max: 679,
      o:
        'm 111 972 l 679 972 l 679 0 l 507 0 l 507 822 l 283 822 l 283 0 l 111 0 l 111 972 z ',
    },
    '∑': {
      ha: 754,
      x_min: 72,
      x_max: 685,
      o:
        'm 72 76 l 331 486 l 72 896 l 72 972 l 685 972 l 685 822 l 307 822 l 503 506 l 503 467 l 307 150 l 685 150 l 685 0 l 72 0 l 72 76 z ',
    },
    '−': {
      ha: 842,
      x_min: 90,
      x_max: 751,
      o: 'm 90 515 l 751 515 l 751 365 l 90 365 l 90 515 z ',
    },
    '∕': {
      ha: 775,
      x_min: 1,
      x_max: 774,
      o: 'm 607 1042 l 774 1042 l 168 -69 l 1 -69 l 607 1042 z ',
    },
    '∙': {
      ha: 501,
      x_min: 111,
      x_max: 390,
      o:
        'm 251 281 q 152 322 193 281 q 111 421 111 363 q 152 520 111 479 q 251 561 193 561 q 349 520 308 561 q 390 421 390 479 q 349 322 390 363 q 251 281 308 281 z ',
    },
    '√': {
      ha: 786,
      x_min: 49,
      x_max: 785,
      o:
        'm 210 385 l 49 385 l 49 540 l 304 540 l 403 226 l 618 983 l 785 983 l 479 0 l 338 0 l 210 385 z ',
    },
    '∞': {
      ha: 1225,
      x_min: 69,
      x_max: 1156,
      o:
        'm 338 233 q 140 306 210 233 q 69 499 69 378 q 140 692 69 619 q 338 764 210 764 q 491 732 415 764 q 613 632 567 700 q 734 732 658 700 q 888 764 810 764 q 1085 692 1015 764 q 1156 499 1156 619 q 1085 306 1156 378 q 888 233 1015 233 q 734 265 810 233 q 613 365 658 297 q 491 265 567 297 q 338 233 415 233 m 361 378 q 446 407 403 378 q 522 499 489 436 q 446 590 489 561 q 361 619 403 619 q 270 589 304 619 q 236 499 236 558 q 270 408 236 439 q 361 378 304 378 m 864 378 q 955 408 921 378 q 989 499 989 439 q 955 589 989 558 q 864 619 921 619 q 779 590 822 619 q 703 499 736 561 q 779 407 736 436 q 864 378 822 378 z ',
    },
    '∫': {
      ha: 676,
      x_min: -114,
      x_max: 696,
      o:
        'm 21 -294 q -57 -287 -19 -294 q -114 -267 -94 -279 l -50 -128 q 29 -147 -8 -147 q 126 -60 108 -147 l 282 736 q 565 983 331 983 q 641 976 606 983 q 696 956 676 968 l 632 817 q 553 836 590 836 q 456 749 474 836 l 300 -47 q 204 -235 275 -176 q 21 -294 133 -294 z ',
    },
    '≈': {
      ha: 822,
      x_min: 60,
      x_max: 763,
      o:
        'm 553 189 q 476 200 511 189 q 399 233 442 211 q 333 262 360 253 q 275 271 306 271 q 149 200 204 271 l 60 296 q 144 405 86 360 q 269 450 201 450 q 346 439 311 450 q 424 406 381 428 q 490 377 463 386 q 547 368 517 368 q 674 439 618 368 l 763 343 q 678 234 736 279 q 553 189 621 189 m 553 476 q 476 488 511 476 q 399 521 442 499 q 333 549 360 540 q 275 558 306 558 q 149 488 204 558 l 60 583 q 144 692 86 647 q 269 738 201 738 q 346 726 311 738 q 424 693 381 715 q 490 665 463 674 q 547 656 517 656 q 674 726 618 656 l 763 631 q 678 522 736 567 q 553 476 621 476 z ',
    },
    '≠': {
      ha: 788,
      x_min: 90,
      x_max: 697,
      o:
        'm 154 160 l 194 231 l 90 231 l 90 381 l 279 381 l 336 481 l 90 481 l 90 631 l 421 631 l 503 774 l 633 701 l 593 631 l 697 631 l 697 481 l 508 481 l 451 381 l 697 381 l 697 231 l 367 231 l 285 88 l 154 160 z ',
    },
    '≤': {
      ha: 842,
      x_min: 90,
      x_max: 751,
      o:
        'm 149 478 l 149 639 l 692 922 l 692 740 l 342 558 l 692 376 l 692 194 l 149 478 m 90 150 l 751 150 l 751 0 l 90 0 l 90 150 z ',
    },
    '≥': {
      ha: 842,
      x_min: 90,
      x_max: 751,
      o:
        'm 150 376 l 500 558 l 150 740 l 150 922 l 693 639 l 693 478 l 150 194 l 150 376 m 90 150 l 751 150 l 751 0 l 90 0 l 90 150 z ',
    },
    '◊': {
      ha: 842,
      x_min: 85,
      x_max: 757,
      o:
        'm 85 486 l 338 972 l 504 972 l 757 486 l 504 0 l 338 0 l 85 486 m 585 486 l 421 825 l 257 486 l 421 147 l 585 486 z ',
    },
    '': {
      ha: 1100,
      x_min: 139,
      x_max: 961,
      o:
        'm 169 0 q 148 9 157 0 q 139 31 139 18 l 139 857 q 145 876 139 867 q 161 888 151 885 l 536 996 l 550 999 l 564 996 l 939 888 q 955 876 949 885 q 961 857 961 867 l 961 31 q 952 9 961 18 q 931 0 943 0 l 921 1 l 550 108 l 179 1 l 169 0 m 519 929 l 200 836 q 249 678 206 750 q 363 560 292 606 q 519 508 435 515 l 519 929 m 581 508 q 737 560 665 515 q 851 678 808 606 q 900 836 894 750 l 581 929 l 581 508 m 519 164 l 519 447 q 333 508 418 456 q 199 643 249 560 l 199 71 l 519 164 m 901 643 q 766 508 850 560 q 581 447 682 456 l 581 164 l 901 71 l 901 643 z ',
    },
    ﬁ: {
      ha: 754,
      x_min: 13,
      x_max: 682,
      o:
        'm 101 553 l 13 553 l 13 700 l 101 700 l 101 708 q 189 914 101 844 q 426 983 276 983 q 547 972 489 983 q 639 943 604 960 l 588 801 q 436 836 515 836 q 317 803 360 836 q 274 707 274 769 l 274 700 l 682 700 l 682 0 l 510 0 l 510 553 l 274 553 l 274 0 l 101 0 l 101 553 z ',
    },
    ﬂ: {
      ha: 779,
      x_min: 13,
      x_max: 682,
      o:
        'm 101 553 l 13 553 l 13 700 l 101 700 l 101 736 q 166 922 101 860 q 343 983 231 983 l 682 983 l 682 0 l 510 0 l 510 836 l 353 836 q 274 749 274 836 l 274 700 l 421 700 l 421 553 l 274 553 l 274 0 l 101 0 l 101 553 z ',
    },
  },
  familyName: 'Apercu Pro',
  ascender: 1094,
  descender: -294,
  underlinePosition: -179,
  underlineThickness: 86,
  boundingBox: { yMin: -411, xMin: -929, yMax: 1568, xMax: 1703 },
  resolution: 1000,

  cssFontWeight: 'bold',
  cssFontStyle: 'normal',
}
